// English
const en = {
  "lang.switch": "Language",

  "nav.marketplace": "Marketplace",
  "nav.coaches": "Coaches",
  "nav.login": "Sign in",
  "nav.signup": "Start for free",
  "nav.dashboard": "Dashboard",
  "nav.circles": "Circles",
  "nav.collab_packages": "Collab packages",
  "cp.cta_book": "Book a session",
  "cp.cta_signup": "Create an account to book",
  "nav.credits": "Credits",
  "nav.membership": "Membership",
  "nav.account": "Account",
  "nav.support": "Support",
  "nav.billing": "Billing",
  "home.meta_title": "Coaching & inner reflection",
  "home.meta_desc": "Find your coach, book sessions and grow your inner self with AI-guided self-reflection.",
  "home.hero_eyebrow": "Your space for inner growth",
  "home.hero_title": "Find calm, clarity and the right coach for your journey.",
  "home.hero_sub": "My Within connects real, verified coaches with gentle, AI-guided self-reflection — in a space that feels calm and safe.",
  "home.hero_cta_marketplace": "Explore offerings",
  "home.hero_cta_signup": "Start for free",
  "home.hero_free_hint": "100% free to sign up · no credit card required",
  "home.step1_title": "Find your coach",
  "home.step1_text": "Browse verified coaches and offerings — by topic, region and language.",
  "home.step2_title": "Work together",
  "home.step2_text": "Book sessions, connect and grow with real, human support.",
  "home.step3_title": "Reflect with AI",
  "home.step3_text": "WEVA & EVA support your inner work between sessions — anytime.",
  "home.offerings_title": "Featured offerings",
  "home.offerings_sub": "Fresh from our coaches' marketplace.",
  "home.see_all": "See all",
  "home.coaches_title": "Meet our coaches",
  "home.coaches_sub": "Verified, experienced and ready to support you.",
  "home.all_coaches": "All coaches",
  "home.cta_title": "Begin your inner work today.",
  "home.cta_sub": "Create an account in under a minute — free and risk-free.",
  "home.cta_btn": "Start free now",
  "announce.coach_call": "Start as a coach – book a free intro call",
  "announce.free_signup": "Or sign up free – in under a minute",
  "announce.founder": "Founder offer – one-time deal",
  "foot.tagline": "A calm place for inner work — guided by real coaches and AI-assisted reflection.",
  "foot.discover": "Discover",
  "foot.create_account": "Create account",
  "foot.legal": "Legal",
  "foot.privacy": "Privacy",
  "foot.terms": "Terms",
  "foot.built_in_austria": "Crafted with care in Austria",
  "oc.recommended": "Recommended",
  "oc.minutes": "{n} min",
  "oc.parts": "{n} parts",
  "nav.account_fallback": "Account",
  "nav.signout": "Sign out",

  "common.or": "OR",
  "common.loading": "Loading…",
  "common.active": "Active",
  "common.save": "Save",
  "common.cancel": "Cancel",

  "auth.email": "Email",
  "auth.password": "Password",
  "auth.email_placeholder": "you@example.com",
  "auth.quote": "“The path inward is the only one that truly leads forward.”",
  "auth.quote_attr": "My Within · your calm space",
  "auth.back_home": "← Back to home",
  "auth.google": "Continue with Google",
  "auth.apple": "Continue with Apple",
  "auth.apple_toast": "Apple sign-in will be enabled with the web launch on my-within.app.",

  "login.meta_title": "Sign in",
  "login.meta_desc": "Sign in to your My Within account.",
  "login.title": "Welcome back",
  "login.subtitle": "Sign in to continue your inner work.",
  "login.footer_q": "No account yet?",
  "login.footer_link": "Sign up now",
  "login.forgot": "Forgot?",
  "login.submit": "Sign in",
  "login.welcome_back": "Welcome back!",
  "login.failed": "Sign-in failed.",

  "signup.meta_title": "Sign up",
  "signup.meta_desc": "Create your free My Within account.",
  "signup.title": "Create account",
  "signup.subtitle": "Start for free — you decide when and with whom you work.",
  "signup.footer_q": "Already registered?",
  "signup.footer_link": "Sign in",
  "signup.role_client": "I'm looking for guidance",
  "signup.role_coach": "I'm a coach",
  "signup.name": "Name",
  "signup.name_placeholder": "Your name",
  "signup.password_placeholder": "At least 8 characters",
  "signup.consent_pre": "I accept the",
  "signup.terms": "Terms",
  "signup.consent_mid": "and",
  "signup.privacy": "Privacy Policy",
  "signup.consent_post": ", explicitly consent to the processing of my health data, and confirm that I am at least 16 years old.",
  "signup.consent_required": "Please confirm your consent to continue.",
  "signup.submit": "Sign up for free",
  "signup.created": "Account created — welcome to My Within!",
  "signup.failed": "Registration failed.",

  "dash.meta_title": "Dashboard",
  "dash.welcome": "Welcome back",
  "dash.hello_fallback": "Glad you're here",
  "dash.balance": "Your balance",
  "dash.credits": "Credits",
  "dash.topup": "Top up",
  "dash.membership": "Membership",
  "dash.upgrade": "Upgrade",
  "dash.manage": "Manage",
  "dash.next": "What's next",
  "dash.action_credits_title": "Top up credits",
  "dash.action_credits_text": "Buy credits for WEVA reports and content.",
  "dash.action_membership_title": "Membership",
  "dash.action_membership_text": "Unlock unlimited AI reflection.",
  "dash.action_marketplace_title": "Marketplace",
  "dash.action_marketplace_text": "Discover offers and courses from coaches.",
  "dash.action_coaches_title": "Coaches",
  "dash.action_coaches_text": "Find the right guidance for you.",

  "tier.free": "Free",
  "tier.plus": "Plus",
  "tier.plus_yearly": "Plus (yearly)",
  "tier.pro": "Pro",
  "tier.pro_yearly": "Pro (yearly)",
  "tier.unlimited": "Unlimited",
  "tier.unlimited_yearly": "Unlimited (yearly)",
  "tier.coach_pro": "Coach Pro",
  "tier.coach_pro_yearly": "Coach Pro (yearly)",

  "credits.meta_title": "Credits",
  "credits.title": "Top up credits",
  "credits.subtitle": "Credits unlock WEVA reports and exclusive content.",
  "credits.suffix": "Credits",
  "credits.popular": "Popular",
  "credits.incl_vat": "incl. VAT",
  "credits.per_credit": "/credit",
  "credits.buy": "Buy",
  "credits.secure": "Secure payment via Stripe. You'll be briefly redirected to Stripe for checkout and then brought back here.",
  "credits.payment_received": "Payment received — your credits will be added.",
  "credits.purchase_cancelled": "Purchase cancelled.",
  "credits.granted": "{n} credits added.",
  "credits.failed": "Purchase failed.",

  "account.meta_title": "Account",
  "account.title": "Account",
  "account.referral": "Your referral code",
  "account.billing": "Billing details",
  "account.billing_complete": "Complete",
  "account.billing_incomplete": "Incomplete",
  "account.devices": "Signed-in devices",
  "account.session": "Session {n}",
  "account.logged_in": "Signed in",
  "account.last_active": "Last active",
  "account.no_sessions": "No active sessions.",
  "account.logout": "Sign out",
  "account.logout_all": "End all sessions",
  "account.logout_all_done": "Signed out of all devices.",

  // Common (extended)
  "common.saving": "Saving…",
  "common.search": "Search…",
  "common.none_found": "Nothing found.",

  // Coach · Offerings / Products / Bundles
  "off.meta_title": "Coach · Offerings",
  "off.back": "Coach dashboard",
  "off.eyebrow": "Offerings",
  "off.title": "Offerings & products",
  "off.subtitle": "Manage sessions, packages, bundles and products.",
  "off.tab_offerings": "Offerings",
  "off.tab_products": "Products",
  "off.new": "New offering",
  "off.new_bundle": "Bundle",
  "off.hide_inactive": "Hide inactive",
  "off.empty_title": "No offerings yet",
  "off.empty_sub": "Create your first offering — e.g. a 1:1 session.",
  "off.inactive": "Inactive",
  "off.active": "Active",
  "off.standard": "Standard",
  "off.min": "min",
  "off.edit": "Edit",
  "off.delete": "Delete",
  "off.delete_confirm": "Really deactivate this offering?",
  "off.deleted": "Offering deactivated.",
  "off.saved": "Offering saved.",
  "off.save_failed": "Offering could not be saved.",
  "off.min_price": "Minimum price is €14.99.",
  "off.dialog_new": "New offering",
  "off.dialog_edit": "Edit offering",
  "off.f_type": "Type",
  "off.f_custom_label": "Custom label",
  "off.f_custom_ph": "e.g. Breathwork intensive",
  "off.f_title": "Title",
  "off.f_title_ph": "e.g. 90-min deep dive",
  "off.f_desc": "Description",
  "off.f_desc_ph": "What the client gets…",
  "off.f_duration": "Duration (min)",
  "off.f_price": "Price (EUR)",
  "off.f_modality": "Format",
  "off.f_online": "Online (Zoom)",
  "off.f_inperson": "In person",
  "off.f_location": "Location",
  "off.f_location_note": "Location note (optional)",
  "off.f_location_online_ph": "Zoom (auto-generated link)",
  "off.f_location_ph": "Vienna, AT · Studio address",
  "off.online_hint": "We'll auto-create a Zoom link once your Zoom account is connected.",
  "off.f_start": "Start (ISO)",
  "off.f_start_ph": "2026-09-14T10:00",
  "off.f_end": "End (retreat, ISO)",
  "off.f_end_ph": "2026-09-17T18:00",
  "off.f_capacity": "Capacity",
  "off.f_sessions": "Number of sessions",
  "off.cover": "Cover image (optional)",
  "off.cover_hint": "A warm 16:9 image shown at the top of the booking screen.",
  "off.cover_library": "Pick from library",
  "off.cover_hide": "Close library",
  "off.cover_remove": "Remove",
  "off.toggle_standard": "Mark as standard session",
  "off.toggle_standard_hint": "Opens when clients tap “Book a session”.",
  "off.toggle_weekly": "Bookable in weekly calendar",
  "off.toggle_weekly_hint": "This offering appears when clients pick a slot.",
  "off.commission_hint": "Platform fee: 10% (Free) · 5% (Coach Pro).",
  "off.bundle_title": "Create bundle",
  "off.bundle_pick": "Select offerings (min. 2)",
  "off.bundle_discount": "Discount (%)",
  "off.bundle_total": "Total single prices",
  "off.bundle_effective": "Bundle price",
  "off.bundle_savings": "Savings",
  "off.bundle_none": "No combinable offerings. Create 2 regular offerings first.",
  "off.bundle_need2": "Please select at least 2 offerings.",
  "off.bundle_saved": "Bundle created.",
  "off.p_new": "New product",
  "off.p_empty_title": "No products yet",
  "off.p_empty_sub": "Products are simple sessions paid with credits or Stripe.",
  "off.p_dialog_new": "New product",
  "off.p_dialog_edit": "Edit product",
  "off.p_name": "Name",
  "off.p_name_ph": "e.g. Intro call",
  "off.p_desc": "Description",
  "off.p_duration": "Duration (min)",
  "off.p_capacity": "Capacity",
  "off.p_group": "Group session",
  "off.p_payment": "Payment",
  "off.p_accept_credits": "Accept credits",
  "off.p_price_credits": "Price (credits)",
  "off.p_accept_stripe": "Accept Stripe",
  "off.p_price_eur": "Price (EUR)",
  "off.p_saved": "Product saved.",
  "off.p_deleted": "Product deleted.",
  "off.p_delete_confirm": "Really delete this product?",
  "off.p_payment_required": "Please select at least one payment method.",
  "off.p_name_required": "Please enter a name.",
  "off.type.one_on_one": "1:1 session",
  "off.type.group_online": "Group course (online)",
  "off.type.group_inperson": "Group course (in person)",
  "off.type.retreat": "Retreat",
  "off.type.workshop": "Workshop",
  "off.type.package": "Package",
  "off.type.custom": "Custom…",

  // Nav (extended)
  "nav.notifications": "Notifications",
  "nav.inner": "Inner Circle",
  "nav.mein_kreis": "My Circle",
  "nav.pulse": "Client pulse",
  "nav.offerings": "Offerings",
  "nav.bookings": "Bookings",
  "nav.earnings": "Earnings",
  "nav.availability": "Availability",
  "nav.analytics": "Analytics",
  "nav.collab": "Collaboration",
  "nav.content": "Social",
  "nav.profile": "Profile & brand",
  "nav.verify": "Verification",
  "nav.admin": "Admin",
  "nav.group.start": "Start",
  "nav.group.circles": "Circles",
  "nav.group.sell": "Sell",
  "nav.group.grow": "Grow",
  "nav.group.account": "Account",
  "nav.group.admin": "Admin",
  "nav.experience.journey": "My Journey",
  "nav.experience.practice": "My Practice",
  "nav.group.home": "Home",
  "nav.group.explore": "Explore",
  "nav.group.breathe": "Breathe",
  "nav.group.weva": "WEVA",
  "nav.group.connect": "Connect",
  "nav.group.my_space": "My Space",
  "nav.group.overview": "Overview",
  "nav.group.clients": "Clients",
  "nav.group.schedule": "Schedule & Plans",
  "nav.group.create": "Create & Offer",
  "nav.group.community": "Community",
  "nav.group.business": "Business",
  "nav.group.settings": "Settings",
  "nav.practices": "Practices",
  "nav.collectives": "Collectives",
  "nav.referral": "Referrals",
  "nav.client_wins": "Client Wins",
  "home.welcome_back": "Welcome back.",
  "home.welcome_q": "What would feel right for you today?",
  "home.action_breathe_title": "Breathe",
  "home.action_breathe_sub": "Find calm in the moment",
  "home.action_reflect_title": "Reflect",
  "home.action_reflect_sub": "Explore your thoughts & feelings",
  "home.action_weva_title": "Explore with WEVA",
  "home.action_weva_sub": "Talk it through with your companion",
  "home.continue_title": "Continue your journey",
  "home.continue_empty": "Your next steps will appear here as you explore.",
  "home.plan_pending": "Weekly plan waiting",
  "home.plan_cta": "View plan",
  "home.report_latest": "Latest WEVA report",
  "home.reflections_title": "Your reflections",
  "home.stat_journal": "Journal entries",
  "home.stat_reports": "WEVA reports",
  "home.stat_practices": "Practices done",
  "home.stat_areas": "Areas explored",
  "home.more_title": "More to explore",
  "home.open": "Open",

  // Coach · Profile & Branding
  "prof.meta_title": "Coach · Profile",
  "prof.back": "Coach dashboard",
  "prof.eyebrow": "Profile",
  "prof.title": "Profile & brand",
  "prof.subtitle": "Your public coach profile and brand.",
  "prof.tab_profile": "Profile",
  "prof.tab_branding": "Brand",
  "prof.photo": "Profile photo",
  "prof.photo_hint": "Profile and cover image (max 2.5 MB). Square recommended for the photo.",
  "prof.header": "Cover image",
  "prof.upload": "Upload",
  "prof.remove": "Remove",
  "prof.too_large": "Image too large (max 2.5 MB).",
  "prof.name": "Name",
  "prof.bio": "About you",
  "prof.bio_ph": "Tell clients how you work…",
  "prof.professions": "Profession(s)",
  "prof.professions_hint": "Pick up to 5 from the list.",
  "prof.professions_ph": "Add profession…",
  "prof.topics": "Topics",
  "prof.topics_hint": "Pick relevant topics.",
  "prof.topics_ph": "Add topic…",
  "prof.methods": "Methods",
  "prof.methods_hint": "Pick your methods / modalities.",
  "prof.methods_ph": "Add method…",
  "prof.location": "Location",
  "prof.location_ph": "Vienna, Austria",
  "prof.website": "Website",
  "prof.website_ph": "https://…",
  "prof.languages": "Languages",
  "prof.languages_hint": "Comma-separated, e.g. German, English.",
  "prof.experience": "Years of experience",
  "prof.audience": "Target audience",
  "prof.audience_ph": "Who do you serve?",
  "prof.visibility_public": "Publicly visible",
  "prof.visibility_hint": "Your profile appears in the marketplace and coach directory.",
  "prof.saved": "Profile saved.",
  "prof.save_failed": "Profile could not be saved.",
  "prof.view_public": "View public profile",

  // Coach · Brand
  "brand.subtitle": "Logo, brand color and footer for client emails & your profile.",
  "brand.locked_title": "Brand is a Coach Pro feature",
  "brand.locked_sub": "Upgrade to Coach Pro to set a logo, color and footer.",
  "brand.upgrade": "Upgrade to Coach Pro",
  "brand.logo": "Logo URL",
  "brand.logo_ph": "https://… (PNG/SVG)",
  "brand.color": "Brand color",
  "brand.footer": "Footer text",
  "brand.footer_ph": "e.g. “Guided with heart by …” (max 200 chars)",
  "brand.saved": "Brand saved.",
  "brand.reset": "Reset",
  "brand.reset_done": "Reset to defaults.",

  // Coach · Verification
  "verify.meta_title": "Coach · Verification",
  "verify.eyebrow": "Verification",
  "verify.title": "Verify your qualification",
  "verify.subtitle": "Upload your certificate to unlock all coach features.",
  "verify.status": "Current status",
  "verify.status_approved": "Verified",
  "verify.status_pending_ai": "AI review in progress",
  "verify.status_pending_admin": "Under review",
  "verify.status_rejected": "Rejected",
  "verify.status_unverified": "Not verified",
  "verify.approved_title": "You're verified 🎉",
  "verify.approved_sub": "All coach features are unlocked — circles, offerings, bookings.",
  "verify.reviewer_title": "Reviewer access active",
  "verify.reviewer_sub": "This account bypasses verification for reviews.",
  "verify.step_dpa_title": "Accept the Joint-Controller Agreement",
  "verify.step_dpa_sub": "Data-protection agreement for joint controllers.",
  "verify.dpa_accept": "I accept the Joint-Controller Agreement.",
  "verify.dpa_accepted": "Agreement accepted.",
  "verify.accept_btn": "Accept",
  "verify.step_upload_title": "Upload certificate",
  "verify.step_upload_sub": "Photo/scan of your certificate (PNG/JPEG, max 4 MB).",
  "verify.upload_btn": "Upload certificate",
  "verify.reupload_btn": "Re-upload",
  "verify.uploading": "Uploading…",
  "verify.upload_failed": "Upload failed.",
  "verify.too_large": "Image too large (max 4 MB).",
  "verify.pending_admin_title": "Forwarded to review",
  "verify.pending_admin_sub": "A human is reviewing your certificate. You'll be notified once approved.",
  "verify.rejected_title": "Verification rejected",
  "verify.rejected_sub": "Please upload a clearer certificate.",
  "verify.ai_verdict": "AI assessment",
  "verify.ai_subject": "Subject area",
  "verify.ai_confidence": "Confidence",

  // Notifications
  "notif.meta_title": "Notifications",
  "notif.title": "Notifications",
  "notif.subtitle": "Updates about bookings, circles and your account.",
  "notif.empty_title": "No notifications",
  "notif.empty_sub": "New updates will appear here.",
  "notif.mark_all": "Mark all read",
  "notif.marked_all": "All marked as read.",

  // Common (Phase 4c)
  "common.refresh": "Refresh",

  // Coach · Social & Content (Phase 4c)
  "soc.meta_title": "Coach · Social",
  "soc.back": "Coach dashboard",
  "soc.eyebrow": "Social",
  "soc.title": "Social & Content",
  "soc.subtitle": "Posts, stories, story wall, messages and WEVA — all in one place.",
  "soc.tab_posts": "Posts",
  "soc.tab_stories": "Stories",
  "soc.tab_wall": "Story wall",
  "soc.tab_impact": "Impact",
  "soc.tab_messages": "Messages",
  "soc.tab_weva": "WEVA",

  "soc.posts_new": "New post",
  "soc.posts_stat_posts": "Posts",
  "soc.posts_stat_unlocks": "Unlocks",
  "soc.posts_stat_credits": "Credits earned",
  "soc.posts_stat_reports": "Reports",
  "soc.posts_empty_title": "No posts yet",
  "soc.posts_empty_sub": "Create your first post for the feed.",
  "soc.posts_unlocks": "{n} unlocks",
  "soc.posts_credits": "{n} credits",
  "soc.posts_hidden": "Hidden",
  "soc.posts_dialog_title": "New post",
  "soc.posts_f_title": "Title",
  "soc.posts_f_title_ph": "Post title",
  "soc.posts_f_body": "Text",
  "soc.posts_f_body_ph": "Share an impulse, a reflection or an exercise…",
  "soc.posts_paid": "Paid content",
  "soc.posts_paid_sub": "Clients pay credits to unlock.",
  "soc.posts_price": "Price (credits)",
  "soc.posts_price_ph": "e.g. 10",
  "soc.posts_publish": "Publish",
  "soc.posts_publishing": "Publishing…",
  "soc.posts_created": "Post published.",
  "soc.posts_title_required": "Please enter a title.",
  "soc.posts_price_required": "Paid content needs at least 1 credit.",
  "soc.posts_create_failed": "Post could not be created.",

  "soc.stories_new": "New story",
  "soc.stories_sub": "24-hour stories and permanent highlights.",
  "soc.stories_empty_title": "No stories yet",
  "soc.stories_empty_sub": "Share a short 24-hour story with your clients.",
  "soc.stories_kind_image": "Image",
  "soc.stories_kind_text": "Text",
  "soc.stories_pick": "Pick image",
  "soc.stories_replace": "Replace image",
  "soc.stories_pick_hint": "Pick an image (max. 10 MB).",
  "soc.stories_text_ph": "What would you like to share?",
  "soc.stories_ttl_hint": "Stories disappear automatically after 24 hours.",
  "soc.stories_dialog_title": "New story",
  "soc.stories_publish": "Share",
  "soc.stories_publishing": "Sharing…",
  "soc.stories_created": "Story shared.",
  "soc.stories_too_large": "Image too large (max. 10 MB).",
  "soc.stories_uploading": "Uploading…",
  "soc.stories_upload_failed": "Image could not be uploaded.",
  "soc.stories_need_content": "Please pick an image or enter text.",
  "soc.stories_create_failed": "Story could not be created.",
  "soc.stories_status_active": "Active",
  "soc.stories_status_expired": "Expired",
  "soc.stories_highlight_badge": "Highlight",
  "soc.stories_views": "{n} views",
  "soc.stories_pin": "Pin",
  "soc.stories_unpin": "Unpin",
  "soc.stories_delete_confirm": "Really delete this story?",
  "soc.stories_deleted": "Story deleted.",
  "soc.stories_pinned": "Pinned as highlight.",
  "soc.stories_unpinned": "Highlight removed.",
  "soc.stories_pin_title": "Pin as highlight",
  "soc.stories_pin_sub": "Give the highlight a short title (optional).",
  "soc.stories_pin_ph": "e.g. Testimonials",
  "soc.stories_pin_save": "Pin",

  "soc.wall_new": "New moment",
  "soc.wall_sub": "Share client moments publicly with double consent.",
  "soc.wall_empty_title": "No moments yet",
  "soc.wall_empty_sub": "Capture a special milestone — with the client's consent.",
  "soc.wall_create_title": "Create moment",
  "soc.wall_client": "Client",
  "soc.wall_kind": "Kind",
  "soc.wall_title_lbl": "Title",
  "soc.wall_title_ph": "Short, powerful title",
  "soc.wall_body_lbl": "Text",
  "soc.wall_body_ph": "What happened? Describe the moment…",
  "soc.wall_metric_lbl": "Metric (optional)",
  "soc.wall_metric_ph": "e.g. −40% stress",
  "soc.wall_color_lbl": "Color",
  "soc.wall_consent_note": "Publishing requires your AND the client's consent.",
  "soc.wall_missing_fields": "Please fill in client, title and text.",
  "soc.wall_save": "Save moment",
  "soc.wall_saved": "Moment created.",
  "soc.wall_kind_reflection": "Reflection",
  "soc.wall_kind_wellbeing_shift": "Wellbeing",
  "soc.wall_kind_streak": "Streak",
  "soc.wall_kind_quote": "Quote",
  "soc.wall_kind_milestone": "Milestone",
  "soc.wall_status_draft": "Draft",
  "soc.wall_status_published": "Published",
  "soc.wall_status_unlisted": "Unlisted",
  "soc.wall_coach_consent": "Your consent",
  "soc.wall_client_consent": "Client consent",
  "soc.wall_consent_granted": "Granted",
  "soc.wall_consent_pending": "Pending",
  "soc.wall_consent_waiting_client": "Waiting for client",
  "soc.wall_review_agree": "Review & agree",
  "soc.wall_review": "View consent",
  "soc.wall_coach_consent_title": "Your consent",
  "soc.wall_coach_consent_body": "With your consent this moment may be shared publicly once the client also agrees.",
  "soc.wall_show_name": "Show my name",
  "soc.wall_show_name_sub": "Your name appears on the published moment.",
  "soc.wall_consent_grant": "Agree",
  "soc.wall_consent_revoke": "Withdraw",
  "soc.wall_publish": "Publish",
  "soc.wall_unpublish": "Unpublish",
  "soc.wall_archive": "Archive",
  "soc.wall_archive_confirm": "Really archive this moment?",
  "soc.wall_published_ok": "Moment published.",
  "soc.wall_publish_needs_consents": "Both consents are required to publish.",

  "soc.impact_sub": "How many people your wins move.",
  "soc.impact_empty_title": "No story moments yet",
  "soc.impact_empty_sub": "Once you publish client wins, you'll see views, shares and trends here.",
  "soc.impact_overall": "Overall summary",
  "soc.impact_views": "Views",
  "soc.impact_shares": "Shares",
  "soc.impact_previews": "Preview opens",
  "soc.impact_engagement": "Engagement",
  "soc.impact_engagement_hint": "Views ÷ preview opens",
  "soc.impact_share_rate": "Share rate",
  "soc.impact_share_hint": "Shares ÷ views",
  "soc.impact_trend": "Last 7 days trend",
  "soc.impact_views_7d": "Views last 7 days",
  "soc.impact_vs_prev": "vs. previous",
  "soc.impact_ranking": "Impact ranking per moment",

  "soc.msg_sub": "Direct messages and shared chats.",
  "soc.msg_shared": "Shared chats",
  "soc.msg_dms": "Direct messages",
  "soc.msg_empty": "No messages yet. Clients and coaches will appear here.",
  "soc.msg_three_way": "Joint care",
  "soc.msg_input_ph": "Write a message…",
  "soc.msg_empty_thread": "No messages yet. Write the first one 👋",
  "soc.msg_deleted": "Message deleted",
  "soc.msg_delete_confirm": "Delete this message?",

  "soc.weva_sub": "Anonymised patterns from your inner circle — with coaching prompts.",
  "soc.weva_trends_title": "Anonymised circle trends",
  "soc.weva_trends_clients": "{a} of {t} active · {d} days",
  "soc.weva_trends_emotions": "Top emotions",
  "soc.weva_trends_themes": "Top themes",
  "soc.weva_trends_beliefs": "Top beliefs",
  "soc.weva_trends_practices": "Top practices",
  "soc.weva_intro": "Ask me about patterns in your inner circle — emotions, themes, practices — and I'll offer coaching prompts.",
  "soc.weva_placeholder": "Ask WEVA something…",
  "soc.weva_thinking": "WEVA is thinking…",
  "soc.weva_clear": "Clear history",
  "soc.weva_clear_confirm": "Clear the entire WEVA history?",
  "soc.weva_locked_title": "WEVA coach chat is a Coach Pro feature",
  "soc.weva_locked_sub": "Upgrade to Coach Pro to use WEVA for anonymised circle insights.",
  "soc.weva_upgrade": "Upgrade to Coach Pro",
  "soc.weva_send_failed": "Message could not be sent.",

  // Common (Phase 4d)
  "common.close": "Close",
  "nav.methods": "Methods",
  "nav.plans": "Plans",

  // Coach · Methods & Templates (Phase 4d)
  "cm.meta_title": "Coach · Methods",
  "cm.back": "Coach dashboard",
  "cm.eyebrow": "Methods",
  "cm.title": "Methods & Templates",
  "cm.subtitle": "Build your own exercises, manage them, save as templates and see their impact.",
  "cm.tab_methods": "Methods",
  "cm.tab_templates": "Templates",
  "cm.tab_breathwork": "Breathwork",
  "cm.tab_stats": "Statistics",
  "cm.tab_social": "Shared in feed",
  "cm.social_title": "Methods in your social feed",
  "cm.social_sub": "Shared methods (free or paid) appear as posts in your feed — including views and purchases.",
  "cm.social_cta": "Go to my feed posts",

  "cm.new_method": "New method",
  "cm.filter_all": "All",
  "cm.filter_shared": "Shared",
  "cm.filter_template": "Templates",
  "cm.no_methods_title": "No methods yet",
  "cm.no_methods_sub": "Start with an audio meditation or a question set.",
  "cm.no_templates": "No templates yet",
  "cm.create_first": "Create your first method",
  "cm.edit": "Edit",
  "cm.tpl": "Template",
  "cm.duplicated": "Method duplicated.",
  "cm.deleted": "Method deleted.",
  "cm.delete_confirm": "Really delete method \"{title}\"?",

  "cm.kind_audio": "Audio meditation",
  "cm.kind_audio_sub": "Guided voice/music session.",
  "cm.kind_video": "Video guide",
  "cm.kind_video_sub": "Short video with you as coach.",
  "cm.kind_breathwork": "Breathwork",
  "cm.kind_breathwork_sub": "Reference your own breathing technique.",
  "cm.kind_questions": "Question set",
  "cm.kind_questions_sub": "Reflection questions, free answers.",
  "cm.kind_combo": "Combo method",
  "cm.kind_combo_sub": "Several building blocks in sequence.",
  "cm.kind_body_scan": "Body scan",
  "cm.kind_body_scan_sub": "Guide attention through the body.",
  "cm.kind_gratitude": "Gratitude",
  "cm.kind_gratitude_sub": "3 things · heart focus.",
  "cm.kind_visualization": "Visualization",
  "cm.kind_visualization_sub": "Inner imagery & future journey.",
  "cm.kind_movement": "Movement",
  "cm.kind_movement_sub": "Yoga · somatic · shaking.",
  "cm.kind_check_in": "Check-in",
  "cm.kind_check_in_sub": "Daily pulse · emotion & need.",

  "cm.vis_private": "Private",
  "cm.vis_shared_with_clients": "Clients",
  "cm.vis_public": "Public",

  "cm.pick_title": "Create method",
  "cm.pick_hint": "Pick the type of your new method.",
  "cm.editing": "Edit method",
  "cm.change_kind": "Change type",
  "cm.save_new": "Save method",
  "cm.saved": "Method saved.",
  "cm.save_failed": "Method could not be saved.",
  "cm.load_failed": "Method could not be loaded.",
  "cm.title_required": "Please enter a title.",
  "cm.cover": "Cover image (optional)",
  "cm.f_title": "Title",
  "cm.title_ph": "Short & clear (max. 140 chars)",
  "cm.f_subtitle": "Subtitle (optional)",
  "cm.subtitle_ph": "e.g. \"Arrive & let go\"",
  "cm.description": "Description",
  "cm.description_ph": "What is this method for?",
  "cm.suggest_titles": "AI suggestions",
  "cm.ai_no_titles": "No suggestions found. Write a more detailed description.",
  "cm.ai_locked": "AI title suggestions are a Coach Pro feature.",
  "cm.audio_field": "Audio",
  "cm.video_field": "Video",
  "cm.pick_technique": "Your own breathwork technique",
  "cm.no_bw_yet": "First create your own breathwork exercise in the mobile app.",
  "cm.questions": "Questions",
  "cm.no_questions": "No questions yet. Add the first one.",
  "cm.q_required": "Required",
  "cm.q_prompt_ph": "Question, e.g. \"How do you feel right now?\"",
  "cm.q_add": "Add question",
  "cm.steps": "Building blocks (order)",
  "cm.steps_empty": "No block yet. Add e.g. body scan + breathwork + gratitude.",
  "cm.step_title_ph": "Block title, e.g. \"3 minutes body scan\"",
  "cm.step_body_ph": "Instruction text…",
  "cm.step_duration_ph": "Duration (seconds)",
  "cm.step_breathwork": "Breath",
  "cm.step_audio": "Audio",
  "cm.step_video": "Video",
  "cm.step_body_scan": "Body",
  "cm.step_gratitude": "Thanks",
  "cm.step_visualization": "Vision",
  "cm.step_movement": "Movement",
  "cm.step_questions": "Questions",
  "cm.step_check_in": "Check-in",
  "cm.step_timer": "Timer",
  "cm.step_text": "Text",
  "cm.settings": "Settings",
  "cm.duration_min": "Duration (min)",
  "cm.preview_seconds": "Preview (sec)",
  "cm.visibility": "Visibility",
  "cm.price": "Price (credits)",
  "cm.is_template": "As template",
  "cm.tpl_on": "Template active",
  "cm.tpl_off": "Save as template",
  "cm.ethics_title": "Coaching, not a therapy substitute",
  "cm.ethics_body": "Frame your method as a coaching offer. It does not replace medical diagnosis or psychotherapy. For trauma, suicidal thoughts or acute symptoms, refer to a professional.",

  "cm.media_url_ph": "Paste a URL or upload a file",
  "cm.media_upload": "Upload",
  "cm.media_uploading": "Uploading…",
  "cm.media_uploaded": "File uploaded.",
  "cm.media_upload_failed": "File could not be uploaded.",

  "cm.preview_lbl": "Preview",
  "cm.preview_running": "Clients hear/see exactly this snippet before buying.",
  "cm.preview_done": "Preview finished.",

  "cm.stats_methods": "Methods",
  "cm.stats_opens": "Opens",
  "cm.stats_completions": "Completions",
  "cm.stats_rate": "Rate",
  "cm.stats_top_completed": "Top performers",
  "cm.stats_top_opened": "Most opened",
  "cm.stats_empty": "No data yet. Once clients use your methods, your top performers show here.",

  "cm.templates_sub": "Signature techniques you can reuse with new clients. Copy one to adapt it.",
  "cm.no_templates_long": "No templates yet. Open a method and enable the template switch when saving.",
  "cm.tpl_use": "Use",
  "cm.tpl_copied": "Template copied — now edit the copy.",
  "cm.tpl_done": "{n}× completed",

  // Coach · Plans (Phase 4d part 2)
  "pl.meta_title": "Coach · Plans",
  "pl.back": "Coach dashboard",
  "pl.eyebrow": "Plans",
  "pl.title": "Plans",
  "pl.subtitle": "Assign daily plans to clients and share weekly breathwork plans.",
  "pl.tab_daily": "Daily plans",
  "pl.tab_weekly": "Weekly plans",

  "pl.d_sub": "Assign clients tasks with date, time and technique.",
  "pl.d_new": "Assign plan",
  "pl.d_empty_title": "No plans assigned yet",
  "pl.d_empty_sub": "Assign a task to your first client.",
  "pl.d_done": "Done",
  "pl.d_pending": "Pending",
  "pl.d_missing": "Please pick a title and at least one client.",
  "pl.d_assigned": "Plan assigned to {n} client(s).",
  "pl.d_title_ph": "Title, e.g. Evening breathing",
  "pl.d_desc_ph": "Description (optional)",
  "pl.d_date": "Date",
  "pl.d_time": "Time",
  "pl.d_reminder": "Reminder (min)",
  "pl.d_technique": "Breathing technique (optional)",
  "pl.d_clients": "Clients",
  "pl.d_no_clients": "No eligible clients. Add someone to a circle first.",

  "pl.w_mobile_note": "You create and edit weekly plans in the mobile app. Here you see your plans and share them with clients or circles.",
  "pl.w_my_master": "My master plans",
  "pl.w_no_plans": "No weekly plans yet. Create your first one right here.",
  "pl.w_slots": "{n} blocks",
  "pl.w_flexible": "flexible",
  "pl.w_send": "Send",
  "pl.w_sent": "Sent to clients",
  "pl.w_sent_hint": "Shared plans appear here with their status.",
  "pl.w_to_client": "To client",
  "pl.w_share_target": "Share plan",
  "pl.w_tab_single": "Single",
  "pl.w_tab_multi": "Multiple",
  "pl.w_tab_circle": "Circle",
  "pl.w_no_clients": "No clients.",
  "pl.w_no_circles": "No circles.",
  "pl.w_select_all": "All",
  "pl.w_deselect_all": "None",
  "pl.w_circle_members": "{n} members",
  "pl.w_overwrite": "Overwrite existing plans",
  "pl.w_msg_ph": "Optional message…",
  "pl.w_send_plan": "Send plan",
  "pl.w_sending": "Sending…",
  "pl.w_sent_ok": "Plan sent.",
  "pl.w_multi_summary": "Sent: {ok} · Failed: {fail}",
  "pl.w_circle_summary": "Sent: {sent} · Skipped: {skipped} · Updated: {updated}",
  "pl.w_web_note": "Create and edit weekly plans right here. Copies already sent to clients stay unchanged.",
  "pl.w_new": "New weekly plan",
  "pl.w_create_plan": "Create plan",
  "pl.w_editor_new": "Create weekly plan",
  "pl.w_editor_edit": "Edit weekly plan",
  "pl.w_editor_sub": "Name the plan, pick the week start and add blocks per day.",
  "pl.w_default_name": "My weekly practice",
  "pl.w_name": "Name",
  "pl.w_name_ph": "e.g. My weekly practice",
  "pl.w_desc": "Description",
  "pl.w_desc_ph": "Optional",
  "pl.w_week_start": "Week start (Mon)",
  "pl.w_slots_lbl": "Blocks",
  "pl.w_add_slot": "Block",
  "pl.w_no_slots": "No block yet. Add exercises for the week.",
  "pl.w_slot_day": "Day",
  "pl.w_slot_time": "Time",
  "pl.w_slot_duration": "Duration (min)",
  "pl.w_slot_category": "Category",
  "pl.w_slot_technique": "Exercise",
  "pl.w_slot_reminder": "Reminder",
  "pl.w_slot_note": "Note (optional)",
  "pl.w_slot_save": "Save block",
  "pl.w_cat_breathing": "Breathing",
  "pl.w_cat_deep_within": "Deep Within",
  "pl.w_cat_rdr": "RDR",
  "pl.w_cat_custom": "My breathwork",
  "pl.w_cat_coach_method": "My methods",
  "pl.w_days": "Mon,Tue,Wed,Thu,Fri,Sat,Sun",
  "pl.w_rem_start": "At start",
  "pl.w_rem_min": "{n} min before",
  "pl.w_rem_hour": "1 hour before",
  "pl.w_need_name": "Please enter a name.",
  "pl.w_need_slots": "Add at least one block.",
  "pl.w_need_tech": "Please pick an exercise.",
  "pl.w_created": "Weekly plan created.",
  "pl.w_updated": "Weekly plan updated.",
  "pl.w_save_failed": "Weekly plan could not be saved.",
  "pl.w_delete_confirm": "Delete weekly plan \"{name}\"?",
  "pl.w_deleted": "Weekly plan deleted.",
  "pl.w_no_custom": "No own breathwork exercise yet. Create one in the Methods tab.",
  "pl.w_no_methods": "No methods yet.",

  // Coach · Breathwork techniques (improvement)
  "bw.new": "New exercise",
  "bw.edit_existing": "Edit exercise",
  "bw.name": "Exercise name",
  "bw.name_ph": "e.g. Box breath 4-4-4-4",
  "bw.rhythm": "Rhythm (seconds)",
  "bw.inhale": "In",
  "bw.hold_in": "Hold",
  "bw.exhale": "Out",
  "bw.hold_out": "Hold",
  "bw.length": "Length",
  "bw.by_reps": "Repetitions",
  "bw.by_duration": "Total duration",
  "bw.reps": "Rounds",
  "bw.duration_s": "Seconds",
  "bw.estimated": "Estimated",
  "bw.cycle": "Cycle",
  "bw.notes": "Note for client (optional)",
  "bw.notes_ph": "e.g. In the evening before sleep",
  "bw.save_new": "Save exercise",
  "bw.saved": "Exercise saved.",
  "bw.save_failed": "Exercise could not be saved.",
  "bw.delete_confirm": "Delete exercise \"{name}\"?",
  "bw.deleted": "Exercise deleted.",
  "bw.saved_list": "Your exercises",
  "bw.empty": "No custom exercise saved yet.",

  // Nav (Phase 4e)
  "nav.ads": "Ads",
  "nav.recommendations": "Recommendations",

  // ── Analytics Deep-dive (Phase 4e · e1) ──
  "an.back": "Coach dashboard",
  "an.eyebrow": "Analytics",
  "an.title": "Analytics deep-dive",
  "an.subtitle": "12 tiles: growth, sessions, WEVA, content, revenue, comparisons & reports.",
  "an.period_week": "Week",
  "an.period_month": "Month",
  "an.period_quarter": "Quarter",
  "an.period_year": "Year",
  "an.period_all": "All",
  "an.period_sync": "The period applies to every time-based tile.",
  "an.pro_locked_title": "Coach Pro unlocks the full depth",
  "an.pro_locked_sub": "Revenue, retention analytics and reports are part of Coach Pro.",
  "an.pro_upgrade": "Upgrade to Coach Pro",
  "an.insights_kicker": "Top movement",
  "an.insights_vs_prev": "vs. last week",
  "an.insights_tap": "View top 3 changes",
  "an.insights_modal_title": "Your top changes",
  "an.insights_modal_sub": "The biggest moves versus last week.",
  "an.insights_empty": "Not enough data to compare yet.",
  "an.tip_button": "What does this show me?",
  "an.tip_loading": "WEVA is reading the numbers…",
  "an.tip_error": "Couldn't load an explanation right now.",
  "an.tip_source": "AI explanation based on your data",
  "an.t1": "Profile at a glance",
  "an.t2": "Client growth",
  "an.t3": "Sessions & bookings",
  "an.t4": "WEVA group analysis",
  "an.t5": "Weekly plans performance",
  "an.t6": "Content performance",
  "an.t7": "Inner vs. Local Circle",
  "an.t8": "Affiliate performance",
  "an.t9": "Engagement & communication",
  "an.t10": "Client goals",
  "an.t11": "Period comparison",
  "an.t12": "Reports & export",
  "an.t1_clients": "Clients total",
  "an.t1_ic": "Inner",
  "an.t1_lc": "Local",
  "an.t1_general": "General",
  "an.t1_sessions": "Sessions completed",
  "an.t1_offerings": "Active offerings",
  "an.t1_gross": "Gross revenue",
  "an.t1_since": "Member since",
  "an.t2_new": "New",
  "an.t2_churn": "Churn",
  "an.t2_net": "Net",
  "an.t2_cumulative": "Cumulative",
  "an.t3_total": "Bookings",
  "an.t3_completed": "Completed",
  "an.t3_cancelled": "Cancelled",
  "an.t3_cancel_rate": "Cancel rate",
  "an.t3_avg_dur": "Avg duration",
  "an.t3_util": "Utilisation",
  "an.t3_hours": "Popular hours",
  "an.t3_weekdays": "Popular weekdays",
  "an.t4_empty": "No WEVA data from your clients yet.",
  "an.t4_client_count": "Clients",
  "an.t4_reports": "Reports",
  "an.t4_emotions": "Top emotions",
  "an.t4_emo_drop": "Emotion resolution · last 90 days",
  "an.t4_emo_drop_hint": "Based on {n} sessions · ≥2 per emotion",
  "an.t4_themes": "Themes",
  "an.t4_trend": "Intensity trend",
  "an.t4_before": "Before",
  "an.t4_after": "After",
  "an.t5_empty": "No weekly plans sent yet.",
  "an.t5_sent": "Sent",
  "an.t5_open_rate": "Open rate",
  "an.t5_completion": "Completion rate",
  "an.t5_sessions_done": "Sessions done",
  "an.t5_top_tech": "Top techniques",
  "an.t6_empty": "No content published yet.",
  "an.t6_posts": "Posts",
  "an.t6_views": "Views",
  "an.t6_favorites": "Favorites",
  "an.t6_revenue": "Revenue",
  "an.t6_top": "Top content",
  "an.t7_empty": "No circle data yet.",
  "an.t7_ic": "Inner Circle",
  "an.t7_lc": "Local Circle",
  "an.t7_members": "Members",
  "an.t7_revenue": "Revenue",
  "an.t7_messages": "Messages",
  "an.t7_snapshots": "Deliveries",
  "an.t8_empty": "No referrals via your code yet.",
  "an.t8_referrals": "Referrals",
  "an.t8_conversion": "Conversion",
  "an.t8_revenue": "Revenue",
  "an.t8_active_phases": "Active phases",
  "an.t8_phase_break": "Phase breakdown",
  "an.t9_msgs": "Messages sent",
  "an.t9_response": "Avg response",
  "an.t9_snap_delivered": "Deliveries done",
  "an.t9_snap_pending": "Deliveries pending",
  "an.t9_circle_activity": "Circle activity",
  "an.t10_empty": "No client goals yet.",
  "an.t10_client_count": "Clients",
  "an.t10_goals_total": "Goals total",
  "an.t10_goals_done": "Goals reached",
  "an.t10_beliefs_total": "Beliefs",
  "an.t10_beliefs_trans": "Transformed",
  "an.t10_top_cats": "Top categories",
  "an.t10_show_examples": "Show anonymous examples",
  "an.t10_hide_examples": "Hide examples",
  "an.t10_examples_note": "Anonymised — no names, only category & wording.",
  "an.t10_goals": "Goals",
  "an.t10_beliefs": "Beliefs",
  "an.t11_period_a": "Period A",
  "an.t11_period_b": "Period B",
  "an.t11_gross": "Gross revenue",
  "an.t11_bookings": "Bookings",
  "an.t11_msgs": "Messages",
  "an.t11_new_clients": "New clients",
  "an.t12_hint": "Pick tiles and export a personalised report.",
  "an.t12_templates": "Saved templates",
  "an.t12_templates_none": "No template saved yet.",
  "an.t12_template_run": "Export",
  "an.t12_pick": "Tiles for the report",
  "an.t12_all_on": "All",
  "an.t12_all_off": "None",
  "an.t12_tpl_name_ph": "Template name",
  "an.t12_tpl_save": "Save as template",
  "an.t12_tpl_saved": "Template saved.",
  "an.t12_pdf": "PDF",
  "an.t12_csv": "CSV",
  "an.t12_xlsx": "Excel",
  "an.t12_download_failed": "Download failed. Please try again.",

  // ── Ads / Campaigns (Phase 4e · e2) ──
  "ads.back": "Coach dashboard",
  "ads.eyebrow": "Ads",
  "ads.title": "Ad campaigns",
  "ads.subtitle": "Promote posts & offerings with an AI audience, budget and analytics.",
  "ads.wallet": "Ad wallet",
  "ads.wallet_hint": "Balance for impression- or click-based campaigns.",
  "ads.topup": "Top up",
  "ads.topup_ok": "Ad wallet topped up.",
  "ads.topup_title": "Top up ad wallet",
  "ads.topup_sub": "Current balance: {balance}",
  "ads.topup_custom": "Custom amount",
  "ads.topup_confirm": "Top up {amount}",
  "ads.topup_note": "Secure payment via Stripe. EU invoice included.",
  "ads.topup_billing": "Please complete your billing details first (Account).",
  "ads.new_campaign": "New campaign",
  "ads.new_campaign_sub": "Created in 3 steps — incl. AI audience.",
  "ads.offerings": "Manage offerings",
  "ads.offerings_sub": "Edit sessions, packages & prices.",
  "ads.reco_title": "Suggestions to promote",
  "ads.reco_sub": "Auto-picked by organic resonance.",
  "ads.reco_cta": "Promote now",
  "ads.reco_reason_default": "Strong organic resonance.",
  "ads.reco_reason_views": "Lots of views — ideal to scale.",
  "ads.reco_reason_reactions": "Lots of reactions from your community.",
  "ads.reco_reason_comments": "Lively comments & conversations.",
  "ads.reco_reason_bookmarks": "Often saved — genuine interest.",
  "ads.reco_reason_freshness": "Fresh & current — perfect for a boost.",
  "ads.reco_reason_bookings": "Strong booking numbers.",
  "ads.reco_reason_favorites": "Frequently favorited.",
  "ads.impressions": "Impressions",
  "ads.clicks": "Clicks",
  "ads.ctr": "CTR",
  "ads.total_spent": "Spent",
  "ads.budget_left": "Budget left",
  "ads.my_campaigns": "My campaigns",
  "ads.empty": "No campaign yet. Create your first one.",
  "ads.untitled": "Untitled",
  "ads.subject_post": "Post",
  "ads.subject_offering": "Offering",
  "ads.billing_impression": "per impression",
  "ads.billing_click": "per click",
  "ads.status_all": "All",
  "ads.status_running": "Running",
  "ads.status_paused": "Paused",
  "ads.status_pending_review": "In review",
  "ads.status_approved": "Approved",
  "ads.status_completed": "Completed",
  "ads.status_rejected": "Rejected",
  "ads.pause": "Pause",
  "ads.resume": "Resume",
  "ads.stop": "Stop",
  "ads.view_details": "Details",
  "ads.spent_of": "{spent} of {total} spent",
  "ads.new_title": "New campaign",
  "ads.new_step": "Step {n} of 3",
  "ads.pick_subject": "What would you like to promote?",
  "ads.pick_subject_hint": "Choose one of your posts or offerings.",
  "ads.subject_offerings": "Offerings",
  "ads.subject_posts": "Posts",
  "ads.no_subjects": "No posts or offerings to promote yet.",
  "ads.audience": "Audience",
  "ads.ai_button": "AI suggestion",
  "ads.ai_ok": "Audience suggested.",
  "ads.ai_why": "Why this audience",
  "ads.field_themes": "Themes",
  "ads.field_regions": "Regions",
  "ads.field_education_backgrounds": "Education",
  "ads.field_life_situations": "Life situations",
  "ads.field_other_traits": "Other traits",
  "ads.budget": "Budget",
  "ads.daily_eur": "Daily (€)",
  "ads.duration_days": "Duration (days)",
  "ads.total": "Total budget",
  "ads.billing_mode": "Billing",
  "ads.payment": "Payment",
  "ads.pay_stripe": "Stripe",
  "ads.pay_credits": "Wallet",
  "ads.credits_short": "Not enough balance — please top up.",
  "ads.no_credits": "Your ad wallet balance is not enough.",
  "ads.new_ok": "Campaign created — now in review.",
  "ads.next": "Next",
  "ads.back_step": "Back",
  "ads.launch": "Launch campaign",
  "ads.detail_title": "Campaign",
  "ads.detail_not_found": "Campaign not found.",
  "ads.range": "{n} days",
  "ads.chart_title": "Impressions & clicks per day",
  "ads.range_totals": "Total · {n} days",

  // ── Recommendations (Phase 4e · e3) ──
  "recs.back": "Coach dashboard",
  "recs.eyebrow": "Recommendations",
  "recs.title": "Recommendations",
  "recs.subtitle": "Impact of your post recommendations & warm recommendations on your profile.",
  "recs.tab_posts": "Post recommendations",
  "recs.tab_testimonials": "Profile recommendations",
  "recs.sent": "Sent",
  "recs.opened": "Opened",
  "recs.saved": "Saved",
  "recs.booked": "Booked",
  "recs.per_post": "Per post",
  "recs.see_clients": "View clients",
  "recs.untitled": "Untitled",
  "recs.posts_empty_title": "No recommendations sent yet",
  "recs.posts_empty_sub": "Recommend fitting posts to clients — the impact shows here.",
  "recs.detail_sub": "Per client: opened, saved, booked.",
  "recs.no_clients": "No clients for this post yet.",
  "recs.unknown_client": "Unknown client",
  "recs.dismissed": "Dismissed",
  "recs.pending": "Pending",
  "recs.testimonials_empty_title": "No recommendations yet",
  "recs.testimonials_empty_sub": "Clients can leave a warm recommendation after a session.",
  "recs.testimonials_count": "{n} recommendation(s) on your profile",
  "recs.deleted": "Recommendation removed.",

  // ── Bookings depth (Phase 4f) ──
  "bk.back": "Coach dashboard",
  "bk.eyebrow": "Bookings",
  "bk.title": "Bookings",
  "bk.subtitle": "Manage sessions, reschedules and your cancellation policy.",
  "bk.tab_bookings": "Bookings",
  "bk.tab_reschedule": "Reschedules",
  "bk.tab_refund": "Cancellation policy",
  "bk.kpi_upcoming": "Upcoming",
  "bk.kpi_completed": "Completed",
  "bk.kpi_pending": "Cancellation requests",
  "bk.kpi_gross": "Gross revenue",
  "bk.scope_upcoming": "Upcoming",
  "bk.scope_cancellation_pending": "Cancellation requests",
  "bk.scope_completed": "Completed",
  "bk.scope_cancelled": "Cancelled",
  "bk.scope_all": "All",
  "bk.status_requested": "Requested",
  "bk.status_confirmed": "Confirmed",
  "bk.status_paid": "Paid",
  "bk.status_pending": "Pending",
  "bk.status_completed": "Completed",
  "bk.status_pending_cancellation": "Cancellation requested",
  "bk.status_cancelled_refunded": "Cancelled (refunded)",
  "bk.status_cancelled_no_refund": "Cancelled",
  "bk.status_cancelled_refund_pending": "Cancelled (refund pending)",
  "bk.status_declined": "Declined",
  "bk.online": "Online",
  "bk.session": "Session",
  "bk.client": "Client",
  "bk.reason": "Reason",
  "bk.refund_per_policy": "Refund per policy: {pct}%",
  "bk.approve_refund": "Approve & refund",
  "bk.decline": "Decline",
  "bk.refunded": "Refunded: {amount} ({pct}%)",
  "bk.empty_title": "No bookings",
  "bk.empty_sub": "Nothing to see in this view right now.",
  "bk.load_failed": "Bookings could not be loaded.",
  "bk.approved_toast": "Cancellation approved & refund issued.",
  "bk.declined_toast": "Cancellation declined.",
  "bk.action_failed": "Action failed.",
  "bk.rs_title": "Auto-reschedule",
  "bk.rs_sub": "How far in advance clients can auto-reschedule their sessions.",
  "bk.rs_window_label": "Auto-approve window (hours before session)",
  "bk.rs_window_unit": "h",
  "bk.rs_saved": "Auto-reschedule is now {n}h before the session.",
  "bk.rs_hint": "Clients can only auto-reschedule if the session is at least this far in the future AND the new slot is at least this far away. Set to 0 to require your approval every time.",
  "bk.rs_invalid": "Please enter a number between 0 and 336 hours.",
  "bk.rs_pending_title": "Pending review",
  "bk.rs_pending_empty": "No pending requests. 🌱",
  "bk.rs_currently": "Currently",
  "bk.rs_reason_too_close": "⚠️ Requested too close to the session start",
  "bk.rs_reason_no_slot": "ℹ️ None of the client's slots were free",
  "bk.rs_client_windows": "Client suggested",
  "bk.rs_approve": "Approve",
  "bk.rs_reject_ph": "Optional message for the client",
  "bk.rs_counter": "🕰️ Counter-propose",
  "bk.rs_reject": "Reject",
  "bk.rs_approved_toast": "{name}'s session has been moved.",
  "bk.rs_rejected_toast": "{name} will be notified.",
  "bk.cp_title": "Send counter-proposals",
  "bk.cp_sub": "Suggest alternative times to {name}.",
  "bk.cp_add_slot": "Add time",
  "bk.cp_message_ph": "Optional message",
  "bk.cp_send": "Send proposals",
  "bk.cp_sent": "Counter-proposals sent.",
  "bk.cp_need_one": "Please pick at least one time.",
  "bk.rf_warn_bold": "The platform never absorbs a loss.",
  "bk.rf_warn_body": "Any refund you agree to comes out of your earnings. Stripe does NOT refund the processing fee charged on the payment — it stays with Stripe and comes off your payout. Choose tiers you can actually afford.",
  "bk.rf_your_tiers": "Your tiers",
  "bk.rf_tiers_hint": "Tiers apply in descending order of hours before the session.",
  "bk.rf_hours_before": "Hours before",
  "bk.rf_percent": "Refund %",
  "bk.rf_add_tier": "Add tier",
  "bk.rf_reset": "Default",
  "bk.rf_estimator": "What does it cost you?",
  "bk.rf_sample_price": "Sample price",
  "bk.rf_at_tier": "At tier",
  "bk.rf_refund_amount": "Refund amount",
  "bk.rf_stripe_fee": "Stripe fee lost",
  "bk.rf_out_of_pocket": "Your out-of-pocket",
  "bk.rf_commission_kept": "Platform commission (still owed)",
  "bk.rf_net_kept": "Your net kept",
  "bk.rf_msg_to_clients": "Message to clients",
  "bk.rf_msg_ph": "e.g. rescheduling is free with 48h notice.",
  "bk.rf_save": "Save",
  "bk.rf_saved": "Your cancellation policy has been updated.",

  // Audience templates (wizard improvement)
  "ads.tpl_label": "Audience templates",
  "ads.tpl_none": "No template saved yet.",
  "ads.tpl_save": "Save",
  "ads.tpl_name_ph": "Template name",
  "ads.tpl_saved": "Audience saved as template.",
  "ads.tpl_applied": "Template “{name}” applied.",
  "ads.tpl_deleted": "Template deleted.",
  "ads.tpl_save_hint": "Saves the current audience fields for reuse.",
  "zoom.title": "Zoom",
  "zoom.soon": "Being set up by the team — coming soon.",
  "zoom.connected": "Connected",
  "zoom.hint": "Connect your Zoom account for automatic meeting links on online bookings.",
  "zoom.connect": "Connect Zoom",
  "zoom.disconnect": "Disconnect",
  "zoom.t_connected": "Zoom account connected.",
  "zoom.t_error": "Zoom connection failed.",
  "zoom.t_disconnected": "Zoom disconnected.",
  "zoom.not_setup": "Zoom is not set up yet.",

  "pl.tab_programs": "Breath programs",
  "bp.sub": "Build multi-day breath programs from 3–5 techniques and share them by assignment or code.",
  "bp.new": "New program",
  "bp.empty_title": "No breath programs yet",
  "bp.empty_sub": "Create your first multi-day program for your clients.",
  "bp.techniques_n": "{n} techniques",
  "bp.days_n": "{n} days",
  "bp.assigned_n": "{n} assigned",
  "bp.share": "Share",
  "bp.archive_confirm": "Archive program “{name}”?",
  "bp.archived": "Program archived.",
  "bp.editor_new_title": "New breath program",
  "bp.editor_edit_title": "Edit program",
  "bp.editor_desc": "Pick 3–5 techniques and set duration & rhythm.",
  "bp.name_ph": "Program name",
  "bp.desc_ph": "Short description (optional)",
  "bp.days_label": "Duration (days)",
  "bp.rhythm_label": "Rhythm",
  "bp.tech_count": "Techniques ({n}/5)",
  "bp.min": "min",
  "bp.note_ph": "Note",
  "bp.need_valid": "Name and 3–5 techniques required.",
  "bp.created": "Program created.",
  "bp.updated": "Program updated.",
  "bp.save_failed": "Saving failed.",
  "bp.share_title": "Share “{name}”",
  "bp.share_desc": "Assign the program directly to a client or share the code {code}.",
  "bp.no_clients": "No clients yet.",
  "bp.assign_note_ph": "Personal message (optional)",
  "bp.assign": "Assign",
  "bp.sending": "Sending…",
  "bp.assigned_ok": "Program assigned.",
  "bp.assign_failed": "Assignment failed.",
  "bp.sched_all_daily": "All daily",
  "bp.sched_rotate": "Rotating",
  "bp.tech_box": "Box breathing",
  "bp.tech_478": "4-7-8",
  "bp.tech_coherent": "Coherent breathing",
  "bp.tech_physiological_sigh": "Physiological sigh",
  "bp.tech_cooling": "Cooling breath",
  "bp.tech_bhramari": "Bhramari",
  "bp.tech_nadi_shodhana": "Alternate nostril",
  "bp.tech_ocean": "Ocean breath",
  "bp.tech_wim_hof": "Wim Hof",
  "bp.tech_kapalabhati": "Kapalabhati",

  "cd.back": "Client pulse",
  "cd.no_access_title": "No access",
  "cd.no_access_sub": "There is no active relationship with this client.",
  "cd.client_fallback": "Client",
  "cd.upcoming": "Upcoming sessions ({n})",
  "cd.no_upcoming": "No upcoming sessions.",
  "cd.past": "Past sessions ({n})",
  "cd.no_past": "No past sessions yet.",
  "cd.plans": "Weekly plans ({n})",
  "cd.no_plans": "No weekly plans shared.",
  "cd.plan_meta": "{slots} slots · {done} done · {week}",
  "cd.flexible": "flexible",
  "cd.session_fallback": "Session",
  "cd.sharing_title": "Shared data",
  "cd.no_sharing": "This client isn't sharing any Deep Within data with you right now.",
  "cd.analysis_title": "Analysis",
  "cd.digestions": "Digestions",
  "cd.transformations": "Transformations",
  "cd.journal": "Journal",
  "cd.no_emotions": "No shared emotion data in this period.",
  "cd.weva": "WEVA reports ({n})",
  "cd.no_weva": "No WEVA reports for this client yet.",
  "cd.days_n": "{n} days",
  "cd.snapshots_n": "{n} snapshot request(s)",
  "cd.attachments": "Shared attachments ({n})",
  "cd.load_failed": "Client could not be loaded.",
  "cd.scope_share_events": "Events",
  "cd.scope_share_hrv": "HRV",
  "cd.scope_share_plans": "Plans",
  "cd.scope_share_ai_reports": "AI reports",
  "cd.scope_share_feed_activity": "Feed activity",
  "cd.scope_share_beliefs": "Beliefs",
  "cd.scope_share_upper_limits": "Upper limits",
  "cd.scope_share_goals": "Goals",
  "cd.scope_share_comfortzone": "Comfort zone",
  "cd.scope_share_coping": "Coping",
  "cd.scope_share_journal": "Journal",
  "cd.scope_share_weva_reports": "WEVA reports",
  "cd.count_beliefs": "Beliefs",
  "cd.count_upper_limits": "Upper limits",
  "cd.count_goals": "Goals",
  "cd.count_comfortzone": "Comfort zone",
  "cd.count_coping": "Coping",
  "cd.count_journal": "Journal entries",
  "cd.count_ai_reports": "AI reports",
  "cd.count_events": "Events",

  // ── Phase A P1 ──
  // Collab depth
  "col.tab_projects": "Projects",
  "col.tab_stats": "Statistics",
  "col.tab_ai": "AI recommendations",
  "col.stats_title": "Coming soon",
  "col.stats_body": "Bookings, revenue and client retention per collaboration in one clear dashboard view.",
  "col.ai_title": "Coming soon",
  "col.ai_body": "WEVA finds matching coaches for new collaborations based on shared topics, audiences and availability.",
  "col.project_type_offering": "Offering",
  "col.project_type_circle": "Circle",
  "col.project_status_active": "Active",
  "col.project_status_archived": "Archived",
  "col.project_empty_active": "No active projects yet",
  "col.project_empty_archived": "No archived projects",
  "col.project_empty_hint": "Shared offerings and circles appear here as projects.",
  "col.project_members_n": "{n} members",
  "col.project_tasks": "tasks",
  "col.project_revenue": "Total revenue",
  "col.project_my_share": "Your share ({pct}%)",
  "col.project_participants": "Participants",
  "col.project_team": "Coach team",
  "col.project_documents": "Documents",
  "col.project_purchases": "Purchases",

  // WEVA snapshot comparison
  "cd.snap_title": "WEVA snapshot comparison",
  "cd.snap_request": "Request snapshot",
  "cd.snap_requesting": "Requesting…",
  "cd.snap_requested": "Snapshot request sent.",
  "cd.snap_request_failed": "Request failed.",
  "cd.snap_need_more": "Not enough data for a comparison yet. Existing snapshots: {count}. Two approved snapshots are needed.",
  "cd.snap_days_between": "{n} days between snapshots",
  "cd.snap_beliefs_new": "{n} new beliefs",
  "cd.snap_beliefs_dissolved": "{n} dissolved",
  "cd.snap_beliefs_recurring": "{n} recurring",
  "cd.snap_pillars_shifted": "Shifted focus areas",
  "cd.snap_pillar_realize": "Realize",
  "cd.snap_pillar_designate": "Designate",
  "cd.snap_pillar_release": "Release",
  "cd.snap_practice_shift": "Next practice changed",
  "cd.snap_previous": "Previous",
  "cd.snap_latest": "Latest",

  // Consent forms
  "cf.meta_title": "Consent forms",
  "cf.back": "Coach dashboard",
  "cf.eyebrow": "Consent",
  "cf.title": "Consent forms",
  "cf.subtitle": "Create templates that clients sign digitally before booking.",
  "cf.new": "New template",
  "cf.empty_title": "No templates yet",
  "cf.empty_sub": "Create a consent form that must be signed before booking.",
  "cf.badge_required": "Required before booking",
  "cf.sig_count": "{n} signatures",
  "cf.delete_confirm": "Really archive this template?",
  "cf.deleted": "Template archived.",
  "cf.saved": "Template saved.",
  "cf.dialog_new": "New consent form",
  "cf.dialog_edit": "Edit template",
  "cf.dialog_desc": "Title and text of the form. Clients sign digitally in the app.",
  "cf.f_title": "Title",
  "cf.f_title_ph": "e.g. Breathwork liability waiver",
  "cf.f_body": "Text",
  "cf.f_body_ph": "Write the full text of the consent form here…",
  "cf.f_required": "Required before booking",
  "cf.f_required_hint": "Clients must sign before they can book.",
  "cf.version_note": "Text edits bump the version — existing signatures are kept.",
  "cf.err_title": "Please enter a title.",
  "cf.err_body": "Please enter the text.",
  "cf.sig_title": "Signatures",
  "cf.sig_empty": "No signatures yet.",
  "cf.sig_version": "Version {v}",

  // Post scheduler
  "ps.tab_label": "Scheduler",
  "ps.new": "New draft",
  "ps.saved": "Saved.",
  "ps.published": "Published.",
  "ps.status_draft": "Drafts",
  "ps.status_scheduled": "Scheduled",
  "ps.status_published": "Published",
  "ps.next_hint": "Next post “{title}” goes live on {when}.",
  "ps.wd_mon": "Mon",
  "ps.wd_tue": "Tue",
  "ps.wd_wed": "Wed",
  "ps.wd_thu": "Thu",
  "ps.wd_fri": "Fri",
  "ps.wd_sat": "Sat",
  "ps.wd_sun": "Sun",
  "ps.undated_title": "Drafts without a date",
  "ps.undated_empty": "No unscheduled drafts.",
  "ps.dialog_new": "New post",
  "ps.dialog_edit": "Edit post",
  "ps.dialog_desc": "Create a draft or schedule publication for later.",
  "ps.f_title": "Title",
  "ps.f_title_ph": "Post headline",
  "ps.f_body": "Content",
  "ps.f_body_ph": "Write your post…",
  "ps.f_scheduled": "Scheduled for",
  "ps.f_scheduled_hint": "Leave empty for an undated draft. With a date it auto-publishes.",
  "ps.f_inner_circle": "Inner Circle only",
  "ps.publish_now": "Publish now",
  "ps.err_title": "Please enter a title.",

  // Affiliate offerings
  "aff.tab_label": "Affiliate",
  "aff.intro": "External affiliate links shown on your public profile.",
  "aff.new": "New affiliate offering",
  "aff.saved": "Saved.",
  "aff.deleted": "Deleted.",
  "aff.delete_confirm": "Really delete this affiliate offering?",
  "aff.locked_title": "Coach Pro only",
  "aff.locked_sub": "Affiliate offerings are available for Coach Pro subscribers and Founder 50/500 members.",
  "aff.empty_title": "No affiliate offerings yet",
  "aff.empty_sub": "Link products you recommend — with an automatic ad label.",
  "aff.ad_badge": "Ad",
  "aff.inactive": "Inactive",
  "aff.dialog_new": "New affiliate offering",
  "aff.dialog_edit": "Edit offering",
  "aff.dialog_desc": "The link opens in the external browser and is automatically labelled as an ad.",
  "aff.f_title": "Title",
  "aff.f_title_ph": "e.g. My favourite journal",
  "aff.f_url": "Affiliate link",
  "aff.f_desc": "Description",
  "aff.f_desc_ph": "Short description (max 400 chars)",
  "aff.f_category": "Category",
  "aff.f_category_ph": "e.g. Books",
  "aff.f_price": "Price",
  "aff.f_price_ph": "optional",
  "aff.f_cover": "Cover image",
  "aff.f_cover_hint": "Optional. Shown on the affiliate card on your public profile.",
  "aff.compete_hint": "Note: links to competitor apps or platforms offering the same features as My Within are not allowed.",
  "aff.ack_label": "I am aware of the disclosure duty and label this link as advertising.",
  "aff.ack_compete": "I confirm this link does not lead to a competing platform.",
  "aff.err_title": "Please enter a title.",
  "aff.err_url": "Please enter a valid URL (http/https).",
  "aff.err_ack": "Please tick both confirmations.",

  // Coach setup
  "cs.meta_title": "Coach setup",
  "cs.back": "Coach dashboard",
  "cs.eyebrow": "Setup",
  "cs.title": "Coach setup",
  "cs.subtitle": "Four steps to a ready coach profile — then you earn the Founding Coach badge.",
  "cs.progress_label": "{done} of {total} steps done",
  "cs.badge_title": "Founding Coach badge active ✨",
  "cs.badge_sub": "You carry the Founding Coach badge on your profile for {n} more days.",
  "cs.step_n": "Step {n}",
  "cs.done": "Done",
  "cs.mark_done": "Mark as done",
  "cs.step_consent_title": "Create a consent form",
  "cs.step_consent_sub": "Build a template clients sign before booking.",
  "cs.step_consent_cta": "Go to consent forms",
  "cs.step_story_title": "Share your first story",
  "cs.step_story_sub": "Show up on the story wall and build trust.",
  "cs.step_story_cta": "Go to Social & content",
  "cs.step_program_title": "Create a breath program",
  "cs.step_program_sub": "Build a program you can assign to clients.",
  "cs.step_program_cta": "Go to plans",
  "cs.step_invite_title": "Invite your first client",
  "cs.step_invite_sub": "Share your invite code and bring your first clients on board.",
  "cs.step_invite_cta": "Show invite code",

  // ── Phase A P2 · Settings hub ──
  "cset.meta_title": "Settings",
  "cset.back_dashboard": "Coach dashboard",
  "cset.eyebrow": "Account",
  "cset.title": "Settings",
  "cset.subtitle": "Account, booking rules, brand, reports and credits in one place.",
  "cset.group_account": "Account",
  "cset.group_bookings": "Bookings",
  "cset.group_brand": "Brand & reports",
  "cset.group_billing": "Billing",
  "cset.group_language": "Language",
  "cset.row_profile": "Profile & brand",
  "cset.row_profile_sub": "Public profile, bio & branding.",
  "cset.row_verify": "Verification",
  "cset.row_verify_sub": "Upload qualification & status.",
  "cset.row_availability": "Availability",
  "cset.row_availability_sub": "Open & close weekly slots.",
  "cset.row_refund": "Cancellation & refunds",
  "cset.row_refund_sub": "Your own refund tiers & costs.",
  "cset.row_reschedule": "Reschedules",
  "cset.row_reschedule_sub": "Auto-approve window & pending requests.",
  "cset.row_branding": "Custom branding",
  "cset.row_branding_sub": "Logo, brand color & email footer.",
  "cset.row_digest": "Weekly digest preview",
  "cset.row_digest_sub": "Your collab bookings from last week.",
  "cset.row_credits": "Credits · {n}",
  "cset.row_credits_sub": "Top up credits for ads & more.",
  "cset.row_language": "App language",
  "cset.logout": "Sign out",

  // Cancellation & refunds
  "refpol.meta_title": "Cancellation & refunds",
  "refpol.eyebrow": "Bookings",
  "refpol.title": "Cancellation & refunds",
  "refpol.subtitle": "Set your own refund tiers that override the platform defaults.",
  "refpol.warn_bold": "The platform never absorbs a loss.",
  "refpol.warn_body": "Any refund comes out of your earnings. Stripe does NOT refund the processing fee — it stays with Stripe and comes off your payout. Only choose tiers you can afford.",
  "refpol.your_tiers": "Your tiers",
  "refpol.tiers_hint": "Tiers apply in descending order of hours before the session.",
  "refpol.hours_before": "Hours before",
  "refpol.refund_pct": "Refund %",
  "refpol.add_tier": "Add tier",
  "refpol.reset": "Reset to default",
  "refpol.cost_title": "What does a refund cost?",
  "refpol.sample_price": "Sample price",
  "refpol.est_refund": "Refund amount",
  "refpol.est_stripe": "Stripe fee lost",
  "refpol.est_oop": "Your out-of-pocket",
  "refpol.est_commission": "Platform commission (still owed)",
  "refpol.est_net": "Your net kept",
  "refpol.notes": "Message to clients",
  "refpol.notes_ph": "e.g. Rescheduling is free up to 48h before.",
  "refpol.save": "Save policy",
  "refpol.saved": "Policy saved.",

  // Reschedules
  "resch.meta_title": "Reschedules",
  "resch.eyebrow": "Bookings",
  "resch.title": "Reschedule settings",
  "resch.subtitle": "How far in advance clients can auto-reschedule their sessions.",
  "resch.window_label": "Auto-approve window (hours before session)",
  "resch.window_hint": "Clients can only auto-reschedule if the session is at least this far in the future AND the new slot is at least this far away. Set to 0 to require your approval every time.",
  "resch.save": "Save",
  "resch.saved": "Saved.",
  "resch.invalid": "Please enter a number between 0 and 336.",
  "resch.pending_title": "Pending review",
  "resch.pending_empty": "No pending requests. 🌱",
  "resch.currently": "Currently",
  "resch.reason_too_close": "⚠️ Requested too close to the session start",
  "resch.reason_no_slot": "ℹ️ None of the client's slots were free",
  "resch.client_windows": "Client suggested",
  "resch.approve": "Approve",
  "resch.approved": "Approved.",
  "resch.reject_ph": "Optional message for the client",
  "resch.reject": "Reject request",
  "resch.rejected": "Rejected.",

  // Custom branding
  "cbr.meta_title": "Custom branding",
  "cbr.eyebrow": "Brand",
  "cbr.title": "Custom branding",
  "cbr.subtitle": "Logo, brand color and footer for your client-facing emails.",
  "cbr.locked_title": "Coach Pro only",
  "cbr.locked_sub": "Custom branding is part of Coach Pro. Upgrade to use your own logo and colors.",
  "cbr.f_logo": "Logo URL",
  "cbr.f_logo_hint": "Public https URL of your logo (shown in emails).",
  "cbr.f_color": "Brand color",
  "cbr.f_footer": "Email footer",
  "cbr.f_footer_ph": "e.g. With love, your coach name · legal/links",
  "cbr.save": "Save branding",
  "cbr.saved": "Branding saved.",
  "cbr.reset": "Reset",
  "cbr.reset_confirm": "Reset branding to defaults?",
  "cbr.reset_done": "Reset to defaults.",
  "cbr.err_logo": "Logo URL must start with http:// or https://.",
  "cbr.err_color": "Color must be #RRGGBB (e.g. #6B8E6E).",

  // Weekly digest preview
  "wdig.meta_title": "Weekly digest",
  "wdig.eyebrow": "Reports",
  "wdig.title": "Weekly digest preview",
  "wdig.subtitle": "Your collab bookings from last week — just like the email digest.",
  "wdig.this_week": "This week",
  "wdig.bookings": "Bookings",
  "wdig.gross": "Gross revenue",
  "wdig.trend": "4-week trend",
  "wdig.offerings": "By offering",
  "wdig.offerings_empty": "No collab bookings this week yet.",
  "wdig.n_bookings": "{n} bookings",
  "wdig.last_sent": "Last sent {when} · {n} bookings · {gross}",

  // Credits
  "cred.meta_title": "Credits",
  "cred.eyebrow": "Billing",
  "cred.title": "Credits",
  "cred.subtitle": "Top up credits to run ads and use premium features.",
  "cred.balance": "Current balance",
  "cred.per_credit": "{price} per credit",
  "cred.buy": "Buy",
  "cred.mock_granted": "{n} credits granted (test mode).",
  "cred.vat_note": "Prices incl. VAT. Invoiced by Inside Out Harmony e.U. (Austria).",

  // ── Phase A P2 Part 2 · Settings rows ──
  "cset.row_professional": "Professional profile & certificates",
  "cset.row_professional_sub": "Profession, methods, qualifications & proofs.",
  "cset.row_checkin": "Check-in template",
  "cset.row_checkin_sub": "Warm message for silent clients.",
  "cset.group_growth": "Growth",
  "cset.row_referral": "Refer & earn",
  "cset.row_referral_sub": "Your code, links & rewards.",
  "cset.row_ic_invites": "Inner Circle invites",
  "cset.row_ic_invites_sub": "Invite clients & track acceptance.",
  "cset.row_wins": "Client wins",
  "cset.row_wins_sub": "Success stories & testimonials.",
  "cset.row_collectives": "Collectives",
  "cset.row_collectives_sub": "Coach alliances with shared revenue.",
  "cset.group_support": "Support & help",
  "cset.row_support": "Support tickets",
  "cset.row_support_sub": "Ask the My Within team directly.",
  "cset.row_help": "Help & FAQ",
  "cset.row_help_sub": "Answers to common questions.",
  "cset.row_tour": "Tour",
  "cset.row_tour_sub": "Quick overview of your dashboard.",
  "cset.row_upgrade": "Coach Pro",
  "cset.row_upgrade_sub": "Upgrade for 10% commission, branding & more.",

  // Support
  "sup.meta_title": "Support", "sup.eyebrow": "Support", "sup.title": "Support & care",
  "sup.subtitle": "Ask the My Within team directly — we reply personally.",
  "sup.new": "New request", "sup.new_desc": "Pick a topic and describe your issue.",
  "sup.f_category": "Topic", "sup.f_subject": "Subject (optional)", "sup.f_subject_ph": "Short title",
  "sup.f_body": "Your message", "sup.f_body_ph": "Describe your issue as concretely as possible…",
  "sup.submit": "Send", "sup.created": "Request sent.", "sup.err_cat": "Please pick at least one topic.", "sup.err_body": "Please describe your issue.",
  "sup.empty_title": "No requests yet", "sup.empty_sub": "Send your first support request — we're here for you.",
  "sup.n_msg": "{n} messages",
  "sup.status_open": "Open", "sup.status_in_progress": "In progress", "sup.status_answered": "Answered", "sup.status_closed": "Closed",
  "sup.reply_ph": "Write a reply…", "sup.send": "Send", "sup.close": "Close ticket", "sup.close_confirm": "Really close this ticket?", "sup.closed": "Closed.", "sup.is_closed": "This ticket is closed. Please create a new request for further questions.",

  // Referral
  "ref.meta_title": "Refer", "ref.eyebrow": "Growth", "ref.title": "Refer & earn",
  "ref.subtitle": "Share My Within and earn rewards for every signup through your code.",
  "ref.your_code": "Your referral code", "ref.share": "Share", "ref.copied": "Link copied.",
  "ref.links": "Your links", "ref.web_link": "Web link", "ref.app_link": "App link",
  "ref.rewards_title": "How rewards work",
  "ref.rule_coach_bonus": "{pct}% bonus on client subscriptions you refer — up to {months} months.",
  "ref.rule_c2c": "{eur} € credit per referred person — up to {max}×/year.",
  "ref.rule_note": "Rewards clear after the refund window.",

  // Check-in template
  "chk.meta_title": "Check-in template", "chk.eyebrow": "Bookings", "chk.title": "Check-in template",
  "chk.subtitle": "Your warm default message for silent clients from Client Pulse.",
  "chk.default_hint": "You're using the default template. Adjust it to match your tone.",
  "chk.f_template": "Template text", "chk.preview": "Preview", "chk.save": "Save template", "chk.saved": "Saved.", "chk.err_short": "Please enter at least 10 characters.",

  // Upgrade
  "upg.meta_title": "Coach Pro", "upg.eyebrow": "Subscription", "upg.title": "Upgrade to Coach Pro",
  "upg.subtitle": "Lower commission, your own branding and all premium tools.",
  "upg.already_pro": "You're already Coach Pro — thank you for being here! ✨",
  "upg.best_value": "Best value", "upg.plan_monthly": "Monthly", "upg.plan_yearly": "Yearly", "upg.per_month": "month", "upg.per_year": "year",
  "upg.f_commission": "Just 10% commission on sessions", "upg.f_unlimited_weva": "Unlimited WEVA analyses", "upg.f_branding": "Custom branding (logo & color)",
  "upg.f_analytics": "Advanced analytics", "upg.f_priority": "Priority WEVA processing", "upg.f_group_tools": "Group & collective tools", "upg.f_bulk_export": "Bulk export of your data",
  "upg.subscribe": "Upgrade now", "upg.current": "Current plan", "upg.pay_credits": "Pay with {n} credits", "upg.activated": "Coach Pro activated!", "upg.vat_note": "Prices incl. 20% Austrian VAT. Cancel anytime.",

  // Help / FAQ
  "help.meta_title": "Help", "help.eyebrow": "Help", "help.title": "Help & FAQ", "help.subtitle": "Quick answers to the most common coach questions.",
  "help.q_getting_started": "How do I get started as a coach?", "help.a_getting_started": "Complete the coach setup (4 steps): create a consent form, share your first story, build a breath program and invite your first client.",
  "help.q_payouts": "How do I get my payouts?", "help.a_payouts": "Connect your Stripe account under Earnings. Payouts run automatically after the refund window — minus the platform commission.",
  "help.q_clients": "How do I see silent clients?", "help.a_clients": "Client Pulse shows who has been inactive for a while. From there you can send a warm check-in or draft an AI nudge.",
  "help.q_pro": "What does Coach Pro offer?", "help.a_pro": "Coach Pro lowers your commission to 10% and unlocks custom branding, advanced analytics, priority WEVA and group tools.",
  "help.q_branding": "How do I use my own branding?", "help.a_branding": "With Coach Pro you can set your logo, brand color and an email footer under Settings → Custom branding.",
  "help.q_refunds": "How do refunds work?", "help.a_refunds": "Under Settings → Cancellation & refunds you define your own tiers. Note: Stripe fees are not refunded and come off your payout.",
  "help.contact_sub": "Didn't find an answer? Write to us directly.", "help.contact_cta": "Contact support",

  // Tour
  "tour.meta_title": "Tour", "tour.eyebrow": "Welcome", "tour.title": "Your coach tour", "tour.subtitle": "The key stops of your dashboard in 5 steps.", "tour.step_n": "Step {n}",
  "tour.clients_title": "Support clients", "tour.clients_sub": "Check the pulse, spot silent clients & follow up warmly.",
  "tour.plans_title": "Plans & programs", "tour.plans_sub": "Assign daily plans and share breath programs.",
  "tour.offerings_title": "Sell offerings", "tour.offerings_sub": "Set up sessions, packages & affiliate offerings.",
  "tour.circles_title": "Build circles", "tour.circles_sub": "Inner & Local Circle for recurring income.",
  "tour.analytics_title": "Measure growth", "tour.analytics_sub": "Analytics deepdive on revenue, WEVA & retention.",
  "tour.cta_sub": "Ready? Finish your setup.", "tour.cta": "Go to coach setup",

  // Inner Circle invites
  "ici.meta_title": "Inner Circle invites", "ici.back": "Inner Circle", "ici.eyebrow": "Inner Circle", "ici.title": "Manage invites",
  "ici.subtitle": "Invite clients to your Inner Circle and track acceptance.",
  "ici.stat_sent": "Sent", "ici.stat_accept_rate": "Accept rate", "ici.stat_active": "Active subs", "ici.stat_retention": "30-day retention",
  "ici.invite_title": "Invite by email", "ici.emails_ph": "Email addresses, separated by comma or line", "ici.note_ph": "Personal note (optional, max 200 chars)",
  "ici.send": "Send invites", "ici.sent": "{n} invites sent.", "ici.err_email": "Please provide at least one valid email.",
  "ici.list_title": "Sent invites", "ici.empty": "No invites sent yet.",
  "ici.status_pending": "Pending", "ici.status_accepted": "Accepted", "ici.status_revoked": "Revoked",

  // Collectives
  "col2.meta_title": "Collectives", "col2.eyebrow": "Collaboration", "col2.title": "Collectives", "col2.subtitle": "Team up with other coaches into an alliance with shared revenue.",
  "col2.new": "New collective", "col2.new_desc": "Give your collective a name and a description.",
  "col2.f_name": "Name", "col2.f_name_ph": "e.g. Breathwork Alliance Vienna", "col2.f_desc": "Description", "col2.f_desc_ph": "What is this collective about?", "col2.f_cover": "Cover image",
  "col2.err_name": "Please enter a name.", "col2.created": "Collective created.", "col2.empty_title": "No collectives yet", "col2.empty_sub": "Create a collective or wait for an invitation.",
  "col2.members_n": "{n} members", "col2.owner": "Owner", "col2.status_draft": "Draft", "col2.status_active": "Active", "col2.status_archived": "Archived",
  "col2.detail_meta": "Collective", "col2.you_invited": "You've been invited to this collective.", "col2.accept": "Accept", "col2.decline": "Decline", "col2.resp_accepted": "Accepted.", "col2.resp_declined": "Declined.",
  "col2.members": "Members", "col2.invite": "Invite", "col2.share_pct": "{pct}% revenue share", "col2.mstatus_invited": "Invited", "col2.mstatus_declined": "Declined",
  "col2.publish": "Publish", "col2.archive": "Archive", "col2.saved": "Saved.", "col2.invited": "Invited.", "col2.err_email": "Please enter a valid email.",
  "col2.invite_title": "Invite coach", "col2.invite_email": "Coach email", "col2.invite_share": "Revenue share %",

  // Client wins
  "win.meta_title": "Client wins", "win.eyebrow": "Social", "win.title": "Client wins", "win.subtitle": "Turn real progress into success stories — with your clients' consent.",
  "win.suggestions": "AI suggestions", "win.suggestions_empty": "No suggestions right now. They appear when clients make measurable progress.", "win.create": "Create as win", "win.requested": "Created — sent to the client for approval.",
  "win.my_wins": "Your wins", "win.empty": "No wins created yet.", "win.delete_confirm": "Really delete this win?", "win.deleted": "Deleted.",
  "win.pending": "Awaiting approval", "win.approved": "Approved", "win.private": "Private",

  // Professional profile progress
  "pon.meta_title": "Professional profile", "pon.eyebrow": "Profile", "pon.title": "Professional profile & progress", "pon.subtitle": "Complete your professional profile so clients trust you.", "pon.progress": "{done} of {total} areas filled",
  "pon.step_profession": "Primary profession chosen", "pon.step_methods": "Methods added", "pon.step_focus": "Focus areas chosen", "pon.step_qualifications": "Qualifications added", "pon.step_languages": "Languages chosen", "pon.step_certificates": "Certificate uploaded",
  "pon.certificates": "Certificates", "pon.cert_add": "Upload", "pon.cert_empty": "No certificates yet. PDF, JPG or PNG (max 20 MB).", "pon.cert_uploaded": "Certificate uploaded.", "pon.cert_fail": "Upload failed.", "pon.cert_delete_confirm": "Really delete this certificate?", "pon.cert_deleted": "Deleted.", "pon.edit_in_profile": "Edit professional profile in Profile",

  // EVA nudge (client detail)
  "nudge.title": "Draft AI nudge", "nudge.hint": "Let WEVA draft a warm, short message based on your client's latest reflection. You review & send it yourself.",
  "nudge.generate": "Draft nudge", "nudge.regenerate": "Draft again", "nudge.generating": "Drafting…", "nudge.failed": "Couldn't draft a nudge right now.", "nudge.theme": "Theme", "nudge.copy": "Copy", "nudge.send_hint": "Tip: copy the text and send it to the client via your messages.",
  "nav.coach_hub": "Coaches",
  "nav.group.book": "Book",
  "nav.my_bookings": "Bookings",
  "bkc.hub_title": "Coaches & booking",
  "bkc.hub_sub": "Your guides and their bookable offerings.",
  "bkc.my_coaches": "My coaches",
  "bkc.no_coaches": "No coaches yet",
  "bkc.no_coaches_sub": "Discover the right guidance and book your first session.",
  "bkc.browse_all": "Browse all coaches",
  "bkc.view_profile": "View profile",
  "bkc.offerings": "Offerings",
  "bkc.no_products": "No bookable offerings.",
  "bkc.book_cta": "Book",
  "bkc.group": "Group",
  "bkc.min": "min",
  "bkc.with_coach": "with {name}",
  "bkc.back": "Back",
  "bkc.pick_date": "Pick a date",
  "bkc.slots": "Available times",
  "bkc.no_slots": "No free times on this day.",
  "bkc.payment": "Payment",
  "bkc.pay_credits": "{n} credits",
  "bkc.pay_card": "Card",
  "bkc.confirm_credits": "Book with {n} credits",
  "bkc.confirm_card": "Book for {amount}",
  "bkc.select_slot_first": "Please pick a time first.",
  "bkc.checkout_opened": "Checkout opened in a new tab …",
  "bkc.booked": "Booking confirmed!",
  "bkc.book_failed": "Booking failed.",
  "bkc.product_not_found": "Offering not found.",
  "bkc.bookings_title": "My bookings",
  "bkc.bookings_sub": "Your upcoming and past sessions.",
  "bkc.upcoming": "Upcoming",
  "bkc.past": "Past",
  "bkc.none": "No bookings yet",
  "bkc.none_sub": "Book your first session with a coach.",
  "bkc.no_upcoming": "No upcoming bookings.",
  "bkc.no_past": "No past sessions yet.",
  "bkc.open_details": "Details",
  "bkc.join_zoom": "Join Zoom",
  "bkc.cancel": "Cancel",
  "bkc.cancel_request": "Request cancellation",
  "bkc.cancel_confirm": "Really cancel this booking?",
  "bkc.cancel_sent": "Cancellation request sent.",
  "bkc.marketplace": "Marketplace",
  "bkc.status_confirmed": "Confirmed",
  "bkc.status_paid": "Paid",
  "bkc.status_pending": "Pending",
  "bkc.status_payment_pending": "Payment due",
  "bkc.status_cancelled": "Cancelled",
  "bkc.status_pending_cancellation": "Cancellation requested",
  "bkc.status_cancelled_refunded": "Cancelled · refunded",
  "bkc.status_cancelled_no_refund": "Cancelled · no refund",
  "bkc.status_cancelled_refund_pending": "Cancelled · refund pending",
  "bkc.refund_title": "Cancellation terms",
  "bkc.refund_intro": "Here's what you'd get back if you cancel now:",
  "bkc.refund_tier_72": "More than 72 h before · 100%",
  "bkc.refund_tier_24": "24–72 h before · 50%",
  "bkc.refund_tier_now": "Less than 24 h before · 0%",
  "bkc.refund_you_get": "You get back",
  "bkc.refund_pct": "{pct}% refund",
  "bkc.refund_amount": "≈ {amount}",
  "bkc.refund_hours_left": "{hours} h left until the session",
  "bkc.refund_note": "Your coach confirms the final refund.",
  "bkc.reason_ph": "Reason (optional)",
  "bkc.submit_cancel": "Request cancellation",
  "bkc.session_title": "Session",
  "bkc.session_not_found": "Session not found.",
  "bkc.when": "When",
  "bkc.where": "Where",
  "bkc.your_coach": "Your coach",
  "bkc.virtual": "Online session",
  "bkc.join_meeting": "Join meeting",
  "bkc.link_tba": "Link to follow.",
  "bkc.in_person": "In person",
  "bkc.location_tba": "Location to follow.",
  "bkc.in_person_hint": "Your coach will share the exact address.",
  "bkc.time_tba": "Time to be announced",
  "bkc.note_title": "Your note for the coach",
  "bkc.note_hint": "Share in advance what you'd like to work on.",
  "bkc.note_ph": "What should this session be about?",
  "bkc.note_saved_at": "Saved on {when}",
  "bkc.save": "Save",
  "bkc.clear": "Clear",
  "bkc.saved": "Saved.",
  "bkc.cancel_policy": "Cancellation: currently {pct}% refund.",
  "bkc.duration_min": "{n} min",
  "bkc.email": "Email",
  "bkc.phone": "Call",

  // Session booking (sb)
  "sb.title": "Book your session",
  "sb.back": "Back",
  "sb.not_found": "Coach not found.",
  "sb.pick_offering": "Choose an offering",
  "sb.no_offerings": "This coach has no bookable offerings right now.",
  "sb.minutes": "{n} min",
  "sb.credits_label": "credits",
  "sb.payment": "Payment method",
  "sb.pay_credits": "Pay with credits",
  "sb.pay_card": "Pay with card",
  "sb.credits_balance": "Balance: {balance} credits",
  "sb.credits_insufficient": "{need} credits short (you have {have}).",
  "sb.add_credits": "Add more credits",
  "sb.preferred_time": "Preferred time",
  "sb.available_times": "Available times",
  "sb.no_slots_day": "No open slots on this day — try another date.",
  "sb.note_title": "A short note (optional)",
  "sb.note_ph": "What would you like to talk about?",
  "sb.legal": "One-time billing check. The coach confirms once payment goes through.",
  "sb.confirm_credits": "Book for {credits} credits",
  "sb.confirm_card": "Book for {amount}",
  "sb.confirm_insufficient": "Not enough credits",
  "sb.booked": "Your session is held 💛",
  "sb.book_failed": "Booking failed.",

  // Collab packages (cov)
  "cov.packages_title": "Collab packages",
  "cov.packages_sub": "Packages crafted together by multiple coaches.",
  "cov.none": "No collab packages available right now.",
  "cov.not_found": "Package not found.",
  "cov.coaches": "Coaches",
  "cov.included": "Included",
  "cov.kind_training": "Training",
  "cov.kind_one_on_one": "1:1 session",
  "cov.kind_product": "Product",
  "cov.min": "min",
  "cov.capacity": "{n} of {total} open",
  "cov.total": "Total",
  "cov.payment": "Payment",
  "cov.balance": "Balance: {balance}",
  "cov.insufficient": "{need} short (you have {have}).",
  "cov.add_credits": "Add more credits",
  "cov.book_credits": "Book for {credits} credits",
  "cov.book_card": "Book for {amount}",
  "cov.full": "Fully booked",
  "cov.book_failed": "Booking failed.",
  "cov.booked_title": "Package booked",
  "cov.booked_sub": "All set. Your coaches have been notified.",
  "cov.booked_blocks": "Your package",
  "cov.booked_ready": "Ready",
  "cov.booked_slot": "Scheduled: {when}",
  "cov.booked_slot_pending": "Slot still pending",
  "cov.booked_home": "Go to my bookings",
  "cov.slot_title": "Choose your slots",
  "cov.slot_sub": "Set a time for each 1:1 session.",
  "cov.slot_all_done": "All slots set",
  "cov.slot_pending": "{n} slot(s) pending",
  "cov.slot_pick_coach": "Pick a coach",
  "cov.slot_pick_slot": "Pick a slot",
  "cov.slot_none": "No open slots.",
  "cov.slot_save": "Save slot",
  "cov.slot_saved": "Saved slots",
  "cov.slot_skip": "Do this later",
  "cov.slot_done": "Done",

  // Deep Within + Journal + Practices (Welle 1)
  "nav.deep_within": "Deep Within",
  "nav.journal": "Journal",
  "dw.title": "Deep Within",
  "dw.subtitle": "Your space to recognise, name and release what you carry.",
  "dw.in_progress": "in gentle work",
  "dw.transformed": "transformed",
  "dw.hero_practices_title": "Recognise · Name · Release",
  "dw.hero_practices_sub": "Guided practices to transform what you feel.",
  "dw.hero_journal_title": "Journaling",
  "dw.hero_journal_sub": "Write yourself free — day by day.",
  "dw.soon": "Coming soon",
  "dw.buckets_heading": "Your areas",
  "dw.entries": "{n} entries",
  "dw.not_found": "Area not found.",
  "dw.add": "Add",
  "dw.edit": "Edit",
  "dw.delete": "Delete",
  "dw.save": "Save",
  "dw.cancel": "Cancel",
  "dw.saved": "Saved.",
  "dw.save_failed": "Could not save.",
  "dw.deleted": "Deleted.",
  "dw.delete_failed": "Could not delete.",
  "dw.delete_confirm": "Delete this entry?",
  "dw.primary_required": "Please fill in the main field.",
  "dw.tab_own": "Mine",
  "dw.tab_weva": "WEVA",
  "dw.tab_all": "All",
  "dw.tab_progress": "In gentle work",
  "dw.tab_transformed": "Transformed",
  "dw.empty_title": "Nothing here yet",
  "dw.empty_sub": "Add your first entry when you're ready.",
  "dw.status_label": "Status",
  "dw.status_open": "Open",
  "dw.status_in_progress": "In progress",
  "dw.status_transformed": "Transformed",
  "dw.weva_toggle": "Include in WEVA reflection",
  "dw.readonly_weva": "Recognised by WEVA — only status & WEVA toggle are editable.",
  "dw.show_details": "More details",
  "dw.hide_details": "Hide details",
  "dw.f.reframe": "New, empowering version",
  "dw.f.reframe_ph": "How would you like to see it instead?",
  "dw.f.frequency": "Frequency",
  "dw.f.origin": "Origin",
  "dw.f.body_location": "Body location",
  "dw.f.physical_pain": "Physical sensation",
  "dw.f.applied_practice": "Applied practice",
  "dw.ul.title": "Upper limit",
  "dw.ul.title_ph": "How do you dim your light when things go well?",
  "dw.ul.life_area": "Life area",
  "dw.ul.symptoms": "Symptoms",
  "dw.ul.symptoms_ph": "e.g. worry, conflict (comma-separated)",
  "dw.ul.trigger": "Trigger",
  "dw.ul.core_false_belief": "Underlying false belief",
  "dw.ul.zone_of_genius_impact": "Impact on your zone of genius",
  "dw.beliefs.title": "Beliefs",
  "dw.beliefs.sub": "Convictions that shape you",
  "dw.beliefs.field": "Belief",
  "dw.beliefs.ph": "What do you believe about yourself or the world?",
  "dw.fears.title": "Fears",
  "dw.fears.sub": "What holds you back",
  "dw.fears.field": "Fear",
  "dw.fears.ph": "What are you afraid of?",
  "dw.surroundings.title": "Surroundings",
  "dw.surroundings.sub": "People & places around you",
  "dw.surroundings.field": "Surrounding",
  "dw.surroundings.ph": "Which part of your surroundings is on your mind?",
  "dw.dreams.title": "Dreams",
  "dw.dreams.sub": "Where you long to go",
  "dw.dreams.field": "Dream",
  "dw.dreams.ph": "What do you dream of?",
  "dw.values.title": "Values",
  "dw.values.sub": "What matters to you",
  "dw.values.field": "Value",
  "dw.values.ph": "Which value guides you?",
  "dw.strengths.title": "Strengths",
  "dw.strengths.sub": "What you can build on",
  "dw.strengths.field": "Strength",
  "dw.strengths.ph": "Which strength lives in you?",
  "dw.habits.title": "Habits",
  "dw.habits.sub": "Your daily patterns",
  "dw.habits.field": "Habit",
  "dw.habits.ph": "Which habit would you like to look at?",
  "dw.boundaries.title": "Boundaries",
  "dw.boundaries.sub": "What you protect",
  "dw.boundaries.field": "Boundary",
  "dw.boundaries.ph": "Which boundary would you like to set?",
  "dw.upper-limits.title": "Upper limits",
  "dw.upper-limits.sub": "Where you hold yourself back",
  "jr.title": "Journal",
  "jr.subtitle": "A calm place for your thoughts.",
  "jr.new_ph": "What's on your mind right now?",
  "jr.mood": "Mood",
  "jr.weva": "Include in WEVA",
  "jr.save": "Save entry",
  "jr.saved": "Entry saved.",
  "jr.save_failed": "Could not save.",
  "jr.empty_err": "Please write something first.",
  "jr.empty_title": "No entries yet",
  "jr.empty_sub": "Your first entry is waiting.",
  "jr.delete": "Delete",
  "jr.delete_confirm": "Delete this entry?",
  "jr.deleted": "Entry deleted.",
  "pr.title": "Recognise · Name · Release",
  "pr.subtitle": "Guided, evidence-based practices to safely transform what you feel. Coming in one of the next waves.",
  "pr.soon": "Coming soon",
  "pr.pillar_realize": "Recognise",
  "pr.pillar_designate": "Name",
  "pr.pillar_release": "Release",

  // Practices (Erkennen·Benennen·Loslassen) — ported from mobile
  "back": "Back",
  "body_arms": "Arms",
  "body_belly": "Belly",
  "body_chest": "Chest",
  "body_face": "Face",
  "body_feet": "Feet",
  "body_head": "Head",
  "body_heart": "Heart",
  "body_hips": "Hips",
  "body_legs": "Legs",
  "body_lower_back": "Lower back",
  "body_mark_neutral": "Neutral",
  "body_mark_open": "Open",
  "body_mark_tense": "Tense",
  "body_pelvis": "Pelvis",
  "body_shoulders": "Shoulders",
  "body_solar_plexus": "Solar plexus",
  "body_throat": "Throat",
  "body_upper_back": "Upper back",
  "bodymap_hint": "Tap a region to cycle tense → neutral → open.",
  "emdr_hint": "Bring the memory or feeling into mind, then follow the dot.",
  "emdr_rounds": "Rounds",
  "emdr_min_rounds": "At least 10 rounds to continue ({n}/10)",
  "emdr_speed": "Speed",
  "emdr_speed_fast": "Fast",
  "emdr_speed_med": "Med",
  "emdr_speed_slow": "Slow",
  "emo_abandoned": "abandoned",
  "emo_accomplished": "accomplished",
  "emo_aching": "aching",
  "emo_amazed": "amazed",
  "emo_anger": "anger",
  "emo_annoyed": "annoyed",
  "emo_anxious": "anxious",
  "emo_ashamed": "ashamed",
  "emo_betrayed": "betrayed",
  "emo_bitter": "bitter",
  "emo_cherished": "cherished",
  "emo_confident": "confident",
  "emo_confused": "confused",
  "emo_connected": "connected",
  "emo_contemptuous": "contemptuous",
  "emo_content": "content",
  "emo_critical": "critical",
  "emo_curious": "curious",
  "emo_defeated": "defeated",
  "emo_disappointed": "disappointed",
  "emo_disgust": "disgust",
  "emo_disoriented": "disoriented",
  "emo_disrespected": "disrespected",
  "emo_eager": "eager",
  "emo_embarrassed": "embarrassed",
  "emo_empty": "empty",
  "emo_energized": "energized",
  "emo_enraged": "enraged",
  "emo_excited": "excited",
  "emo_exposed": "exposed",
  "emo_fear": "fear",
  "emo_frozen": "frozen",
  "emo_frustrated": "frustrated",
  "emo_furious": "furious",
  "emo_grateful": "grateful",
  "emo_grief": "grief",
  "emo_guilty": "guilty",
  "emo_hateful": "hateful",
  "emo_heartbroken": "heartbroken",
  "emo_helpless": "helpless",
  "emo_hopeless": "hopeless",
  "emo_hostile": "hostile",
  "emo_hurt": "hurt",
  "emo_impatient": "impatient",
  "emo_inadequate": "inadequate",
  "emo_insecure": "insecure",
  "emo_intrigued": "intrigued",
  "emo_irritated": "irritated",
  "emo_isolated": "isolated",
  "emo_jealous": "jealous",
  "emo_jolted": "jolted",
  "emo_joy": "joy",
  "emo_judgmental": "judgmental",
  "emo_lonely": "lonely",
  "emo_lost": "lost",
  "emo_loving": "loving",
  "emo_mourning": "mourning",
  "emo_nauseated": "nauseated",
  "emo_open": "open",
  "emo_overwhelmed": "overwhelmed",
  "emo_paralyzed": "paralyzed",
  "emo_peaceful": "peaceful",
  "emo_perplexed": "perplexed",
  "emo_powerless": "powerless",
  "emo_primary": "Primary",
  "emo_proud": "proud",
  "emo_repulsed": "repulsed",
  "emo_resentful": "resentful",
  "emo_restless": "restless",
  "emo_revolted": "revolted",
  "emo_sadness": "sadness",
  "emo_scared": "scared",
  "emo_secondary": "Secondary",
  "emo_seen": "seen",
  "emo_shocked": "shocked",
  "emo_small": "small",
  "emo_specific": "Specific",
  "emo_startled": "startled",
  "emo_superior": "superior",
  "emo_surprise": "surprise",
  "emo_tearful": "tearful",
  "emo_tender": "tender",
  "emo_terrified": "terrified",
  "emo_threatened": "threatened",
  "emo_thrilled": "thrilled",
  "emo_trapped": "trapped",
  "emo_unfair": "unfair",
  "emo_unseen": "unseen",
  "emo_unworthy": "unworthy",
  "emo_violent": "violent",
  "emo_warm": "warm",
  "emo_worried": "worried",
  "favorite": "Favorite",
  "p_abc_a_label": "A — What happened? (facts only)",
  "p_abc_a_ph": "My boss said…",
  "p_abc_b_label": "B — What did I make it mean?",
  "p_abc_b_ph": "That I'm not competent…",
  "p_abc_c_label": "C — How did I feel and act?",
  "p_abc_c_ph": "I froze, avoided…",
  "p_abc_dispute_label": "Is B objectively true? What's another read?",
  "p_abc_dispute_ph": "Maybe they were stressed too…",
  "p_abc_intro_body": "A (Activating event) → B (Belief / evaluation) → C (Consequence). The magic is at B.",
  "p_abc_intro_title": "See the sequence",
  "p_abc_model": "ABC Model",
  "p_abc_model_desc": "Trigger → Evaluation → Consequence. See the sequence.",
  "p_abc_newc_label": "If I held the new belief — what would C look like?",
  "p_abc_title": "ABC Model",
  "p_body_scan": "Body Scanning",
  "p_body_scan_bodymap_hint": "Tap each region to mark its state.",
  "p_body_scan_bodymap_label": "Where do you feel it?",
  "p_body_scan_desc": "Sense your body head to toe and mark what asks to be noticed.",
  "p_body_scan_intro_body": "Move your attention slowly from crown to soles. Mark what is tense, what is neutral, what feels open.",
  "p_body_scan_intro_title": "Sense head-to-toe",
  "p_body_scan_invite_breath": "To be breathed into",
  "p_body_scan_invite_label": "What does that place want?",
  "p_body_scan_invite_movement": "Movement",
  "p_body_scan_invite_stillness": "Just presence",
  "p_body_scan_invite_touch": "A hand of care",
  "p_body_scan_invite_words": "Kind words",
  "p_body_scan_mood_after": "After",
  "p_body_scan_mood_before": "Before",
  "p_body_scan_sensation_label": "What's the most vivid sensation?",
  "p_body_scan_sensation_ph": "A tight ring around my throat…",
  "p_body_scan_title": "Body Scanning",
  "p_cb_after": "After",
  "p_cb_before": "Before",
  "p_cb_dur_20": "20 min",
  "p_cb_dur_30": "30 min",
  "p_cb_dur_40": "40 min",
  "p_cb_dur_starter": "10 min (starter)",
  "p_cb_duration_label": "Session length",
  "p_cb_exp_calm": "Deep calm",
  "p_cb_exp_heat": "Heat / cold",
  "p_cb_exp_images": "Vivid images",
  "p_cb_exp_movement": "Body wanted to move",
  "p_cb_exp_nothing": "Nothing dramatic",
  "p_cb_exp_tears": "Tears",
  "p_cb_exp_tetany": "Tingling / tetany",
  "p_cb_experience_label": "What arose during breathing? (check afterwards)",
  "p_cb_intention_label": "Your intention for this session",
  "p_cb_intention_ph": "To let grief move…",
  "p_cb_intro_body": "Continuous inhale-exhale with no pause. Best done supported by a facilitator or a guided track. 20-40 minutes.",
  "p_cb_intro_title": "Circular breathing",
  "p_cb_posture_bed": "On a bed / mat",
  "p_cb_posture_chair": "Seated in chair",
  "p_cb_posture_floor": "Floor",
  "p_cb_posture_label": "Where will you lie or sit?",
  "p_cb_reflection_label": "Reflection",
  "p_cb_title": "Connected Breathwork",
  "p_cognitive_restructuring": "Cognitive Restructuring",
  "p_cognitive_restructuring_desc": "Test a heavy thought, then choose a lighter, truer one.",
  "p_connected_breath": "Connected Breathwork",
  "p_connected_breath_desc": "Circular breathing to move stuck emotional energy.",
  "p_core_deeper1_label": "If it got that fully, what would that give it?",
  "p_core_deeper1_ph": "Safety, maybe.",
  "p_core_deeper2_label": "And if it got THAT fully?",
  "p_core_integration_label": "How does the original reaction change when you already have this?",
  "p_core_intro_body": "Ask each reaction \"if you got everything you want, what would that give me?\" — until you reach a core state (Peace, Love, Being).",
  "p_core_intro_title": "Follow it home",
  "p_core_state_being": "Being / okness",
  "p_core_state_label": "Which core state feels closest?",
  "p_core_state_love": "Love",
  "p_core_state_oneness": "Oneness",
  "p_core_state_peace": "Peace",
  "p_core_transformation": "Core Transformation",
  "p_core_transformation_desc": "Follow a reaction to its deepest positive intent.",
  "p_core_transformation_title": "Core Transformation",
  "p_core_trigger_label": "What reaction are you working with?",
  "p_core_trigger_ph": "When my partner ignores my texts, I feel angry…",
  "p_core_want_label": "What does that part want?",
  "p_core_want_ph": "I want to be seen.",
  "p_cr_balanced_label": "A more balanced thought",
  "p_cr_balanced_ph": "Sometimes I struggle AND I've grown through hard things before.",
  "p_cr_belief_after": "How true does the balanced thought feel now?",
  "p_cr_belief_before": "How true does it feel? (1 low – 10 high)",
  "p_cr_dist_all_or_nothing": "All-or-nothing",
  "p_cr_dist_catastrophizing": "Catastrophizing",
  "p_cr_dist_label": "Which cognitive distortions are at play?",
  "p_cr_dist_labeling": "Labeling",
  "p_cr_dist_mind_reading": "Mind-reading",
  "p_cr_dist_personalizing": "Personalizing",
  "p_cr_dist_should": "'Should' statements",
  "p_cr_evidence_against": "Evidence AGAINST the thought",
  "p_cr_evidence_for": "Evidence FOR the thought",
  "p_cr_heavy_label": "Write the heavy thought",
  "p_cr_heavy_ph": "I'll never be good enough…",
  "p_cr_intro_body": "A heavy thought is not a fact. Weigh it, then choose a truer one.",
  "p_cr_intro_title": "Test the thought",
  "p_cr_title": "Cognitive Restructuring",
  "p_dream_log": "Dream Logbook",
  "p_dream_log_desc": "Capture dreams while fresh - symbols, feelings, thresholds.",
  "p_dream_log_intro_body": "Dreams fade in minutes. Write what you remember — even fragments carry meaning.",
  "p_dream_log_intro_title": "Catch the thread",
  "p_dream_log_narrative_label": "Tell it — in present tense if you can.",
  "p_dream_log_narrative_ph": "I am walking through…",
  "p_dream_log_question_label": "What question is this dream asking?",
  "p_dream_log_question_ph": "…",
  "p_dream_log_sym_animal": "Animal",
  "p_dream_log_sym_fire": "Fire",
  "p_dream_log_sym_house": "House / room",
  "p_dream_log_sym_light": "Light / dark",
  "p_dream_log_sym_person": "Person",
  "p_dream_log_sym_threshold": "Threshold / door",
  "p_dream_log_sym_vehicle": "Vehicle",
  "p_dream_log_sym_water": "Water",
  "p_dream_log_symbols_hint": "Pick as many as fit.",
  "p_dream_log_symbols_label": "Symbols that stood out",
  "p_dream_log_title": "Dream Logbook",
  "p_dream_log_title_label": "A short title for this dream",
  "p_dream_log_title_ph": "The endless staircase",
  "p_dream_log_tone_grieving": "Grieving",
  "p_dream_log_tone_joyful": "Joyful",
  "p_dream_log_tone_label": "The overall feeling was…",
  "p_dream_log_tone_mystery": "Mysterious",
  "p_dream_log_tone_peaceful": "Peaceful",
  "p_dream_log_tone_tense": "Tense",
  "p_emdr": "EMDR (Self-use)",
  "p_emdr_desc": "Bilateral stimulation with a memory or emotion.",
  "p_emdr_intro_body": "This is a self-use adaptation of EMDR — for gentle daily distress, not deep trauma. Seek a licensed therapist for the latter.",
  "p_emdr_intro_title": "Bilateral stimulation",
  "p_emdr_session_hint": "Complete 1-3 sets of 20-30 rounds. Between sets, breathe and let images float.",
  "p_emdr_session_label": "Watch the dot while holding the target",
  "p_emdr_shift_label": "What shifted in image, body, or thought?",
  "p_emdr_suds_after": "SUDS now (0 – 10)",
  "p_emdr_suds_before": "SUDS — distress right now (0 calm – 10 max)",
  "p_emdr_target_label": "Target: bring one memory or feeling to mind",
  "p_emdr_target_ph": "The moment yesterday when…",
  "p_emdr_title": "EMDR (Self-use)",
  "p_emotion_wheel": "Emotion Wheel",
  "p_emotion_wheel_after": "After naming it — how are you?",
  "p_emotion_wheel_before": "Before",
  "p_emotion_wheel_desc": "Pinpoint what you feel with precision - from broad to specific.",
  "p_emotion_wheel_intro_body": "When we can name it, we can meet it. Move from wide to narrow.",
  "p_emotion_wheel_intro_title": "Precision changes everything",
  "p_emotion_wheel_title": "Emotion Wheel",
  "p_emotion_wheel_trigger_label": "What triggered this?",
  "p_emotion_wheel_trigger_ph": "A short sentence…",
  "p_emotion_wheel_wheel_label": "Move outward — general → specific",
  "p_inner_critic": "The Inner Critic",
  "p_inner_critic_desc": "Meet the voice inside - and hear what it is protecting.",
  "p_inner_critic_intro_body": "The inner critic is not you — it is a part of you trying to protect you in an old way. Let's meet it, listen, and thank it.",
  "p_inner_critic_intro_title": "Meet the voice",
  "p_inner_critic_mood_after": "And now?",
  "p_inner_critic_mood_before": "How are you before we start?",
  "p_inner_critic_mood_before_hint": "1 = heavy, 10 = light",
  "p_inner_critic_protect_hint": "Look underneath the harshness. What fear lives there?",
  "p_inner_critic_protect_label": "What is it trying to protect you from?",
  "p_inner_critic_response_label": "What could you say back — kindly?",
  "p_inner_critic_response_ph": "Thank you for trying to protect me. I hear you and I've got this.",
  "p_inner_critic_title": "The Inner Critic",
  "p_inner_critic_tone_label": "What tone does it use?",
  "p_inner_critic_tone_opt_anxious": "Anxious & catastrophizing",
  "p_inner_critic_tone_opt_cold": "Cold & dismissive",
  "p_inner_critic_tone_opt_harsh": "Harsh & cutting",
  "p_inner_critic_tone_opt_pushy": "Pushy & demanding",
  "p_inner_critic_voice_label": "What is the critic saying to you today?",
  "p_inner_critic_voice_ph": "You're never going to…",
  "p_parts_age_label": "How old does it feel?",
  "p_parts_age_ph": "7, or 42, or ageless",
  "p_parts_intro_body": "You have many inner parts. Choose one that is active today — give it a name, an age, and listen.",
  "p_parts_intro_title": "Meet the parts",
  "p_parts_message_label": "What does it want you to know?",
  "p_parts_name_label": "Give this part a name",
  "p_parts_name_ph": "The Overachiever",
  "p_parts_role_exile": "Exile (holds pain)",
  "p_parts_role_firefighter": "Firefighter",
  "p_parts_role_label": "What is its role?",
  "p_parts_role_manager": "Manager / planner",
  "p_parts_role_protector": "Protector",
  "p_parts_role_witness": "Inner witness",
  "p_parts_self_label": "What does your calm Self say back?",
  "p_parts_self_ph": "I hear you. Thank you for holding this.",
  "p_parts_work": "Parts Work",
  "p_parts_work_desc": "Meet your ego-states as inner characters with roles.",
  "p_parts_work_title": "Parts Work",
  "p_the_work": "The Work (Byron Katie)",
  "p_the_work_belief_label": "Write the stressful thought",
  "p_the_work_belief_ph": "They should love me the way I want.",
  "p_the_work_desc": "Four questions and a turnaround for a stressful belief.",
  "p_the_work_intro_body": "Bring one stressful belief. Ask it four questions. Then turn it around.",
  "p_the_work_intro_title": "Four questions & a turnaround",
  "p_the_work_q1_label": "1. Is it true?",
  "p_the_work_q2_label": "2. Can you absolutely know it's true?",
  "p_the_work_q3_label": "3. How do you react — what happens — when you believe this thought?",
  "p_the_work_q4_label": "4. Who would you be without this thought?",
  "p_the_work_title": "The Work (Byron Katie)",
  "p_the_work_turnaround_label": "Turn it around — write one turnaround that feels just as true, or truer.",
  "p_the_work_turnaround_ph": "I should love myself the way I want them to.",
  "p_tre": "TRE",
  "p_tre_after": "After",
  "p_tre_before": "Before",
  "p_tre_desc": "Trauma releasing exercises - let the body tremble it out.",
  "p_tre_intro_body": "TRE fatigues the psoas and releases the tremor reflex. Do this on a soft surface. Stop any time. Not for advanced trauma without support.",
  "p_tre_intro_title": "Let the body tremble",
  "p_tre_reflection_label": "What did you notice?",
  "p_tre_session_hint": "Follow each phase. The tremor is safe when it flows freely.",
  "p_tre_session_label": "Guided session",
  "p_tre_title": "TRE",
  "p_yesno_no": "No",
  "p_yesno_unsure": "Not sure",
  "p_yesno_yes": "Yes",
  "pillar_designate": "Designate",
  "pillar_designate_desc": "Name and structure what you see.",
  "pillar_realize": "Realize",
  "pillar_realize_desc": "See what is truly here.",
  "pillar_release": "Release",
  "pillar_release_desc": "Let it move through you.",
  "practices_hub_subtitle": "Twelve guided practices across the three pillars.",
  "practices_hub_title": "Realize - Designate - Release",
  "saving": "Saving...",
  "tre_hint": "Follow the 4 phases. Stop any time if you feel unsafe.",
  "tre_intensity_lbl": "Tremor intensity (0 – 10)",
  "tre_phase_fatigue": "2. Wall-sit fatigue",
  "tre_phase_rest": "4. Integration rest",
  "tre_phase_tremor": "3. Tremor phase (lying)",
  "tre_phase_warmup": "1. Warm-up (feet, calves)",
  "ui_continue": "Continue",
  "ui_could_not_save": "Could not save",
  "ui_please_try_again": "Please try again.",
  "ui_save_finish": "Save & finish",
  "unfavorite": "Remove favorite",
  "widget_pause": "Pause",
  "widget_resume": "Resume",
  "widget_start": "Start",
  // Deep Within tabs, insights, workings + view switcher (iter250)
  "nav.switch_to_client": "My personal space",
  "nav.switch_to_coach": "Coach area",
  "dw.tab_practice": "Practice",
  "dw.tab_insights": "Insights",
  "dw.tab_history": "History",
  "dw.insights_total": "Total entries",
  "dw.insights_streak_current": "Current streak",
  "dw.insights_streak_longest": "Longest streak",
  "dw.insights_mood_delta": "Avg. shift",
  "dw.insights_7d": "Last 7 days",
  "dw.insights_by_pillar": "By pillar",
  "dw.insights_mood": "Mood",
  "dw.insights_mood_before": "before",
  "dw.insights_mood_after": "after",
  "dw.insights_sources": "Sources",
  "dw.insights_top": "Favourite practice",
  "dw.insights_empty_title": "No data yet",
  "dw.insights_empty_sub": "Complete a practice or add an entry — your insights will appear here.",
  "dw.src_practices": "Practices",
  "dw.src_goals": "Goals",
  "dw.src_comfortzone": "Comfort zone",
  "dw.src_coping": "Coping",
  "dw.src_journal": "Journal",
  "dw.history_full_log": "Full log",
  "dw.history_empty_title": "No practices yet",
  "dw.history_empty_sub": "Your completed practices will appear here.",
  "dw.workings": "Journey",
  "dw.workings_add": "Step",
  "dw.workings_none": "No steps in this journey yet.",
  "dw.working_saved": "Step saved.",
  "dw.working_title": "Journey step",
  "dw.working_sub": "Capture what shifted as you worked with it.",
  "dw.working_intensity": "Intensity",
  "dw.working_success": "Sense of success",
  "dw.working_reflection": "What changed?",
  "dw.working_still": "I'm still working on it",
  "dw.working_hint_progress": "Stays in gentle work.",
  "dw.working_hint_done": "Marked as transformed.",
  "practices_history_title": "Practice history",
  "practices_history_sub": "All your completed practices.",
  "practices_history_empty_title": "No practices yet",
  "practices_history_empty_sub": "Start a practice from the Practices hub.",
  "practices_delete_confirm": "Delete this entry?",

  // --- WEVA / EVA (Phase B Epic C+B · Welle 2) ---
  "weva": "WEVA",
  "weva_full_name": "Wellbeing Emotional Vitality Assistant",
  "weva_freemium_notice": "WEVA is an AI feature — Plus (€5.97/mo) or higher unlocks chat, reports, beliefs analysis and insights.",
  "weva_tab_insight": "Insight",
  "weva_action_insight_sub": "See WEVA's latest reflection at a glance.",
  "weva_action_chat": "Chat with WEVA",
  "weva_action_chat_sub": "WEVA listens only when you invite her.",
  "weva_action_reports": "Generate reports",
  "weva_action_reports_sub": "Pick timeframes and sources for your report.",
  "weva_action_beliefs": "Your Beliefs",
  "weva_action_beliefs_sub": "Your table + WEVA's observations, side by side.",
  "weva_tab_history": "AI History",
  "weva_report_fallback_title": "Report",
  "ui_latest_reflection": "Latest WEVA reflection",
  "ui_open_full_report": "Open full report",
  "ui_no_report_yet": "No WEVA report yet. Generate one from the WEVA tab.",
  "weva_generate_report_cta": "Generate a report",
  "eva_chat": "Chat with WEVA",
  "eva_chat_sub": "Ask WEVA about your patterns, emotions or next steps.",
  "eva_chat_tab_chat": "Chat",
  "eva_chat_tab_past": "Past",
  "eva_chat_tab_reports": "Reports",
  "eva_chat_empty": "Say hi to WEVA - she remembers what you've shared.",
  "eva_chat_send_hint": "WEVA answers based on your recent journal, breakouts and latest digest.",
  "eva_chat_thinking": "WEVA is reflecting…",
  "eva_chat_placeholder": "What's on your mind?",
  "eva_chat_used": "{n}/{q} messages today",
  "eva_chat_limit_hit": "Daily WEVA chat limit reached - upgrade to keep talking.",
  "eva_chat_clear": "Clear conversation",
  "eva_chat_clear_confirm": "Delete our entire conversation with WEVA?",
  "eva_chat_new_session": "Start a fresh chat",
  "eva_chat_past_empty": "Your past chats appear here once you finish a conversation.",
  "eva_chat_current_pill": "Current",
  "eva_chat_msgs_short": "msgs",
  "eva_chat_empty_session": "empty session",
  "eva_chat_reflecting": "Reflecting…",
  "eva_chat_view_report": "View report",
  "eva_chat_make_report": "Make report",
  "eva_chat_reports_empty": "After a chat, tap \\\"Make report\\\" on the Past tab. Summaries live here.",
  "eva_chat_report_fallback": "Chat report",
  "insights_2": "Insights",
  "delete_report": "Delete report",
  "eva_chat_voice_locked": "Voice input needs Plus, Pro or Ultimate.",
  "journal_upgrade_cta": "Upgrade to unlock",
  "cancel": "Cancel",
  "delete": "Delete",
  "popup_report_failed": "Report failed",
  "popup_not_enough_credits": "Not enough credits",
  "popup_signup_required": "Signup required",
  "popup_signup_to_report": "Please finish signup to generate this report.",
  "weekly_digest": "Weekly digest",
  "what_weva_noticed": "What WEVA noticed",
  "a_gentle_next_step": "A gentle next step",
  "weva_didn_t_leave_a_summary_for_this": "WEVA didn't leave a summary for this week.",
  "talk_with_weva_about_this": "Talk with WEVA about this",
  "retry": "Retry",
  "weva_report": "WEVA Report",
  "report_not_found": "Report not found.",
  "expand_all": "Expand all",
  "collapse_all": "Collapse all",
  "since_your_last_report": "Since your last report",
  "this_is_your_first_weva_report": "This is your first WEVA report",
  "welcome_to_the_journey_come_back_after": "Welcome to the journey. Come back after your next practice window — the “before vs after” card will start tracking your growth from here.",
  "tap_to_open_previous_report": "Tap to open previous report ›",
  "try_this_first": "Try this first",
  "try_this_next": "Try this next",
  "open_the_practice": "Open the practice ›",
  "open_the_beliefs_table": "Open the Beliefs table ›",
  "weva_reports_title": "Generate a new WEVA report",
  "weva_reports_sub": "Choose what WEVA takes into consideration.",
  "weva_reports_scope_all": "All data",
  "one_timeframe_applied_to_all_sources": "One timeframe applied to all sources.",
  "weva_reports_include_realize": "Include Realize data",
  "weva_reports_include_designate": "Include Designate data",
  "weva_reports_include_release": "Include Release data",
  "weva_reports_include_breakouts": "Include Breathwork sessions",
  "weva_reports_include_goals": "Include My Goals",
  "weva_reports_include_comfortzone": "Include My Comfortzone",
  "weva_reports_include_coping": "Include My Coping",
  "weva_reports_include_journal": "Include My Journal",
  "my_beliefs_section_title": "My beliefs",
  "upper_limits_section_title": "My upper limits",
  "weva_reports_include_prior": "Include older WEVA reports",
  "weva_reports_generate": "Generate report",
  "weva_reports_history": "Previous reports",
  "your_reports_will_live_here": "Your reports will live here.",
  "no_reports_match_your_filters": "No reports match your filters.",
  "search_reports": "Search reports…",
  "weva_lang_picker_label": "Report language",
  "weva_lang_picker_hint": "The WEVA report will be written in this language.",
  "get_a_weva_report": "Get a WEVA report",
  "reports_left": "reports left",
  "every_report_distils_your_recent": "Every report distils your recent breathwork, journals, goals and comfort-zone work into one clear reflection from WEVA.",
  "confirm_delete_weva_report_title": "Delete this WEVA report?",
  "confirm_delete_weva_report_body": "This cannot be undone.",
  "confirm_delete": "Delete",
  "popup_delete_failed": "Couldn't delete",
  "nav.weva": "WEVA",
  "weva_subtitle": "Your personal AI vitality companion.",
  "weva_action_digests": "Weekly reflections",
  "weva_action_digests_sub": "WEVA's weekly summaries of your inner work.",
  "weva_digests_title": "Weekly reflections",
  "weva_digests_sub": "WEVA's weekly summaries of your inner work.",
  "weva_digests_empty": "No weekly reflections yet. They appear as you practice regularly.",
  "weva_reflects_title": "WEVA reflects",
  "weva_reflects_sub": "The heart of this report",
  "weva_recommended_title": "Practices for right now",
  "weva_recommended_sub": "Tap to open",
  "weva_beliefs_noticed_title": "Beliefs WEVA noticed",
  "weva_comp_new_entries": "New entries",
  "weva_comp_practice_days": "Practice days",
  "weva_comp_mood_delta": "Avg mood Δ",
  "weva_comp_beliefs": "Beliefs",
  "weva_generating": "WEVA is reflecting…",
  "weva_no_data": "No data in the selected timeframe. Practice something first, then try again.",
  "weva_credits_needed": "This report needs 15 credits (or a Plus/Pro subscription). Top up credits now?",
  "weva_scope_sources": "Sources & timeframes",
  "weva_reports_left": "reports left",
  "weva_report_language": "Report language",
  "weva_tts_play": "Play aloud",
  "weva_tts_stop": "Stop",


  // --- Collaboration (Teilen mit Coach) ---
  "collaboration_2": "Collaboration",
  "decide_who_sees_what_only_coaches_whose": "Decide who sees what. Only coaches whose inner circle you joined can receive your data.",
  "you_re_not_connected_to_any_coach_yet": "You're not connected to any coach yet.",
  "inner_circle_2": "Inner Circle",
  "collab_join": "Join",
  "allow_to_collaborate_with": "Allow to collaborate with:",
  "even_in_a_3_way_chat_each_coach_only": "Even in a 3-way chat, each coach only sees the data you shared with THEM. Nobody sees the other side.",
  "nav.collaboration": "Collaboration",
  "collab_share_events": "Breakout events + emotions",
  "collab_share_hrv": "HRV + heart-rate signal",
  "collab_share_plans": "Practice plans + calendar",
  "collab_share_ai_reports": "AI analysis reports",
  "collab_share_feed": "Feed activity",
  "collab_not_in_circle": "Not in inner circle",
  "collab_active": "Inner circle · active",
  "collab_join_first": "Join this coach's inner circle first.",
  "collab_saved": "Sharing updated",


  // --- Epic E (Journal depth) + Epic F (Goals) ---
  "goals_action_archive": "Archive",
  "goals_action_complete": "Mark complete",
  "goals_actions_body": "Pick an action for this goal.",
  "goals_actions_title": "Goal actions",
  "goals_add": "Add",
  "goals_add_first": "Add your first goal",
  "goals_empty_body": "A goal helps WEVA and yourself see where you're heading. Add your first - it takes 3 minutes.",
  "goals_empty_title": "No goals yet",
  "goals_framework_recap": "Your framework",
  "goals_last_scale": "Last check-in: {n}/10",
  "goals_log_note_ph": "Optional: a note about today (private)",
  "goals_log_progress": "Log progress",
  "goals_log_prompt": "Where are you today on this goal, from 1 (far) to 10 (fully lived)?",
  "goals_more_hint": "Open all your goals",
  "goals_no_progress_yet": "No progress logged yet",
  "goals_progress_card": "Progress",
  "goals_progress_last_n": "Last {n} check-ins",
  "goals_q1_hint": "What feeling are you truly seeking? Peace, connection, self-trust, freedom? Write freely, in your own words.",
  "goals_q1_num": "STEP 1 · INTROSPECTION",
  "goals_q1_placeholder": "I sense I'm looking for…",
  "goals_q1_short": "Emotional need",
  "goals_q1_title": "Recognise your true emotional need.",
  "goals_q2_hint": "Move from vague to specific. e.g. \\\"I want to respond with more compassion during conflicts\\\" instead of \\\"I want to be nicer.\\\"",
  "goals_q2_num": "STEP 2 · SPECIFICITY",
  "goals_q2_placeholder": "Concretely, I want to…",
  "goals_q2_short": "Concrete goal",
  "goals_q2_title": "Make your goal concrete.",
  "goals_q3_high": "Fully lived",
  "goals_q3_hint": "This is your starting scale - no judgement. You'll log check-ins on the same scale later.",
  "goals_q3_low": "Far",
  "goals_q3_num": "STEP 3 · MEASURABILITY",
  "goals_q3_scale_hint": "1 = far from it   ·   10 = fully lived",
  "goals_q3_short": "Starting point",
  "goals_q3_title": "Where are you today on this goal, from 1 to 10?",
  "goals_q4_hint": "Why does this feeling matter to you? What becomes possible when you live it?",
  "goals_q4_num": "STEP 4 · ATTRACTIVENESS",
  "goals_q4_placeholder": "This matters to me because…",
  "goals_q4_short": "Your why",
  "goals_q4_title": "Connect the goal to a deep emotional why.",
  "goals_q5_hint": "Adjust so the goal is about your own responses, not what others must do. Keep it achievable.",
  "goals_q5_num": "STEP 5 · RELEVANCE",
  "goals_q5_placeholder": "This is within my control because…",
  "goals_q5_short": "Realism",
  "goals_q5_title": "Is this goal within your own control, and realistic?",
  "goals_q6_hint": "e.g. \\\"Over the next four weeks\\\", \\\"By the end of the summer\\\".",
  "goals_q6_num": "STEP 6 · TIME FRAME",
  "goals_q6_placeholder": "Over the next…",
  "goals_q6_short": "Time frame",
  "goals_q6_title": "In what time frame do you want to live this?",
  "goals_q7_hint": "Say it to yourself, then write it here. This is your written promise - kind and honest.",
  "goals_q7_num": "STEP 7 · WRITTEN COMMITMENT",
  "goals_q7_placeholder": "I commit to…",
  "goals_q7_short": "Commitment",
  "goals_q7_title": "Write your commitment in your own words.",
  "goals_section_subtitle": "Set the goals that guide your practice.",
  "goals_section_title": "My Goals",
  "goals_see_all": "See all {n} goals",
  "goals_status_active": "Active",
  "goals_status_archived": "Archived",
  "goals_status_completed": "Completed",
  "goals_status_paused": "Paused",
  "goals_title_placeholder": "e.g. Respond with compassion in conflicts",
  "goals_view_all": "See all goals",
  "goals_weva_analyze": "Analyze with WEVA",
  "goals_weva_card_title": "WEVA reflection",
  "goals_weva_challenges": "Gentle invitations",
  "goals_weva_enable_body": "WEVA reads your seven answers and check-ins, then offers a compassionate reflection - strengths, gentle challenges, and a next kind step. You can turn this off at any time.",
  "goals_weva_enable_first_body": "Enable WEVA for this goal above, then run the analysis.",
  "goals_weva_enable_first_title": "Turn on WEVA reflection first",
  "goals_weva_enable_title": "Let WEVA reflect on this goal",
  "goals_weva_next_step": "A next kind step",
  "goals_weva_no_analysis_yet": "No reflection yet. Tap Analyze to invite WEVA.",
  "goals_weva_regenerate": "Reflect again",
  "goals_weva_strengths": "What you already carry",
  "goals_wizard_discard_body": "You've started filling this in. Leave without saving?",
  "goals_wizard_discard_confirm": "Discard",
  "goals_wizard_discard_title": "Discard this goal?",
  "goals_wizard_final_h": "Almost there - one last choice",
  "goals_wizard_final_hint": "Optional: let WEVA reflect on this goal privately.",
  "goals_wizard_final_num": "ALMOST THERE",
  "goals_wizard_recap": "Your commitment in short",
  "goals_wizard_recap_title": "Title",
  "goals_wizard_save": "Save goal",
  "goals_wizard_step_of": "Step {n} of {total}",
  "goals_wizard_title_h": "Give your goal a short name",
  "goals_wizard_title_hint": "One line you'll recognise. You can change it any time.",
  "goals_wizard_title_num": "GOAL TITLE",
  "journal_tab_entries": "Journal entries",
  "journal_tab_weva": "WEVA Insight",
  "journal_recording": "Recording… tap to stop",
  "journal_transcribing": "Transcribing…",
  "journal_transcription_ready": "Transcription ready. Edit or save.",
  "journal_tap_to_record": "Tap to record",
  "journal_permission_denied": "Microphone permission denied - enable it in system Settings.",
  "journal_locked_voice": "Voice journaling is a Plus feature.",
  "journal_monthly_used": "{n}/{q} entries used this month",
  "journal_saved": "Entry saved. Include it in a WEVA report anytime for reflection.",
  "journal_empty": "No entries yet. Your first reflection is one breath away.",
  "journal_subtitle": "Your private reflection space - write or speak.",
  "journal_prompt": "How are you feeling today? What emotions, situations or beliefs are alive right now?",
  "journal_placeholder": "e.g. Felt tension in my chest before the meeting. I believed I'd freeze...",
  "journal_mood": "Mood",
  "journal_save": "Save entry",
  "journal_new_entry": "New entry",
  "journal_tap_to_open": "Tap to open",
  "journal_entry_detail_title": "Journal entry",
  "journal_take_this_further": "Take this further",
  "journal_work_alone_title": "Work on this alone",
  "journal_work_alone_sub": "Generate a WEVA insight focused just on this entry to see the patterns it reveals.",
  "journal_work_coach_title": "Work with a coach",
  "journal_work_coach_sub": "Book a session — your entry will be attached so the coach can prepare.",
  "journal_delete_confirm": "Delete this entry? This cannot be undone.",
  "journal_weva_included": "You have {n} {reportWord} included in your {plan} plan.",
  "journal_weva_credits_hint": "One WEVA insight = 15 credits. Or upgrade to include monthly reports.",
  "journal_weva_report_singular": "report",
  "journal_weva_report_plural": "reports",
  "journal_pick_prompt": "Tick 1+ entries to focus a report — or leave empty for the last 30 days.",
  "journal_pick_selected_singular": "{n} entry selected",
  "journal_pick_selected_plural": "{n} entries selected",
  "journal_pick_clear": "Clear",
  "journal_pick_empty": "Write your first journal entry — then come back to tick it for a report.",
  "journal_weva_btn_picked": "Generate WEVA report ({n} entries)",
  "journal_weva_btn_30d": "Generate WEVA report (last 30 days)",
  "journal_weva_btn_picked_credits": "Generate WEVA report ({n} entries) · 15 credits",
  "journal_weva_btn_30d_credits": "Generate WEVA report (last 30 days) · 15 credits",
  "journal_weva_hint_picked": "WEVA will focus on the entries you ticked and reveal recurring emotions, beliefs and patterns.",
  "journal_weva_hint_30d": "Combines your recent journal entries into a coherent story of emotions, beliefs, and patterns.",
  "journal_weva_history_empty": "No WEVA reports yet — generate your first one to see patterns across your entries.",
  "journal_weva_report_fallback": "Report generated.",
  "journal_journey_title": "Journey with a coach",
  "journal_journey_sub": "Someone who can walk with you through what your entries reveal.",
  "journal_new_entry_a11y": "New journal entry",
  "eva": "WEVA",
  "eva_full_name": "Wellbeing Emotional Vitality Assistant",
  "eva_latest_insight": "Latest WEVA insight",
  "eva_tag_emotions": "Emotions",
  "eva_tag_beliefs": "Beliefs",
  "eva_tag_behaviors": "Behaviours",
  "eva_tag_body": "Body signals",
  "eva_tag_situations": "Situations",
  "eva_tag_themes": "Themes",
  "eva_reflection": "WEVA reflects",
  "picked": "PICKED",
  "goal_voice_hint": "Just speak it out — we'll type for you.",
  "continue": "Continue",
  "more": "more",
  "error": "Error",
  "done": "Done",
  "close": "Close",
  "save": "Save",
  "nav.goals": "Goals",
  "jr_voice_hint": "Just speak — we'll type it for you.",
  "jr_voice_start": "Record voice",
  "jr_voice_stop": "Stop recording",
  "jr_voice_mic_denied": "Microphone access denied. Please allow it in your browser.",
  "jr_tab_entries": "Entries",
  "jr_tab_weva": "WEVA insight",

  "goals_coach_cta_title": "Work on this with a coach",
  "goals_coach_cta_sub": "Find a coach and book to work on this goal together.",


  // --- Epic D (Breathwork client) ---
  "best_for": "Best for",
  "breathwork": "Breathwork",
  "breathwork_insights_sub": "Practice time, achievements, and patterns from your sessions.",
  "breathwork_insights_title": "Insights",
  "breathwork_plan_examples": "Example plans",
  "breathwork_plan_from_coach": "Plan from your coach",
  "breathwork_plan_sub": "Set morning, mid-day, and evening breathing anchors.",
  "breathwork_plan_title": "Your weekly plan",
  "breathwork_start_sub": "Choose an emotion, share context, breathe.",
  "breathwork_start_title": "Start a session",
  "breathwork_subtitle": "Move emotion through the body with breath.",
  "breathwork_techniques_sub": "Browse each technique before you start.",
  "breathwork_techniques_title": "Techniques library",
  "confirm_decline": "Decline",
  "confirm_decline_plan_body": "You can still create your own version any time.",
  "confirm_decline_plan_title": "Decline plan?",
  "confirm_delete_plan_body": "This cannot be undone.",
  "confirm_delete_plan_title": "Delete this plan?",
  "duration_2": "Duration",
  "explanation_how_it_works": "How it works",
  "how_to": "How to",
  "intensity_2": "Intensity",
  "intensity_gentle": "gentle",
  "intensity_intense": "intense",
  "intensity_medium": "medium",
  "lib_session_back_btn": "Back to library",
  "lib_session_note_ph": "What did you notice?",
  "lib_session_note_sub": "A short note for yourself — optional.",
  "lib_session_note_title": "How was your session?",
  "lib_session_start_btn": "Start session",
  "lib_session_wellbeing_sub": "1 = drained, 10 = radiant",
  "lib_session_wellbeing_title": "How do you feel now?",
  "lib_tech_478_body": "The 4-7-8 breath, popularised by Dr. Andrew Weil, is a natural tranquiliser for the nervous system. The long exhale activates the vagus nerve and prepares body and mind for sleep or deep calm.",
  "lib_tech_478_step1": "Exhale fully through the mouth with a soft sound.",
  "lib_tech_478_step2": "Close the mouth, inhale through the nose for 4 seconds.",
  "lib_tech_478_step3": "Hold your breath for 7 seconds.",
  "lib_tech_478_step4": "Exhale slowly through the mouth for 8 seconds.",
  "lib_tech_478_step5": "Do 4 cycles, then rest and observe.",
  "lib_tech_bhramari_body": "Bhramari — the bee breath — uses a soft humming exhale that vibrates the vagus nerve. Deep vagal soothing, ideal for anxiety, insomnia and pre-sleep wind-down.",
  "lib_tech_bhramari_step1": "Sit tall and close your eyes.",
  "lib_tech_bhramari_step2": "Inhale slowly through the nose.",
  "lib_tech_bhramari_step3": "On the exhale hum softly like a bee.",
  "lib_tech_bhramari_step4": "Let the vibration fill your face and chest.",
  "lib_tech_bhramari_step5": "Continue for 6 to 10 rounds.",
  "lib_tech_box_body": "Box breathing is a simple 4-part rhythm that stabilises the nervous system in minutes. Special-forces teams use it before stressful decisions — it's discreet, portable and effective wherever you are.",
  "lib_tech_box_step1": "Inhale through the nose for 4 seconds.",
  "lib_tech_box_step2": "Hold gently with air in for 4 seconds.",
  "lib_tech_box_step3": "Exhale through the mouth for 4 seconds.",
  "lib_tech_box_step4": "Hold empty for 4 seconds.",
  "lib_tech_box_step5": "Repeat the box for 3 to 10 minutes.",
  "lib_tech_coherent_body": "Coherent (5-5) breathing brings breath and heart rhythm into resonance, boosting heart-rate variability. Just 5 minutes shifts you from stress into a calm, focused state — cardiologists recommend it as a daily practice.",
  "lib_tech_coherent_step1": "Inhale gently through the nose for 5 seconds.",
  "lib_tech_coherent_step2": "Exhale gently through the nose for 5 seconds.",
  "lib_tech_coherent_step3": "Keep it soft — no strain, no forcing.",
  "lib_tech_coherent_step4": "Continue for 5 to 20 minutes.",
  "lib_tech_cooling_body": "Sitali — the cooling breath — literally cools body and mind. Ideal for hot moments: anger, agitation, physical heat or menopausal flushes. A summer-friendly yoga classic.",
  "lib_tech_cooling_step1": "Curl your tongue into a tube (or gently purse your lips).",
  "lib_tech_cooling_step2": "Inhale slowly through the mouth over the cool tongue.",
  "lib_tech_cooling_step3": "Close your mouth and exhale gently through the nose.",
  "lib_tech_cooling_step4": "Continue for 3 to 8 minutes.",
  "lib_tech_kapalabhati_body": "Kapalabhati — skull-shining breath — uses sharp exhales and passive inhales to energise body and mind. Great morning wake-up. Skip if lightheaded or during pregnancy.",
  "lib_tech_kapalabhati_step1": "Passive inhales, sharp exhales through the nose.",
  "lib_tech_kapalabhati_step2": "The belly pumps inward with each exhale.",
  "lib_tech_kapalabhati_step3": "Start with 30 pulses — rest — repeat 2 to 3 rounds.",
  "lib_tech_kapalabhati_step4": "Stop immediately if you feel lightheaded.",
  "lib_tech_nadi_shodhana_body": "Alternate-nostril breathing (Nadi Shodhana) balances left and right brain hemispheres and clears mental fog. Traditional yogic technique — takes 5 minutes to shift into clarity.",
  "lib_tech_nadi_shodhana_step1": "Close the right nostril with your thumb and inhale through the left.",
  "lib_tech_nadi_shodhana_step2": "Close the left with your ring finger and exhale through the right.",
  "lib_tech_nadi_shodhana_step3": "Inhale through the right.",
  "lib_tech_nadi_shodhana_step4": "Close the right and exhale through the left.",
  "lib_tech_nadi_shodhana_step5": "That's one round — do 5 to 10 rounds.",
  "lib_tech_ocean_body": "Ujjayi — the ocean breath — creates a soft whisper sound in the throat that anchors attention like waves on a beach. The classic meditation and yoga breath.",
  "lib_tech_ocean_step1": "Slightly constrict the back of your throat.",
  "lib_tech_ocean_step2": "Breathe with a soft, audible ocean-like whisper.",
  "lib_tech_ocean_step3": "Keep it audible only to yourself.",
  "lib_tech_ocean_step4": "Let it be the anchor of your attention.",
  "lib_tech_physiological_sigh_body": "The physiological sigh is the fastest way to release acute stress — a double inhale followed by a long exhale, discovered by Stanford neuroscientist Dr. Andrew Huberman. Works in under a minute.",
  "lib_tech_physiological_sigh_step1": "Take a long slow inhale through the nose.",
  "lib_tech_physiological_sigh_step2": "On top of that, add a second shorter inhale.",
  "lib_tech_physiological_sigh_step3": "Release it all with a long slow exhale through the mouth.",
  "lib_tech_physiological_sigh_step4": "Repeat 1 to 3 times — feel the shift.",
  "lib_tech_wim_hof_body": "The Wim Hof Method combines 30 rapid deep breaths with a breath-hold retention. It floods the system with oxygen and builds resilience. Intense — never practise while driving or in water.",
  "lib_tech_wim_hof_step1": "Take 30 deep breaths — full inhale, let the exhale fall (don't force).",
  "lib_tech_wim_hof_step2": "After #30, exhale and hold as long as it feels comfortable.",
  "lib_tech_wim_hof_step3": "When you need to, inhale deeply and hold 15 seconds.",
  "lib_tech_wim_hof_step4": "Repeat 3 to 4 rounds.",
  "lib_tech_wim_hof_step5": "Stop immediately if you feel unwell — never while driving or in water.",
  "phase_exhale": "Breathe out",
  "phase_hold_in": "Hold",
  "phase_hold_out": "Rest",
  "phase_inhale": "Breathe in",
  "popup_adopted": "Adopted ✓",
  "popup_plan_under_myplans": "The plan is now under ‘My plans’. Open it to adapt or reschedule.",
  "posture_lying": "Lying flat on your back",
  "posture_reclined": "Semi-reclined, supported by a bolster",
  "posture_seated_chair": "Upright in a chair, feet flat",
  "posture_seated_cross": "Seated cross-legged, spine tall",
  "posture_standing": "Standing tall, arms relaxed",
  "recommended_posture": "Recommended posture",
  "session_done_btn": "Done",
  "session_success_body": "That breathing was worth it. Stay in this feeling.",
  "session_success_title": "Well done!",
  "tech_478": "4-7-8 Breathing",
  "tech_478_bestfor": "sleep, anxiety",
  "tech_478_desc": "Inhale 4, hold 7, exhale 8. Calms the nervous system.",
  "tech_478_step1": "Exhale fully through the mouth.",
  "tech_478_step2": "Inhale through the nose for 4 seconds.",
  "tech_478_step3": "Hold for 7 seconds.",
  "tech_478_step4": "Exhale through the mouth for 8 seconds.",
  "tech_478_step5": "Do 4 cycles - then rest.",
  "tech_bhramari": "Bhramari (Bee Breath)",
  "tech_bhramari_bestfor": "vagal tone, calm",
  "tech_bhramari_desc": "Hum on the exhale - vagal soothing.",
  "tech_bhramari_step1": "Sit tall, close your eyes.",
  "tech_bhramari_step2": "Inhale through the nose.",
  "tech_bhramari_step3": "On the exhale, hum like a bee.",
  "tech_bhramari_step4": "Feel the vibration in your face and chest.",
  "tech_bhramari_step5": "Continue for 6–10 rounds.",
  "tech_box": "Box Breathing (4-4-4-4)",
  "tech_box_bestfor": "stress, focus",
  "tech_box_desc": "Equal in / hold / out / hold. A quick reset for stress.",
  "tech_box_step1": "Inhale through the nose for 4 seconds.",
  "tech_box_step2": "Hold for 4 seconds.",
  "tech_box_step3": "Exhale through the mouth for 4 seconds.",
  "tech_box_step4": "Hold empty for 4 seconds.",
  "tech_box_step5": "Repeat for 3–10 minutes.",
  "tech_coherent": "Coherent Breathing (5-5)",
  "tech_coherent_bestfor": "grounding, HRV",
  "tech_coherent_desc": "5s in, 5s out. Anchors heart-rate variability.",
  "tech_coherent_step1": "Inhale gently for 5 seconds.",
  "tech_coherent_step2": "Exhale gently for 5 seconds.",
  "tech_coherent_step3": "Keep it soft - no strain.",
  "tech_coherent_step4": "Continue for 5–20 minutes.",
  "tech_connected": "Connected Breathwork",
  "tech_connected_bestfor": "emotional release",
  "tech_connected_desc": "Circular, no pause. Emotional release; do supported.",
  "tech_connected_learn_more": "Learn about this practice",
  "tech_connected_step1": "Continuous inhale + exhale with no pause.",
  "tech_connected_step2": "Breathe through the mouth or nose.",
  "tech_connected_step3": "Do this only with a trained facilitator or in a well-held space.",
  "tech_connected_step4": "Emotions may arise - that is the point.",
  "tech_cooling": "Cooling breath (Sitali)",
  "tech_cooling_bestfor": "heat, anger, agitation",
  "tech_cooling_desc": "Slow inhale over a curled tongue - releases heat and irritation.",
  "tech_cooling_step1": "Curl your tongue into a tube (or purse the lips).",
  "tech_cooling_step2": "Slow inhale through the mouth over the cool tongue.",
  "tech_cooling_step3": "Close the mouth, exhale gently through the nose.",
  "tech_cooling_step4": "Repeat for 3-8 minutes.",
  "tech_kapalabhati": "Kapalabhati (Skull-shining)",
  "tech_kapalabhati_bestfor": "wakefulness",
  "tech_kapalabhati_desc": "Sharp exhales, passive inhales. Alerting.",
  "tech_kapalabhati_step1": "Passive inhales, sharp exhales through the nose.",
  "tech_kapalabhati_step2": "Belly pumps in on each exhale.",
  "tech_kapalabhati_step3": "Start 30 pulses - rest - repeat 2-3 rounds.",
  "tech_kapalabhati_step4": "Stop if lightheaded.",
  "tech_nadi_shodhana": "Nadi Shodhana (Alt-Nostril)",
  "tech_nadi_shodhana_bestfor": "balance, focus",
  "tech_nadi_shodhana_desc": "Balance left/right hemispheres.",
  "tech_nadi_shodhana_step1": "Close right nostril, inhale through the left.",
  "tech_nadi_shodhana_step2": "Close left, exhale through the right.",
  "tech_nadi_shodhana_step3": "Inhale through the right.",
  "tech_nadi_shodhana_step4": "Close right, exhale through the left.",
  "tech_nadi_shodhana_step5": "That's one round - do 5-10.",
  "tech_ocean": "Ocean Breath (Ujjayi)",
  "tech_ocean_bestfor": "meditation anchor",
  "tech_ocean_desc": "Constrict throat gently - meditative anchor.",
  "tech_ocean_step1": "Slightly constrict the back of your throat.",
  "tech_ocean_step2": "Breathe with a soft ocean-like whisper.",
  "tech_ocean_step3": "Keep it audible only to yourself.",
  "tech_ocean_step4": "Let it be the anchor of your attention.",
  "tech_physiological_sigh": "Physiological Sigh",
  "tech_physiological_sigh_bestfor": "acute stress",
  "tech_physiological_sigh_desc": "Double inhale + long exhale - fastest stress-drop.",
  "tech_physiological_sigh_step1": "Take a long inhale through the nose.",
  "tech_physiological_sigh_step2": "Then a second, smaller inhale on top.",
  "tech_physiological_sigh_step3": "Long slow exhale through the mouth.",
  "tech_physiological_sigh_step4": "Repeat 1–3 times.",
  "tech_practice_guide_only": "Guided practice",
  "tech_practice_guide_only_body": "This technique is a guided practice - follow the steps above. An in-app player for this method is on the way.",
  "tech_wim_hof": "Wim Hof",
  "tech_wim_hof_bestfor": "energy, resilience",
  "tech_wim_hof_desc": "30 deep breaths → retention → recovery. Energizing.",
  "tech_wim_hof_step1": "30 deep breaths - full in, let out (don't force).",
  "tech_wim_hof_step2": "After #30, exhale and hold as long as comfortable.",
  "tech_wim_hof_step3": "Inhale deeply and hold 15 seconds.",
  "tech_wim_hof_step4": "Repeat 3-4 rounds.",
  "tech_wim_hof_step5": "Never do while driving or in water.",
  "technique_not_found": "Technique not found",
  "ui_accept_activate": "Accept & activate",
  "ui_adopt": "Adopt this plan",
  "ui_create_plan": "Create a plan",
  "ui_days": "days",
  "ui_decline": "Decline",
  "ui_min": "min",
  "ui_my_plans": "My plans",
  "ui_no_coach_plans_sub": "When a coach shares a plan with you, it will land here.",
  "ui_no_coach_plans_title": "No coach plans waiting",
  "ui_no_plans_sub": "Create one from scratch or adopt a template.",
  "ui_no_plans_title": "No plans yet",
  "ui_pending_action": "waiting for your reply",
  "ui_sessions": "sessions",
  "ui_slots": "slots",
  "ui_templates_empty_sub": "Refresh, or check your connection.",
  "ui_templates_empty_title": "Couldn't load examples",

  "nav.breathwork": "Breathwork",
  "nav.breakout": "Breakout",


  // --- Epic G+H (Feed + Messages client) ---
  "feed": "Feed",
  "feed_tab_global": "Global",
  "feed_tab_regional": "Regional",
  "feed_tab_interest": "Interest",
  "feed_search_placeholder": "Search title, coach or hashtag…",
  "no_posts_yet": "No posts yet.",
  "loading": "Loading...",
  "coach": "Coach",
  "post_paid_chip": "PAID",
  "post_sponsored_chip": "Sponsored",
  "unlock_credits": "Unlock · {n} credits",
  "paid_locked": "Paid preview",
  "post_book_now": "Book now",
  "post_action_react": "React",
  "post_action_comment": "Comment",
  "post_action_save": "Save",
  "post_action_share": "Share",
  "report_post_title": "Report this post",
  "report_reason_spam": "Spam or misleading",
  "report_reason_inappropriate": "Inappropriate content",
  "report_reason_medical_claim": "Unverified medical claim",
  "report_reason_other": "Other",
  "reported": "Reported. Thank you.",
  "description": "Description",
  "submit": "Submit",
  "reaction_heart": "Heart",
  "reaction_inspired": "Inspired",
  "reaction_moved": "Moved",
  "reaction_strong": "Strong",
  "block_user_cta": "Block this user",
  "chats": "Chats",
  "chats_tab_all": "All",
  "chats_tab_circles": "Circles",
  "chats_tab_direct": "Direct",
  "chats_tab_shared": "Shared",
  "no_conversations": "No conversations yet.",
  "my_circles": "My circles",
  "shared_chats": "Shared coaching chats",
  "direct_messages": "Direct messages",
  "three_way_care": "3-way client care",
  "members": "members",
  "message_deleted": "Message deleted",
  "message": "Message",
  "no_messages_hint": "Send a message to start the conversation.",
  "write_a_message": "Write a message...",
  "delete_message_title": "Delete message?",
  "delete_message_confirm": "This message will be replaced with a “deleted” placeholder for everyone in the chat.",
  "something_went_wrong": "Something went wrong. Please try again.",
  "nav.feed": "Feed",
  "nav.messages": "Messages",
  "feed_comments_title": "Comments",
  "feed_no_comments": "No comments yet. Be the first kind voice.",
  "feed_write_comment": "Write a comment…",
  "feed_add_comment": "Post",
  "feed_unlocked": "Unlocked",
  "feed_open_post": "Open post",
  "feed_credits_needed": "This post costs {n} credits. Top up now?",
  "msg_support": "Support",
  "msg_new_chat": "New message",

  "messages": "Messages",
  "chats_support_btn": "Support",
  "join_by_code": "Have an invitation code?",
  "chats_join_placeholder": "Enter code",
  "join": "Join",
  "chats_invalid_code": "Invalid code",
  "circles_empty_sub": "When a coach invites you to a circle it will appear here.",
  "new_chat_fab_a11y": "Start a new chat",
  "shared_coaching_chat": "Shared coaching chat",
  "shared_chat_banner": "All members can see the messages in this shared chat.",
  "shared_chat_no_access_title": "This chat is private",
  "shared_chat_no_access_body": "Only members of this shared coaching chat can see the messages.",
  "shared_chat_empty": "No messages yet. Start the conversation.",
  "shared_chat_placeholder": "Message everyone …",
  "new_chat_title": "New chat",
  "new_chat": "New chat",
  "new_chat_pick_coach": "Pick a coach",
  "new_chat_pick_second": "Pick a second coach",
  "new_chat_shared_toggle": "Start a shared chat with two coaches",
  "new_chat_search_placeholder": "Search coaches …",
  "new_chat_no_results": "No coaches found.",
  "new_chat_cancel": "Cancel",
  "new_chat_start_btn": "Start chat",
  "new_chat_start_shared_btn": "Start shared chat",
  "new_chat_error_same_coach": "Please pick two different coaches.",
  "post_details": "Post",
  "post_not_found": "Post not found.",
  "comment_sheet_title": "Comments ({n})",
  "comment_empty": "No comments yet. Be the first.",
  "comment_input_placeholder": "Write a comment …",
  "series_progress": "{viewed}/{total} viewed",
  "panic_attack_btn": "Panic attack",
  "panic_attack_btn_sub": "Guided breathing help",
  "panic_picker_title": "Where are you right now?",
  "panic_picker_sub": "Choose the stage that matches — we'll guide you through the right breath.",
  "panic_stage_early_title": "First signs",
  "panic_stage_early_sub": "Inner restlessness, anxiety rising",
  "panic_stage_acute_title": "Acute emergency",
  "panic_stage_acute_sub": "Full panic attack, shortness of breath",
  "panic_stage_subside_title": "Subsiding phase",
  "panic_stage_subside_sub": "Body trembling, pulse slowly dropping",
  "panic_stage_prevent_title": "Prevention",
  "panic_stage_prevent_sub": "Daily life, no acute anxiety",
  "panic_tech_2_4": "2-4 Breathing",
  "panic_tech_pursed": "Pursed-lip breathing · goalkeeper posture",
  "panic_tech_478": "4-7-8 Breathing",
  "panic_tech_diaphragm": "Diaphragmatic breathing",
  "panic_technique_label": "Technique",
  "panic_intro_early_title": "Steady the incoming wave",
  "panic_intro_early_body": "This technique prevents hyperventilation. The extended exhale signals safety to your brain early.",
  "panic_intro_acute_title": "Immediate relief for the lungs",
  "panic_intro_acute_body": "Immediate effect: the lip resistance presses used air out of the lungs and stops the acute shortness of breath.",
  "panic_intro_subside_title": "A natural sedative",
  "panic_intro_subside_body": "Acts like a natural sedative. The long hold and exhale force the cardiovascular system into deep relaxation.",
  "panic_intro_prevent_title": "Train the diaphragm daily",
  "panic_intro_prevent_body": "Trains the diaphragm and sustainably lowers stress levels so the body reacts less intensely in crises.",
  "panic_body_hint_early": "Sit or stand upright. Breathe softly through your nose.",
  "panic_body_hint_acute": "Goalkeeper posture: bend forward slightly, hands on knees, lips softly pursed like blowing a candle.",
  "panic_body_hint_subside": "Sit tall. Press the tip of your tongue behind your upper teeth. Exhale with a soft ‘whoosh'.",
  "panic_body_hint_prevent": "Place one hand on your belly. Let it rise on the inhale, fall on the exhale.",
  "panic_intensity_recap_title": "How intense was your panic?",
  "panic_intensity_scale_hint": "1 = calm, 10 = maximum",
  "panic_intensity_continue": "Continue",
  "panic_analytics_title": "Panic Attack Analytics",
  "panic_analytics_sub": "Your panic response over time.",
  "breathe_easy_btn": "Breathe Easy",
  "breathe_easy_btn_sub": "For COPD & shortness of breath",
  "copd_picker_title": "Which situation matches?",
  "copd_picker_sub": "Choose a technique — we'll guide you step by step.",
  "copd_stage_pursed_title": "Pursed Lip Breathing",
  "copd_stage_pursed_sub": "Acute breathlessness, after exertion",
  "copd_stage_belly_title": "Belly Breathing",
  "copd_stage_belly_sub": "Rest phases, relaxation",
  "copd_stage_contact_title": "Contact Breathing",
  "copd_stage_contact_sub": "Stress, targeted deep ventilation",
  "copd_stage_huff_title": "Huffing",
  "copd_stage_huff_sub": "Stubborn mucus in the airways",
  "copd_stage_acbt_title": "Active Breathing Cycle",
  "copd_stage_acbt_sub": "Daily lung cleansing routine",
  "copd_intro_pursed_title": "Stabilise your airways",
  "copd_intro_pursed_body": "Stabilises your airways and prevents them from collapsing — immediate relief during breathlessness.",
  "copd_intro_belly_title": "More volume, less effort",
  "copd_intro_belly_body": "Uses your diaphragm instead of shallow chest breathing. More volume, less effort.",
  "copd_intro_contact_title": "Hands guide the breath",
  "copd_intro_contact_body": "Your hands guide attention to specific lung areas and deepen your breath.",
  "copd_intro_huff_title": "Move mucus without straining",
  "copd_intro_huff_body": "Moves stubborn mucus upward without straining your airways.",
  "copd_intro_acbt_title": "Relax · Ventilate · Cleanse",
  "copd_intro_acbt_body": "A daily three-phase routine: relax, ventilate, cleanse.",
  "copd_pursed_step1": "Breathe in gently through your nose.",
  "copd_pursed_step2": "Place your lips loosely together — as if about to whistle.",
  "copd_pursed_step3": "Breathe out slowly against the lip resistance. Twice as long as you inhale.",
  "copd_belly_step1": "Sit or lie down comfortably.",
  "copd_belly_step2": "Place one hand on your belly.",
  "copd_belly_step3": "Breathe in — feel your hand rise.",
  "copd_belly_step4": "Breathe out — ideally with pursed lips.",
  "copd_contact_step1": "Place hands flat on your ribs or lower belly.",
  "copd_contact_step2": "As you breathe out, gently assist with your hands.",
  "copd_contact_step3": "As you breathe in, push against your hands.",
  "copd_huff_step1": "Take a deep breath in.",
  "copd_huff_step2": "Open your mouth wide — as if fogging a mirror.",
  "copd_huff_step3": "Push air out in short strong bursts — 'haff' sound.",
  "copd_acbt_p1_body": "Breathe normally and in a relaxed way for a few minutes.",
  "copd_acbt_p2_body": "3–4 deep breaths, hold for 3 seconds each.",
  "copd_acbt_p3_body": "Huff the loosened mucus upward, then gently cough.",
  "copd_step_next": "Next",
  "copd_intensity_title": "How was your breathing?",
  "copd_intensity_scale_hint": "1 = easy, 10 = very hard",
  "copd_intensity_before_short": "Before",
  "copd_intensity_after_short": "Now",
  "copd_intensity_continue": "Continue",
  "copd_analytics_title": "Breathing Analytics",
  "copd_analytics_sub": "Your breathing patterns over time.",
  "posture_coach_title": "Coachman's Seat",
  "posture_coach_sub": "Sit on chair edge, legs apart, elbows on thighs, head relaxed forward.",
  "posture_goalkeeper_title": "Goalkeeper Position",
  "posture_goalkeeper_sub": "Knees slightly bent, lean forward, hands on thighs.",
  "posture_wall_title": "Wall Position",
  "posture_wall_sub": "Lean back or side against a wall.",
  "posture_lay_title": "Lie flat",
  "posture_lay_sub": "On your back, knees slightly bent, head resting to the side.",
  "posture_upright_title": "Sit upright",
  "posture_upright_sub": "Chair edge, feet flat, spine long, shoulders relaxed.",
  "posture_recommended_title": "Your posture",
  "posture_recommended_sub": "Choose the one that feels right for you.",
  "explanation_ready_btn": "I'm ready",
  "analytics_sect_trend": "Weekly trend",
  "analytics_sect_situations": "Situations",
  "analytics_sect_techniques": "Techniques",
  "analytics_sect_postures": "Postures",
  "analytics_sect_timeline": "Timeline",
  "analytics_no_sessions": "No sessions yet.",
  "analytics_no_sessions_sub": "Complete your first guided breathing to see stats here.",
  "analytics_no_data": "No data",
  "analytics_kpi_sessions": "Sessions",
  "analytics_kpi_avg_before": "Avg. before",
  "analytics_kpi_avg_after": "Avg. after",
  "analytics_kpi_reduction": "Avg. reduction",
  "analytics_before_short": "Before",
  "analytics_sec": "s",
  "analytics_stage_early": "First signs",
  "analytics_stage_acute": "Acute emergency",
  "analytics_stage_subside": "Subsiding",
  "analytics_stage_prevent": "Prevention",
  "analytics_tech_pursed_lip": "Pursed lip",
  "analytics_tech_4_7_8": "4-7-8 Breathing",
  "analytics_tech_diaphragmatic": "Diaphragmatic",
  "analytics_tech_belly": "Belly breathing",
  "analytics_tech_contact": "Contact breathing",
  "analytics_tech_huff": "Huffing",
  "analytics_tech_acbt": "Active cycle (ACBT)",
  "analytics_posture_coach": "Coachman seat",
  "analytics_posture_goalkeeper": "Goalkeeper",
  "analytics_posture_wall": "Against wall",
  "analytics_posture_lay": "Lying flat",
  "analytics_posture_upright": "Sitting upright",
  "analytics_posture_none": "No posture",
  "analytics_tech_2_4_breathing": "2-4 Breathing",
  "analytics_tech_pursed": "Pursed lip",
  "settings": "Settings",
  "language": "Language",
  "event_display_pref": "Show events as",
  "by_technique": "Technique",
  "by_emotion": "Emotion",
  "by_base_situation": "Base situation",
  "privacy_and_data": "Privacy & data",
  "upgrade_plan": "Upgrade plan",
  "upgrade_to_coach": "Upgrade to coach account",
  "mode": "Mode",
  "switch_to_coach_view": "Switch to coach view",
  "sign_out": "Sign out",
  "disclaimer": "This app supports emotional self-regulation and does not replace medical, psychological, or emergency care.",
  "download_my_data": "Download my data",
  "gdpr_art20": "Get a copy of everything (GDPR Art. 20)",
  "terms_of_service": "Terms of Service",
  "privacy_policy": "Privacy Policy",
  "refund_policy": "Refund Policy",
  "blocked_users_title": "Blocked users",
  "blocked_users_empty": "You haven't blocked anyone yet.",
  "delete_my_account": "Delete my account",
  "delete_my_account_sub": "Permanent · cascade delete all data",
  "delete_account_confirm_title": "Delete account permanently?",
  "delete_account_confirm_body": "This cannot be undone. All journal, chat and practice data will be erased.",
  "delete_account_confirm_cta": "Delete",
  "need_help_now": "Need help now?",
  "crisis_helplines": "Crisis helplines · emergency numbers",
  "data_sharing": "Data sharing",
  "data_sharing_sub": "Choose what each coach can see",
  "data_sharing_ic_badge": "Inner Circle",
  "data_sharing_n_shared": "{count} shared",
  "data_sharing_none_shared": "Nothing shared",
  "data_sharing_intro": "Toggle exactly what {coachName} can see. You can change this any time.",
  "data_sharing_save": "Save changes",
  "data_sharing_updated": "Updated {when}",
  "data_sharing_none_available_body": "You're not connected to any coach yet. Book a session or join an Inner Circle to start sharing.",
  "profile": "Profile",
  "profile_subtitle": "Your account, coaches, and referral link.",
  "edit_name": "Edit name",
  "email": "Email",
  "phone": "Phone number",
  "country": "Country",
  "country_pick_hint": "Please select your country",
  "contraindications": "Contraindications",
  "contraindications_hint": "We'll skip techniques that may not be safe for you.",
  "weekly_report_title": "Weekly practice email",
  "weekly_report_hint": "A gentle recap of your week every Sunday evening.",
  "saved": "Saved ✓",
  "invite_friends_earn": "Invite friends · earn €5 each",
  "invite_friends_sub": "Both of you get rewarded after their first session",
  "create_account_cta": "Create account",
  "account": "Account",
  "edit_profile": "Edit profile",
  "account_more": "More",
  "account_manage": "Manage account",
  "consent_forms_title": "Consents",
  "consent_forms_sub": "Your signed consent forms.",
  "consent_forms_empty": "No signed forms yet.",
  "consent_signed_on": "Signed on {when}",
  "consent_version": "Version {v}",
  "unblock": "Unblock",
  "bio_label": "About you",
  "export_started": "Your data export is downloading.",
  "delete_code_prompt": "Type the code {code} to confirm permanent deletion:",
  "delete_code_mismatch": "Code did not match. Account was NOT deleted.",
  "profile_account_section": "Account details",
  "profile_health_section": "Health",
  "add": "Add",
  "safety": "Safety",
  "you_re_not_alone": "You're not alone",
  "if_you_are_in_immediate_danger_call": "If you are in immediate danger, call your local emergency number now.",
  "your_country": "Your country",
  "safety_other": "Other…",
  "choose_country": "Choose country",
  "search_country": "Search country…",
  "no_match_try_a_different_name": "No match. Try a different name.",
  "my_within_is_not_a_medical_device_or_a": "My Within is not a medical device or a substitute for professional care. If you're working with a therapist or doctor, please continue to follow their guidance.",
  "help_faq": "Help & FAQ",
  "search_all_help_articles": "Search all help articles…",
  "new_support_request": "New support request",
  "start_a_new_support_chat": "Start a new support chat",
  "your_email": "Your email",
  "you_email_com": "you@email.com",
  "describe_your_issue": "Describe your issue…",
  "suppor_send": "Send",
  "suppor_reply": "Reply…",
  "my_within_ai": "My Within AI",
  "status": "Status",
  "my_within_team": "💬 My Within team",
  "forwarded_to_a_human_reply_arriving_by": "↳ Forwarded to a human - reply arriving by email.",
  "popup_email_required": "Email required",
  "popup_email_for_reply": "Please enter your email so we can reply to you.",
  "this_week": "This week",
  "sessions": "sessions",
  "streak_days": "Streak",
  "avg_drop": "Avg drop",
  "digest_unique_days": "Days practised",
  "digest_avg_duration": "Average duration",
  "digest_biggest_drop": "Biggest shift",
  "digest_top_emotion": "Most felt",
  "digest_top_technique": "Favourite technique",
  "digest_empty_client": "No sessions logged this week — a single breath counts.",
  "digest_email_me": "Email me a copy",
  "digest_hint_client": "Your digest arrives every Sunday evening by email.",
  "digest_sent_title": "Sent to your inbox",
  "digest_sent_body": "Check your email for the full digest.",
  "digest_trend_4w": "Last 4 weeks",
  "friendly_error_title": "Just a moment",
  "coach_earnings_cashable": "Coach earnings (cashable)",
  "coach_earnings_held": "Coach earnings (held)",
  "credits_2": "Credits",
  "no_transactions_yet": "No transactions yet.",
  "purchases_refunds_and_coach_earnings": "Purchases, refunds and coach earnings will appear here.",
  "transaction_history": "Transaction history",
  "abbrechen_und_neu_starten": "Abbrechen und neu starten",
  "bevor_dein_vorteil_aktiviert_wird": "Before your benefit is activated, we'll verify a payment method via Stripe. No money will be charged — just a secure card stored on file.",
  "case_insensitive_format_mw_gefolgt_von": "Case-insensitive · Format: MW- gefolgt von einer kurzen Kombination aus Buchstaben und Zahlen.",
  "dein_code": "Your code",
  "dein_vorteil_wurde_deinem_account": "Your benefit has been credited to your account.",
  "hast_du_unsere_crowdfunding_kampagne": "Did you support our crowdfunding campaign? Enter your pledge code and your benefit will be activated immediately after a quick payment verification.",
  "kein_code_erhalten": "Kein Code erhalten?",
  "mw_xxx_xxxx": "MW-XXX-XXXX",
  "pledge_code_einlo_sen": "Redeem pledge code",
  "support_my_within_com": "support@my-within.com",
  "warte_auf_deine_ru_ckkehr": "Waiting for your return ...",
  "weiter_zur_zahlungsverifizierung": "Weiter zur Zahlungsverifizierung",
  "willkommen_bei_my_within": "Willkommen bei My Within",
  "zuru_ck_zur_startseite": "Back to home",
  "ai_verdict": "AI verdict",
  "become_coach_complete_steps": "Complete both steps below to unlock circles, feed posts, products, and paid subscriptions.",
  "become_coach_full_access": "You have full access to coach monetisation features.",
  "become_coach_rejected": "Please upload a clearer certificate or contact renew@insideoutharmony.com.",
  "become_coach_title": "Become a coach",
  "dpa_accept": "Accept the DPA",
  "dpa_accept_button": "Accept Joint-Controller Agreement",
  "dpa_body": "As a coach, you and Inside Out Harmony e.U. are {joint} of your clients' data under GDPR Art. 26. You agree to only process client data on the platform, never export or copy it externally, and report incidents within 24 hours.",
  "dpa_joint_controllers": "joint controllers",
  "dpa_read_full": "Read the full agreement →",
  "dpa_title": "Joint-Controller Agreement (DPA)",
  "guest_cta_body": "To verify yourself as a coach we need an account with email + password. Afterwards you can upload documents and get started.",
  "guest_cta_title": "First create your account",
  "not_yet_verified": "Not yet verified",
  "once_verified": "Once verified you can:",
  "popup_approved_check": "Approved ✅",
  "popup_couldnt_read_image": "Couldn't read image",
  "popup_error_title": "Something went wrong",
  "popup_submitted": "Submitted",
  "qual_cert_areas": "Accepted areas: breathwork, meditation, mindfulness, yoga therapy, coaching, psychology, therapy, somatic experiencing, and related wellness credentials.",
  "qual_cert_before_verified": "Affiliate referrals work even before verification.",
  "qual_cert_hint": "Upload a clear photo / scan of your coaching, therapy, breathwork, or wellness certification. AI reviews it within seconds. If we can't verify automatically, a human admin reviews it within 48 hours.",
  "qual_cert_reupload": "Re-upload certificate",
  "qual_cert_title": "Qualification certificate",
  "qual_cert_upload": "Upload qualification certificate",
  "qual_cert_upload_short": "Upload certificate",
  "account_help": "Help",
  "account_support": "Support",
  "account_purchases": "Purchase history",
  "account_redeem": "Redeem pledge",
  "help_search_empty": "No results for “{q}”. Try different words or open Support.",
  "purchases_balance": "Balance",
  "weekly_digest_email_toggle": "Weekly digest by email",
  "redeem_needs_payment": "Payment verification required. Please complete it in the mobile app.",
  "redeem_invalid": "Code invalid or already redeemed.",
  "support_resolved": "Resolved",
  "ok": "OK",

  // Breakout (Wave 1 · client parity)
  "breakout": "Breakout",
  "breakout_tab_sub": "A guided path from feeling to relief.",
  "breakout_start_session": "Start a session",
  "breakout_start_sub": "Choose an emotion, share context, breathe.",
  "breakout_how_it_works": "How it works",
  "breakout_step1": "Name the emotion",
  "breakout_step2": "Share the situation",
  "breakout_step3": "Rate intensity 1–10",
  "breakout_step4": "Receive a matched technique",
  "breakout_step5": "Breathe with the guide",
  "breakout_step6": "Rate intensity again",
  "breakout_step7": "Save & review",
  "what_feeling": "What are you feeling?",
  "base_situation": "What's the base situation?",
  "base_situation_hint": "Where does this feeling live?",
  "bs_work": "Work",
  "bs_private": "Private",
  "bs_public": "Public",
  "bs_togetherness": "Togetherness",
  "bs_family": "Family",
  "bs_health": "Health",
  "bs_financial": "Financial",
  "bs_learning": "Learning",
  "bs_other": "Other",
  "how_intense": "How intense is it?",
  "intensity_scale_hint": "1 = barely there · 10 = overwhelming",
  "situation_belief_after_hint": "We'll ask about the situation and your belief after breathing so you can start right away.",
  "try_technique": "Try {name}",
  "how_it_works_row": "How it works",
  "expected": "Expected",
  "duration": "Duration",
  "caution": "Caution",
  "min": "min",
  "begin_breathing": "Begin breathing",
  "step_of": "Step {n} of {total}",

  // Share Cards (Wave 1 · client parity)
  "share_cards_title": "Share cards",
  "sc_tab_all": "All cards",
  "sc_tab_sent": "Sent",
  "sc_filter_all": "All",
  "sc_filter_client": "Client cards",
  "sc_filter_coach": "Coach cards",
  "sc_empty_filter": "No cards in this filter.",
  "sc_empty_sent_head": "No cards shared yet",
  "sc_empty_sent_body": "Once you share a card, it shows up here.",
  "sc_browse": "Browse cards",
  "sc_share_moment": "Share your moment",
  "sc_share_details": "Share more details (emotion, intensity)",
  "sc_your_link": "Your personal link",
  "sc_copy": "Copy",
  "sc_copied": "Link copied",
  "sc_step1": "Click “Copy link”",
  "sc_step2": "Share the card on your channel",
  "sc_step3": "Paste the copied link into your post caption",
  "sc_steps_note": "Only through your link do you earn from the affiliate program.",
  "sc_download": "Download",
  "sc_share": "Share",
  "sc_fine": "When people click your link, they land on the current active-phase landing automatically.",
  "nav.share_cards": "Share cards",

  // Story Wall (Wave 1 · client parity)
  "story_wall_coach_title": "Story Wall",
  "story_wall_coach_sub": "Share moments from your clients' journey — with double consent only.",
  "story_wall_coach_empty": "No moments drafted yet.",
  "story_wall_coach_empty_cta": "Capture your first moment",
  "story_wall_create_title": "Capture a moment",
  "story_wall_client_lbl": "Client",
  "story_wall_kind_lbl": "Kind",
  "story_wall_kind_reflection": "Reflection",
  "story_wall_kind_wellbeing_shift": "Wellbeing",
  "story_wall_kind_streak": "Streak",
  "story_wall_kind_quote": "Quote",
  "story_wall_kind_milestone": "Milestone",
  "story_wall_title_lbl": "Title",
  "story_wall_title_ph": "Short headline — e.g. \\\"From 8 to 3\\\"",
  "story_wall_body_lbl": "Description",
  "story_wall_body_ph": "What happened? Keep it warm, specific and respectful.",
  "story_wall_metric_lbl": "Metric (optional)",
  "story_wall_metric_ph": "e.g. \\\"8 → 3\\\" or \\\"30 days\\\"",
  "story_wall_color_lbl": "Colour accent",
  "story_wall_double_consent_note": "After saving, your client must confirm the exact wording. Only then can you publish.",
  "story_wall_missing_fields": "Please pick a client and write title + description.",
  "story_wall_draft_save": "Save draft",
  "story_wall_publish": "Publish",
  "story_wall_unpublish": "Take off the wall",
  "story_wall_archive": "Delete",
  "story_wall_archive_confirm_title": "Delete this moment?",
  "story_wall_archive_confirm_body": "The record is archived and no longer visible on the Story Wall.",
  "story_wall_status_draft": "Draft",
  "story_wall_status_published": "Live",
  "story_wall_status_unlisted": "Unlisted",
  "story_wall_review": "Edit",
  "story_wall_review_and_agree": "Give consent",
  "story_wall_coach_consent_lbl": "Your consent",
  "story_wall_client_consent_lbl": "Client consent",
  "story_wall_consent_pending": "Pending",
  "story_wall_consent_granted": "Granted",
  "story_wall_consent_waiting_client": "Waiting for client",
  "story_wall_consent_grant": "Yes, publish",
  "story_wall_consent_revoke": "Revoke",
  "story_wall_coach_consent_title": "Your consent",
  "story_wall_coach_consent_body": "Confirm you want this text to appear publicly. You can revoke your consent any time.",
  "story_wall_show_name_lbl": "Show my name",
  "story_wall_show_name_coach_sub": "Default: your name stays private.",
  "story_wall_show_name_client_sub": "Default: only your initial is shown.",
  "story_wall_publish_needs_consents": "Please wait until both parties have agreed.",
  "story_wall_client_title": "Moments awaiting your OK",
  "story_wall_client_sub": "Your coach wants to share these moments. They'll only go public with your consent.",
  "story_wall_client_empty": "No moments waiting for you.",
  "story_wall_client_consent_title": "Are you okay with this?",
  "story_wall_client_consent_sub": "Review the exact wording below. Nothing goes public without your OK.",
  "story_wall_client_consent_thanks_title": "Thank you 🌿",
  "story_wall_client_consent_thanks_body": "Your coach will be notified and can now publish.",
  "story_wall_privacy_note": "We only store what's written above. You can revoke your consent anytime — the moment disappears immediately.",
  "story_wall_grant": "I consent",
  "story_wall_decline": "Decline",
  "story_wall_by_coach": "by {name}",
  "story_wall_by_coach_anonymous": "by a coach",
  "story_wall_browse_public": "Browse the public wall",
  "story_wall_public_title": "Story Wall",
  "story_wall_public_sub": "Real moments from the my-within community — shared with everyone's consent.",
  "story_wall_public_empty": "No public moments yet.",
  "story_wall_filter_all": "All",
  "story_wall_moment_title": "Story moment",
  "story_wall_moment_missing_title": "Moment not found",
  "story_wall_moment_missing_body": "This moment is no longer public or has been revoked.",
  "story_wall_share_title": "Share this moment",
  "story_wall_share_body": "I just discovered this moment on my-within: {title}",
  "story_wall_share_copied": "Link copied",
  "story_wall_share_copied_body": "The link is now on your clipboard.",
  "story_wall_share_cta": "Share",
  "story_wall_share_open_card": "Open fact-card",

  // Story Mode (Wave 1 · client parity)
  "nav.story_wall": "Story Wall",
  "nav.story_mode": "Story Mode",
  "sm_title": "Story Mode",
  "sm_cover_eyebrow": "A private memoir of your months here",
  "sm_cover_title": "The chapters you have kept.",
  "sm_cover_meta": "{entries} entries across {days} days · {chapters} chapters",
  "sm_cover_body": "This is the room your words live in. Nothing here is shared with your coach — this timeline is only for you. Scroll slowly. Read yourself like a book.",
  "sm_empty_title": "Nothing to memoir yet.",
  "sm_empty_body": "A few journal entries, one or two practices — and the first chapter starts writing itself. Come back here in a week or two.",
  "sm_chapter": "Chapter {n}",
  "sm_kind_journal": "Journal",
  "sm_kind_practice": "Practice",
  "sm_kind_breakout": "Breakout",
  "sm_kind_booking": "Session",
  "sm_mood": "mood {a} → {b}",
  "sm_intensity": "intensity {a} → {b}",
  "sm_download_pdf": "Download as PDF",
  "sm_footer_note": "Your story stays with you. The PDF is private, downloaded to this device.",

  // Welle 2 · Client-Extras (Collections · Focus-Timer · Connected-Breath · Method-Player · Unlocked)
  "collections_title": "My collections",
  "collections_empty_title": "No collections yet",
  "collections_empty_sub": "Tap the bookmark icon on any post to start one.",
  "collections_n_posts": "{n} posts",
  "collections_public": "Public",
  "collections_private": "Private",
  "collections_not_found": "This collection doesn't exist anymore.",
  "collections_now_private": "Back to private",
  "collections_now_private_body": "The link no longer works.",
  "collections_now_public": "Collection is public",
  "collections_now_public_body": "Anyone with the link can view.",
  "collections_share_msg": "Check out my '{name}' collection on My Within: {url}",
  "collections_share_again": "Share link",
  "collections_edit_title": "Edit collection",
  "collections_field_name": "Name",
  "collections_field_description": "Description",
  "collections_field_description_ph": "What's this collection about?",
  "collections_field_emoji": "Emoji",
  "collections_field_color": "Colour",
  "collections_empty_folder": "This collection is empty — save posts to fill it.",
  "collections_paid_tag": "Paid",
  "action_failed": "Action failed",
  "post_untitled": "Untitled",
  "focus_timer_title": "Deep Work Timer",
  "focus_timer_preset_classic": "Classic",
  "focus_timer_preset_sprint": "Sprint",
  "focus_timer_preset_extended": "Extended",
  "focus_timer_phase_focus": "Focus",
  "focus_timer_phase_breathing": "Breathe",
  "focus_timer_phase_break": "Break",
  "focus_timer_phase_done": "Done",
  "focus_timer_phase_ready": "Ready",
  "focus_timer_hint_breathing": "Box breathing 4-4-4-4 · reset your nervous system.",
  "focus_timer_hint_break": "Stand up, look away, drink water.",
  "focus_timer_hint_focus": "Deep focus — silence notifications and go.",
  "focus_timer_hint_done": "Well done — {n} sprint(s) complete.",
  "focus_timer_hint_ready": "Pick a preset and start — a breathing pause runs after each sprint.",
  "focus_timer_completed_sprints": "{n} sprint(s) complete",
  "focus_timer_start": "Start",
  "focus_timer_start_next": "Start next sprint",
  "focus_timer_finish": "Finish",
  "focus_timer_pause": "Pause",
  "focus_timer_resume": "Resume",
  "focus_timer_reset": "Reset",
  "focus_timer_tip": "Tip: put your phone face-down. The screen stays awake so you can glance at the pacer during the breathing pause.",
  "breath_inhale": "Inhale",
  "breath_exhale": "Exhale",
  "breath_hold_in": "Hold",
  "breath_hold_out": "Rest",
  "connected_intro_title": "Connected Breathing",
  "connected_intro_body": "A deep-release practice — read this fully before ever trying it.",
  "connected_what_it_is": "What it is",
  "connected_what_body": "A continuous, circular breath — no pauses between inhale and exhale — sustained for 30–60 minutes. Often through the mouth, in a lying position.",
  "connected_how_works": "How it works",
  "connected_how_body": "The sustained pattern shifts blood chemistry and lowers the guard of the thinking mind. Held emotions, memories and body states can rise to the surface.",
  "connected_benefits": "What it can offer",
  "connected_benefits_body": "Emotional release, insight, a felt sense of integration, and sometimes a very expanded state. It's a big practice — treat it with respect.",
  "connected_safety": "Only with an experienced facilitator",
  "connected_safety_body": "This is not a solo practice. Do not attempt it alone, driving, in water, on medication that affects the nervous system, during pregnancy, with severe heart or lung conditions, or with an untreated trauma history. Always work with a trained facilitator who can hold the space, spot dysregulation, and support integration.",
  "connected_facilitator_only": "No in-app player is provided — by design.",
  "connected_close": "Understood",
  "mp_load_failed": "Failed to load",
  "mp_by": "by",
  "mp_auto_chain": "Auto-advance",
  "mp_start": "Start",
  "mp_pause": "Pause",
  "mp_next_in": "Next in",
  "mp_next_step": "Next block",
  "mp_finish": "Done · leave feedback",
  "mp_chain_cancel": "Stop auto-advance",
  "mp_disclaimer": "This exercise is a coaching offer and does not replace medical diagnosis or psychotherapy. For acute distress, please consult a professional.",
  "mp_fb_title": "How was the session?",
  "mp_fb_sub": "Your coach will see your short pulse.",
  "mp_fb_note_ph": "Optional: what felt particularly good?",
  "mp_fb_skip": "Skip",
  "mp_fb_send": "Send",
  "cm_q_required": "Required",
  "unlocked_title": "Unlocked",
  "unlocked_sub": "Your purchased and gifted methods",
  "unlocked_empty": "Nothing unlocked yet. When your coach gifts you a method or you buy one, it appears here.",
  "unlock_src_gift": "Gift",
  "unlock_src_paid": "Purchased",
  "unlock_src_public": "Public",
  "unlocked_posts_title": "My unlocked posts",
  "unlocked_posts_sub": "Paid feed posts from your coaches",
  "unlocked_posts_empty_title": "No posts unlocked yet",
  "unlocked_posts_empty_body": "When you unlock a paid post in the feed, it will appear here.",
  "unlocked_posts_go_feed": "Open feed",
  "nav.collections": "Collections",
  "nav.focus_timer": "Focus Timer",
  "nav.connected_breath": "Connected Breath",
  "nav.unlocked_methods": "Unlocked",
  "nav.unlocked_posts": "Unlocked posts",

  // Welle 2 · Methoden-Kind-Labels (Method-Player / Unlocked)
  "method_kind_audio": "Audio",
  "method_kind_video": "Video",
  "method_kind_breathwork": "Breathwork",
  "method_kind_questions": "Questions",
  "method_kind_combo": "Combo",
  "method_kind_body_scan": "Body Scan",
  "method_kind_gratitude": "Gratitude",
  "method_kind_visualization": "Visualization",
  "method_kind_movement": "Movement",
  "method_kind_check_in": "Check-In",
  "method_kind_journal": "Journal",

  // Welle 3 · Collab-Marketplace + Snapshot-Anfragen + Blockierte Nutzer
  "client_collab_title": "Collab Area",
  "client_collab_subtitle": "Everything about your coach collaborations",
  "client_collab_tile_chats_title": "My Collab Chats",
  "client_collab_tile_chats_sub": "All ongoing coach chats",
  "client_collab_tile_offerings_title": "Buy Collab Offerings",
  "client_collab_tile_offerings_sub": "Discover coach duos & groups to book",
  "client_collab_tile_projects_title": "My active projects",
  "client_collab_tile_projects_sub": "Offerings & circles you're part of",
  "client_collab_tile_discover_title": "Discover Collab Coaches",
  "client_collab_tile_discover_sub": "Coach pairs with joint offerings",
  "client_collab_tile_reviews_title": "My Reviews",
  "client_collab_tile_reviews_sub": "Rate completed projects",
  "client_collab_discover_title": "Discover Collab Coaches",
  "client_collab_discover_sub": "Coach pairs & groups with joint offerings",
  "client_collab_discover_empty": "No coach pairs with Collab offerings right now.",
  "client_collab_discover_offerings": "Joint offerings",
  "client_collab_discover_circles": "Collab Circles",
  "starter_card_eyebrow": "First time? Try this",
  "starter_card_eyebrow_matched": "Matches your most-felt · {emotion}",
  "starter_card_a11y": "Try a sample collab package",
  "client_collab_offerings_title": "Buy Collab Offerings",
  "client_collab_offerings_sub": "Coach duos & groups you can book",
  "client_collab_offerings_empty": "No Collab offerings available right now.",
  "client_collab_included_unlimited": "Ultimate",
  "client_collab_included_msgs": "msgs",
  "client_collab_included_calls": "Calls",
  "client_collab_included_live": "Live",
  "client_collab_already_bought": "Purchased",
  "client_collab_buy_cta": "Buy",
  "client_collab_purchase_confirm_title": "Confirm purchase",
  "client_collab_purchase_confirm_body": "{title} for {price}?",
  "client_collab_pay_credits": "Pay with {n} credits",
  "client_collab_purchase_success_title": "Purchased!",
  "client_collab_purchase_success_body": "You can now chat with {coaches}.",
  "client_collab_purchase_fail_body": "Purchase failed.",
  "client_collab_purchase_credits_short": "You need {need} credits but have only {have}.",
  "client_collab_projects_title": "My active projects",
  "client_collab_projects_sub": "Offerings & circles you're part of",
  "client_collab_projects_empty": "No active Collab projects yet.",
  "client_collab_kind_circle": "Circle",
  "client_collab_kind_offering": "Offering",
  "client_collab_kind_shared": "Multi",
  "client_collab_reviews_title": "My Collab Reviews",
  "client_collab_reviews_sub": "One rating per coach per project",
  "client_collab_reviews_empty": "No completed projects to review yet.",
  "client_collab_review_add": "Rate now",
  "client_collab_review_saved": "Review saved",
  "client_collab_review_editor_title": "Rate {coach}",
  "client_collab_review_comment_ph": "A few words (optional)…",
  "client_collab_review_submit": "Save review",
  "client_collab_chats_title": "My Collab Chats",
  "client_collab_chats_sub": "All chats with your coaches",
  "client_collab_chats_empty": "No Collab chats yet. Buy a Collab offering to get started.",
  "client_collab_no_messages": "No messages yet",
  "client_collab_project_not_found": "Project not found",
  "client_collab_project_coaches": "Your coaches",
  "client_collab_project_about": "About this project",
  "client_collab_project_chat": "Chat",
  "client_collab_project_open_chat": "Open chat with your coaches",
  "client_collab_project_chat_soon": "Chat available after first activity.",
  "client_collab_project_sessions": "Sessions",
  "client_collab_project_sessions_empty": "No sessions scheduled yet.",
  "client_collab_project_documents": "Materials",
  "client_collab_project_documents_empty": "No materials shared yet.",
  "client_collab_project_tasks": "Tasks",
  "client_collab_project_tasks_empty": "No to-dos for you right now.",
  "session": "Session",
  "week": "week",
  "month": "month",
  "total": "total",
  "document": "Document",
  "open_report": "Open report",
  "snapshot_requests_inbox": "Snapshot requests",
  "snapshot_requests_none": "You don't have any snapshot requests right now.",
  "snapshot_requests_from": "From {coach}",
  "snapshot_requests_period": "Last {days} days",
  "snapshot_requests_approve": "Approve & share",
  "snapshot_requests_decline": "Decline",
  "snapshot_requests_help": "Approving generates a fresh WEVA report from your last {days} days and shares it only with this coach.",
  "snapshot_requests_status_pending": "Pending",
  "snapshot_requests_status_approved": "Shared",
  "snapshot_requests_status_approved_no_data": "Approved (no data)",
  "snapshot_requests_status_declined": "Declined",
  "snapshot_approved_toast": "Snapshot shared with your coach ✨",
  "snapshot_declined_toast": "Declined — nothing was shared.",
  "snapshot_no_data_msg": "You have no data in the selected window. Practice something first, then approve again.",
  "popup_approve_failed": "Approve failed",
  "blocked_at": "Blocked on",
  "unblock_cta": "Unblock",
  "nav.snapshot_requests": "Snapshot requests",
  "nav.blocked_users": "Blocked users",
  "circle_news_just_now": "just now",
  "nav.collab_area": "Collab area",
  "discover_strip_title": "Discover",
  "discover_strip_sub": "New extras for you",
  "discover_strip_new": "New",

  "nav.assistant": "AI Practice Assistant",
  "support": "Support",
  "aipa.title": "AI Practice Assistant",
  "aipa.subtitle": "Your proactive assistant for everyday practice.",
  "aipa.upsell_headline": "More time for your clients",
  "aipa.upsell_sub": "Your AI assistant prepares a briefing every morning, prioritizes tasks, drafts messages and automates routines — you stay in control.",
  "aipa.feature_briefing": "Daily briefing",
  "aipa.feature_briefing_desc": "A clear overview of clients, appointments and priorities every morning.",
  "aipa.feature_tasks": "Task manager",
  "aipa.feature_tasks_desc": "Prioritize, delegate to the AI and keep track of your history.",
  "aipa.feature_chat": "Assistant chat",
  "aipa.feature_chat_desc": "Ask about your practice and get concrete answers.",
  "aipa.feature_workflows": "Automatic workflows",
  "aipa.feature_workflows_desc": "The assistant handles recurring routines — with your approval.",
  "aipa.price_line": "€{price} / month",
  "aipa.trial_note": "7 days free · cancel anytime",
  "aipa.start_trial": "Start 7-day free trial",
  "aipa.start_sub": "Subscribe now",
  "aipa.starting": "Redirecting to checkout…",
  "aipa.consent_hint": "Then €20/month, renews automatically until canceled.",
  "aipa.checkout_error": "Couldn't start just now. Please try again.",
  "aipa.status_trial": "Trial",
  "aipa.status_active": "Active",
  "aipa.status_canceled": "Canceled",
  "auth.cb_success": "Successfully signed in!",
  "auth.cb_failed": "Google sign-in failed. Please try again.",
  "auth.cb_completing": "Completing sign-in …",
  "nf.meta": "Page not found",
  "nf.title": "This page doesn't exist.",
  "nf.body": "Maybe you'll find what you're looking for on our marketplace.",
  "nf.home": "Home",
  "aipa.card_ready": "Your assistant is ready. Open it for today's briefing.",
  "aipa.card_open_tasks": "Open tasks",
  "aipa.card_needs_attention": "Needs attention",
  "aipa.card_to_approve": "To approve",
  "aipa.card_setup_step": "Just one more step: set up your assistant so it prepares for you each morning.",
  "aipa.card_pitch": "Your proactive assistant: daily briefing, tasks, automatic follow-ups & nudges — you stay in control.",
  "aipa.card_try_free": "Try 7 days free",
  "notif.seo": "Notifications",
  "ads.seo": "Coach · Advertising",
  "an.seo": "Coach · Analytics",
  "bk.seo": "Coach · Bookings",
  "cd.seo": "Coach · Client",
  "win.seo": "Coach · Client wins",
  "cc.seo": "Coach · Circles",
  "cs.seo": "Coach · Setup",
  "col2.seo": "Coach · Collectives",
  "cf.seo": "Coach · Consents",
  "soc.seo": "Coach · Social",
  "help.seo": "Coach · Help",
  "ici.seo": "Coach · Inner Circle invites",
  "cm.seo": "Coach · Methods",
  "off.seo": "Coach · Offerings",
  "pl.seo": "Coach · Plans",
  "pon.seo": "Coach · Professional profile",
  "prof.seo": "Coach · Profile",
  "recs.seo": "Coach · Recommendations",
  "ref.seo": "Coach · Refer",
  "cset.seo": "Coach · Settings",
  "sup.seo": "Coach · Support",
  "tour.seo": "Coach · Tour",
  "upg.seo": "Coach · Upgrade",
  "verify.seo": "Coach · Verification",
  "aipa.seo": "Coach · AI practice assistant",
  "cbr.seo": "Coach · Branding",
  "chk.seo": "Coach · Check-in template",
  "cred.seo": "Coach · Credits",
  "refpol.seo": "Coach · Cancellation & refund",
  "resch.seo": "Coach · Rescheduling",
  "wdig.seo": "Coach · Weekly digest",
  "common.copied": "Copied",
  "open": "Open",
  "ads.topup_custom_ph": "e.g. 75",
  "ads.ph_themes": "breathwork, boundaries…",
  "ads.ph_regions": "EU, DE-Berlin…",
  "ads.ph_education_backgrounds": "Coaching training…",
  "ads.ph_life_situations": "Self-employed, young parents…",
  "ads.ph_other_traits": "Early risers, ADHD…",
  "aipa.renews_on": "Renews on {date}",
  "aipa.trial_until": "Trial until {date}",
  "aipa.canceled_until": "Active until {date}",
  "aipa.wizard_title": "Set up assistant",
  "aipa.wizard_intro": "Just a few steps and your assistant is ready.",
  "aipa.step_label": "Step {n} of {total}",
  "aipa.step_language": "Language",
  "aipa.step_language_desc": "Which language should the assistant write in?",
  "aipa.lang_label": "Assistant language",
  "aipa.step_briefing": "Daily briefing",
  "aipa.step_briefing_desc": "When should your briefing be ready?",
  "aipa.briefing_time": "Briefing time",
  "aipa.show_on_login": "Show briefing at login",
  "aipa.step_autonomy": "Autonomy",
  "aipa.step_autonomy_desc": "Decide what the assistant may do on its own and what you confirm.",
  "aipa.step_workflows": "Workflows",
  "aipa.step_workflows_desc": "Enable the routines that should support you.",
  "aipa.step_outlook": "Outlook",
  "aipa.step_outlook_desc": "Connect calendar and mail (optional).",
  "aipa.outlook_calendar": "Outlook calendar",
  "aipa.outlook_mail": "Outlook mail",
  "aipa.outlook_not_connected": "Not connected yet — the assistant uses your app data in the meantime.",
  "aipa.step_groups": "Group filter",
  "aipa.step_groups_desc": "Which circles should the assistant focus on? Empty = all.",
  "aipa.groups_all": "All circles",
  "aipa.groups_empty": "No circles yet.",
  "aipa.back": "Back",
  "aipa.next": "Next",
  "aipa.finish_setup": "Finish setup",
  "aipa.saving": "Saving…",
  "aipa.setup_done_toast": "Your assistant is ready!",
  "aipa.lvl_confirm": "Confirm",
  "aipa.lvl_auto": "Automatic",
  "aipa.lvl_never": "Never",
  "aipa.auto.message_clients": "Message clients",
  "aipa.auto.appointment_reminders": "Appointment reminders",
  "aipa.auto.outlook_events": "Create Outlook events",
  "aipa.auto.weekly_plan_reminders": "Weekly plan reminders",
  "aipa.auto.post_drafts": "Post drafts",
  "aipa.auto.mail_replies": "Mail replies",
  "aipa.auto.auto_tasks": "Create tasks automatically",
  "aipa.wf.daily_briefing": "Daily briefing",
  "aipa.wf.weekly_summary": "Weekly summary",
  "aipa.wf.weekly_plan_reminder": "Weekly plan reminder",
  "aipa.wf.birthday_greetings": "Birthday greetings",
  "aipa.wf.session_followup": "Session follow-up",
  "aipa.wf.inactive_clients": "Inactive clients",
  "aipa.wf.post_draft_on_theme": "Post draft on themes",
  "aipa.wf.appointment_confirmations": "Appointment confirmations",
  "aipa.wf.mail_reply_drafts": "Mail reply drafts",
  "aipa.tab_briefing": "Briefing",
  "aipa.tab_tasks": "Tasks",
  "aipa.tab_agenda": "Agenda",
  "aipa.tab_chat": "Chat",
  "aipa.tab_settings": "Settings",
  "aipa.briefing_title": "Your daily briefing",
  "aipa.briefing_generate": "Create briefing",
  "aipa.briefing_generating": "Creating briefing…",
  "aipa.briefing_regenerate": "Recreate",
  "aipa.briefing_empty": "No briefing for today yet. Create your first one now.",
  "aipa.briefing_clients": "Clients",
  "aipa.briefing_attention": "Needs attention",
  "aipa.briefing_calendar": "Calendar",
  "aipa.briefing_tasks": "Tasks",
  "aipa.briefing_comm": "Communication suggestions",
  "aipa.briefing_posts": "Post ideas",
  "aipa.briefing_add_task": "As task",
  "aipa.copy": "Copy",
  "aipa.copied": "Copied",
  "aipa.generated_at": "Created {date}",
  "aipa.tasks_title": "Tasks",
  "aipa.tasks_empty": "No open tasks. Well done!",
  "aipa.task_title_ph": "New task…",
  "aipa.task_desc_ph": "Description (optional)",
  "aipa.task_priority": "Priority",
  "aipa.task_add": "Add",
  "aipa.task_adding": "Adding…",
  "aipa.prio.urgent": "Urgent",
  "aipa.prio.important": "Important",
  "aipa.prio.normal": "Normal",
  "aipa.prio.later": "Later",
  "aipa.task_done": "Done",
  "aipa.task_delegate": "Delegate to AI",
  "aipa.task_delegating": "Delegating…",
  "aipa.task_delete": "Delete",
  "aipa.task_ai_result": "AI result",
  "aipa.task_history": "Show history",
  "aipa.task_history_hide": "Hide history",
  "aipa.task_export": "CSV export",
  "aipa.agenda_title": "Today's agenda",
  "aipa.agenda_events": "Appointments",
  "aipa.agenda_no_events": "No appointments today.",
  "aipa.agenda_recurring": "Recurring",
  "aipa.agenda_recurring_empty": "No recurring entries yet.",
  "aipa.agenda_outlook_on": "Outlook connected",
  "aipa.agenda_outlook_off": "Outlook not connected",
  "aipa.recurring_add": "Add entry",
  "aipa.recurring_title_ph": "Title (e.g. team call)",
  "aipa.recurring_time": "Time",
  "aipa.recurring_save": "Save",
  "aipa.wd.0": "Mon",
  "aipa.wd.1": "Tue",
  "aipa.wd.2": "Wed",
  "aipa.wd.3": "Thu",
  "aipa.wd.4": "Fri",
  "aipa.wd.5": "Sat",
  "aipa.wd.6": "Sun",
  "aipa.chat_title": "Assistant chat",
  "aipa.chat_ph": "Ask your assistant…",
  "aipa.chat_send": "Send",
  "aipa.chat_empty": "Ask a question about your practice.",
  "aipa.chat_clear": "Clear history",
  "aipa.chat_thinking": "Thinking…",
  "aipa.settings_title": "Settings",
  "aipa.settings_saved": "Settings saved.",
  "aipa.save": "Save",
  "aipa.cancel_package": "Cancel package",
  "aipa.cancel_confirm": "Really cancel the package? You keep access until the end of the period.",
  "aipa.canceling": "Canceling…",
  "aipa.cancel_done": "Package canceled.",
  "aipa.tab_automation": "Automation",
  "aipa.automation_title": "Autonomous workflows",
  "aipa.automation_desc": "The assistant runs your enabled routines. Actions set to “Automatic” run without asking; “Confirm” creates a task for your approval.",
  "aipa.run_now": "Run now",
  "aipa.running": "Running…",
  "aipa.run_done": "{auto} automatic · {pending} to approve",
  "aipa.activity_title": "Recent activity",
  "aipa.activity_empty": "No activity yet. Enable workflows in settings and run them here.",
  "aipa.mode_auto": "Automatic",
  "aipa.mode_pending": "To approve",
  "guide.ui.step": "Step {x} of {y}",
  "guide.ui.next": "Next",
  "guide.ui.done": "Done",
  "guide.ui.later": "Later",
  "guide.ui.not_now": "Not now",
  "guide.ui.close": "Close",
  "guide.bar.title": "Your start as a coach",
  "guide.bar.subtitle": "A few warm steps and you're all set.",
  "guide.bar.progress": "{done} of {total} done",
  "guide.bar.hide": "Hide for now",
  "guide.bar.reopen": "Setup guide",
  "guide.status.done": "Done",
  "guide.status.skipped": "Skipped",
  "guide.status.open": "Open",
  "guide.complete.title": "All set — wonderful!",
  "guide.complete.body": "You've completed your starting path. Your space is ready to welcome and guide people on their journey. So glad you're here.",
  "guide.complete.cta": "Let's go",
  "guide.theme.profile.label": "Profile",
  "guide.theme.offering.label": "Offering",
  "guide.theme.circle.label": "Circle",
  "guide.theme.availability.label": "Availability",
  "guide.theme.payments.label": "Payments",
  "guide.theme.post.label": "Post",
  "guide.theme.method.label": "Method",
  "guide.theme.weekly_plan.label": "Weekly plan",
  "guide.theme.calendar.label": "Calendar",
  "guide.theme.discover.label": "Discover",
  "guide.theme.profile.title": "Show yourself — your profile",
  "guide.theme.profile.cta": "Go to profile",
  "guide.theme.profile.step1": "Let's start with you. This is your personal profile — the first impression for people who find you.",
  "guide.theme.profile.step2": "Upload a warm photo of yourself. A real face builds trust right away.",
  "guide.theme.profile.step3": "Add your name — the way you'd like to be called.",
  "guide.theme.profile.step4": "Share in a few sentences who you are and what you care about. No jargon needed.",
  "guide.theme.profile.step5": "Save your profile — done! You can change it anytime.",
  "guide.theme.offering.title": "Your first offering",
  "guide.theme.offering.cta": "Go to offerings",
  "guide.theme.offering.step1": "Here you define how you support people — for example a one-on-one session or a small package.",
  "guide.theme.offering.step2": "Create an offering that fits you. Once it's saved, we'll check this step off for you.",
  "guide.theme.circle.title": "Your own circle",
  "guide.theme.circle.cta": "Go to circles",
  "guide.theme.circle.step1": "A circle is your space for community — where the people you guide come together.",
  "guide.theme.circle.step2": "Create your first circle. You decide how open or protected it should be.",
  "guide.theme.availability.title": "Your hours",
  "guide.theme.availability.cta": "Go to availability",
  "guide.theme.availability.step1": "So people can book with you, set your available times here.",
  "guide.theme.availability.step2": "Add when you're there for sessions. Once you save, this step is done.",
  "guide.theme.payments.title": "Set up payments",
  "guide.theme.payments.cta": "Connect Stripe",
  "guide.theme.payments.step1": "So your fee reaches you safely, we connect your account with our payment partner.",
  "guide.theme.payments.step2": "Connect securely with Stripe. It only takes a few minutes — we'll guide you step by step.",
  "guide.theme.post.title": "Your first post",
  "guide.theme.post.cta": "Go to the feed",
  "guide.theme.post.step1": "A post shows what moves you — a thought, an invitation, a spark.",
  "guide.theme.post.step2": "Share your first post. Once it's published, we'll check this step off.",
  "guide.theme.method.title": "Your method",
  "guide.theme.method.cta": "Go to methods",
  "guide.theme.method.step1": "A method is a small exercise or guide you share with people.",
  "guide.theme.method.step2": "Create your first method. It gets checked off automatically once saved.",
  "guide.theme.weekly_plan.title": "A weekly plan",
  "guide.theme.weekly_plan.cta": "Go to weekly plans",
  "guide.theme.weekly_plan.step1": "With a weekly plan you support people day by day — gently and with structure.",
  "guide.theme.weekly_plan.step2": "Create a plan and assign it to someone. Then this step is done.",
  "guide.theme.calendar.title": "Your calendar",
  "guide.theme.calendar.cta": "Connect calendar",
  "guide.theme.calendar.step1": "Connect your Outlook calendar so appointments line up automatically. Not required — you can do this later too.",
  "guide.theme.discover.title": "Discover your space",
  "guide.theme.discover.cta": "Go to dashboard",
  "guide.theme.discover.step1": "Finally, a little tour. This is your dashboard — your home in the app.",
  "guide.theme.discover.step2": "Here you see the pulse of your people — how they're doing right now.",
  "guide.theme.discover.step3": "In messages you stay in personal, direct contact.",
  "guide.theme.discover.step4": "In your circles, community and exchange come to life.",
  "guide.theme.discover.step5": "And here you'll find your account and all settings. That's it — enjoy!",
  // === iter273 i18n · wave 1 (CoachHome, CoachCircles) ===
  "ch.welcome": "Welcome back",
  "ch.default_name": "Coach",
  "ch.setup_title": "Coach setup · {done}/{total} done",
  "ch.setup_sub": "Complete the 4 steps and secure your Founding Coach badge.",
  "ch.stat_circles": "Circles",
  "ch.stat_upcoming": "Upcoming bookings",
  "ch.wq_upcoming": "Upcoming sessions",
  "ch.wq_unread": "Unread messages",
  "ch.wq_pending": "Needs attention",
  "ch.wq_next_sessions": "Your next sessions",
  "ch.wq_no_sessions": "No upcoming sessions.",
  "ch.wq_view_all": "View all",
  "ch.wq_session": "Session",
  "ch.stat_credits": "Credits",
  "ch.aff_title": "Your affiliate link",
  "ch.aff_hint": "Share it — you earn on every referral.",
  "ch.aff_copied": "Affiliate link copied",
  "ch.area_title": "Your coach area",
  "ch.areas_count": "{n} areas",
  "ch.gross_title": "Total revenue (all bookings)",
  "ch.g_start": "Start",
  "ch.g_circles": "Circles",
  "ch.g_sell": "Sell",
  "ch.g_grow": "Growth",
  "ch.g_account": "Account",
  "ch.g_affiliate": "Affiliate",
  "ch.i_feed": "Feed",
  "ch.i_messages": "Messages",
  "ch.i_notifications": "Notifications",
  "ch.i_circles": "Circles",
  "ch.i_inner": "Inner Circle",
  "ch.i_mein": "My Circle",
  "ch.i_pulse": "Client Pulse",
  "ch.i_assistant": "AI Practice Assistant",
  "ch.i_ads": "Ads",
  "ch.i_recommendations": "Recommendations",
  "ch.i_content": "Social & Content",
  "ch.i_consent": "Consent forms",
  "ch.i_client_wins": "Client wins",
  "ch.i_collectives": "Collectives",
  "ch.i_settings": "Settings",
  "ch.i_billing": "Billing & plans",
  "ch.i_upgrade": "Coach Pro",
  "ch.i_support": "Support & help",
  "ch.i_aff_link": "Refer & affiliate link",
  "ch.i_aff_offerings": "Affiliate offerings",
  "ch.i_aff_payouts": "Payouts",
  "ch.s_feed": "Global & regional feed.",
  "ch.s_messages": "Direct messages & circle chats.",
  "ch.s_notifications": "All your alerts at a glance.",
  "ch.s_circles": "Inner & Local Circle overview.",
  "ch.s_inner": "Set subscription plan, perks & pricing.",
  "ch.s_mein": "Configure add-on subscriptions in detail.",
  "ch.s_pulse": "Silent clients & warning signs.",
  "ch.s_offerings": "Sessions, packages, affiliate & pricing.",
  "ch.s_bookings": "Sessions, cancellations & refunds.",
  "ch.s_earnings": "Revenue, payouts & taxes.",
  "ch.s_availability": "Open & close weekly slots.",
  "ch.s_assistant": "Your autonomous coaching assistant.",
  "ch.s_analytics": "12-tile deep dive: growth & reports.",
  "ch.s_ads": "Campaigns, audience AI & credits.",
  "ch.s_recommendations": "Post impact & warm referrals.",
  "ch.s_collab": "Network, projects & joint offerings.",
  "ch.s_content": "Posts, planner, stories & WEVA.",
  "ch.s_methods": "Build exercises: audio, video, combo.",
  "ch.s_plans": "Share daily plans & weekly breathwork.",
  "ch.s_profile": "Public profile, bio & branding.",
  "ch.s_verify": "Upload qualifications & status.",
  "ch.s_consent": "Consent forms & signatures.",
  "ch.s_client_wins": "AI suggestions for success stories.",
  "ch.s_collectives": "Coach alliances with shared revenue.",
  "ch.s_settings": "Cancellation policy, rebookings, branding.",
  "ch.s_billing": "Credits, platform plan & AI assistant.",
  "ch.s_upgrade": "Upgrade: 10% commission, branding & more.",
  "ch.s_support": "Tickets to the team, FAQ & tour.",
  "ch.s_aff_link": "Share your link & earn along.",
  "ch.s_aff_offerings": "Promote external products.",
  "ch.s_aff_payouts": "Commissions & payouts.",
  "cc.title": "Circles",
  "cc.subtitle": "Your companionship spaces in one place — Inner Circle, My Circle, Local and the Client Pulse.",
  "cc.card_inner_sub": "Your exclusive companionship",
  "cc.card_mein_sub": "Individual, guided circles",
  "cc.card_local_sub": "Your free community",
  "cc.card_pulse_sub": "Keep engagement in view",
  "cc.your_circles": "Your circles",
  "cc.new_circle": "New circle",
  "cc.empty": "No circles yet. Create your first circle.",
  "cc.archived": "Archived",
  "cc.actions": "Circle actions",
  "cc.rename": "Rename",
  "cc.archive": "Archive",
  "cc.restore": "Restore",
  "cc.delete": "Delete",
  "cc.health_line": "{total} members · {msgs} msgs/7d · {active} active",
  "cc.health_active": "Active",
  "cc.health_quiet": "Quiet",
  "cc.health_silent": "Silent",
  "cc.copy_code": "Copy invite code",
  "cc.code_copied": "Code copied",
  "cc.my_clients": "My clients",
  "cc.no_clients": "No clients without a circle right now.",
  "cc.client": "Client",
  "cc.rename_title": "Rename circle",
  "cc.rename_desc": "Give the circle a new name. All members will see the updated name.",
  "cc.rename_ph": "Circle name",
  "cc.cancel": "Cancel",
  "cc.save": "Save",
  "cc.renamed": "Circle renamed",
  "cc.name_short": "Name is too short (min. 2 characters)",
  "cc.archived_toast": "Circle archived",
  "cc.restored_toast": "Circle restored",
  "cc.delete_title": "Delete circle “{name}”?",
  "cc.delete_desc": "This action cannot be undone. The circle and all its messages, announcements and activity will be permanently deleted.",
  "cc.delete_confirm": "Delete permanently",
  "cc.deleted": "Circle deleted",
  "cc.kind_local": "LOCAL",
  "cc.kind_individual": "My Circle",
  "cc.kind_inner": "Inner Circle",
  // === iter273 i18n · wave 2 (Billing, Membership) ===
  "tier.plus_blurb": "For a gentle start into AI reflection.",
  "tier.pro_blurb": "More reports and starter plans.",
  "tier.unlimited_blurb": "Unlimited reflection, prioritised.",
  "tier.coach_pro_blurb": "Everything in Unlimited + coaching tools.",
  "feat.reports_unlimited": "Unlimited WEVA reports (fair use)",
  "feat.reports_count": "{n} WEVA reports / month",
  "feat.ad_free": "Ad-free",
  "feat.voice_journal": "Voice journal",
  "feat.starter_plans": "Starter plans",
  "feat.priority": "Prioritised processing",
  "feat.commission": "Only {pct}% platform commission",
  "feat.advanced_analytics": "Advanced coach analytics",
  "bill.title": "Billing & plans",
  "bill.sub_coach": "Credits, platform membership and the AI Practice Assistant — all in one place. Secure payment via Stripe.",
  "bill.sub_client": "Credits and platform membership — all in one place. Secure payment via Stripe.",
  "bill.credits": "Credits",
  "bill.credit_rate": "1 credit = €0.10 · incl. VAT",
  "bill.n_credits": "{n} credits",
  "bill.popular": "Popular",
  "bill.credits_word": "Credits",
  "bill.incl_vat_per": "incl. VAT · {per}/credit",
  "bill.buy": "Buy",
  "bill.credits_added": "Credits added!",
  "bill.purchase_failed": "Purchase failed.",
  "bill.payment_received": "Payment received — thank you!",
  "bill.cancelled": "Process cancelled.",
  "bill.sub_activated": "Membership activated — thank you!",
  "bill.membership": "Platform membership",
  "bill.membership_sub": "Choose the plan that fits your inner work. Cancel anytime.",
  "bill.current_plan": "Current plan: {name}",
  "bill.manage_hint": "Manage your subscription, change payment method or cancel — securely via the Stripe portal. Your access stays until the end of the period.",
  "bill.manage": "Manage subscription",
  "bill.monthly": "Monthly",
  "bill.yearly": "Yearly · save more",
  "bill.recommended": "Recommended",
  "bill.per_year": "year",
  "bill.per_month": "month",
  "bill.current": "Current plan",
  "bill.choose": "Choose",
  "bill.activated": "Membership activated!",
  "bill.finish_failed": "Couldn't complete.",
  "bill.stripe_note": "Secure payment via Stripe · incl. Austrian VAT.",
  "bill.stripe_note_vat": "Secure payment via Stripe · incl. Austrian VAT · prices include VAT.",
  "bill.manage_demo": "Subscription management is not available in demo mode.",
  "bill.no_active_sub": "No active subscription.",
  "bill.manage_failed": "Couldn't open subscription management.",
  "bill.ai_title": "AI Practice Assistant",
  "bill.ai_sub": "Your autonomous coaching assistant — daily briefing, tasks, chat & workflows.",
  "bill.ai_active": "Active",
  "bill.ai_runs_until": "Runs until {date}",
  "bill.ai_is_active": "Your assistant is active.",
  "bill.ai_open": "Open assistant",
  "bill.ai_upsell": "Automate routine tasks and get a clear daily briefing every morning.",
  "bill.ai_f_briefing": "Daily briefing",
  "bill.ai_f_tasks": "Task delegation",
  "bill.ai_f_chat": "AI chat",
  "bill.ai_f_workflows": "Autonomous workflows",
  "bill.ai_starting": "Starting…",
  "bill.ai_start_sub": "Start subscription",
  "bill.ai_trial": "Try 7 days free",
  "bill.ai_price": "€{price} / month",
  "bill.ai_checkout_failed": "Checkout failed.",
  "mem.title": "Membership",
  // === iter273 i18n · wave 3 (auth + public pages) ===
  "fp.meta": "Reset password",
  "fp.title": "Forgot your password?",
  "fp.subtitle": "We'll send you a reset link.",
  "fp.back": "Back to sign in",
  "fp.sent": "If this email is registered, you'll receive a reset link shortly.",
  "fp.email": "Email",
  "fp.email_ph": "you@example.com",
  "fp.submit": "Send link",
  "rp.meta": "New password",
  "rp.title": "New password",
  "rp.subtitle": "Choose a secure password for your account.",
  "rp.back": "To sign in",
  "rp.no_token": "This link is invalid. Please request a new reset link.",
  "rp.new_pw": "New password",
  "rp.pw_ph": "At least 8 characters",
  "rp.submit": "Save password",
  "rp.updated": "Password updated.",
  "rp.failed": "Reset failed.",
  "cpg.meta": "Coaches",
  "cpg.meta_desc": "Discover verified coaches on My Within — by topic, expertise and region.",
  "cpg.title": "Our coaches",
  "cpg.subtitle": "Verified companions for your inner work — find the person who fits you.",
  "cpg.search_ph": "Search by name, expertise or profession …",
  "cpg.empty_title": "No coaches found",
  "cpg.empty_desc": "Try a different search term.",
  "cpg.reset_search": "Reset search",
  "od.fallback_title": "Offering",
  "od.notfound_title": "Offering not found",
  "od.notfound_desc": "This offering is no longer available.",
  "od.to_marketplace": "To the marketplace",
  "od.marketplace": "Marketplace",
  "od.recommended": "Recommended",
  "od.minutes": "{n} minutes",
  "od.included": "What's included",
  "od.savings": "You save {amount} in the bundle.",
  "od.price": "Price",
  "od.cta": "View coach & availability",
  "od.create_account": "Create an account",
  "od.signup_rest": " to book and chat.",
  "od.more_from": "More offerings from {name}",
  "mkt.meta": "Marketplace",
  "mkt.meta_desc": "Discover coaching offerings, courses and packages from verified coaches on My Within.",
  "mkt.title": "Marketplace",
  "mkt.subtitle": "Offerings, courses and packages from verified coaches — find what fits your path.",
  "mkt.search_ph": "Search by topic, title or coach …",
  "mkt.art": "Type",
  "mkt.all_types": "All types",
  "mkt.region": "Region",
  "mkt.all_regions": "All regions",
  "mkt.theme": "Topic",
  "mkt.all_themes": "All topics",
  "mkt.filters_active": "{n} filters active",
  "mkt.reset": "Reset",
  "mkt.count_one": "{n} offering found",
  "mkt.count_other": "{n} offerings found",
  "mkt.empty_title": "No offerings found",
  "mkt.empty_desc": "Adjust your search or filters to see more offerings.",
  "mkt.reset_filters": "Reset filters",
  "mkt.loading": "Loading …",
  "mkt.load_more": "Show more",
  "cp.meta_fallback": "Coach",
  "cp.notfound_title": "Coach not found",
  "cp.notfound_desc": "This profile is not available.",
  "cp.all_coaches": "All coaches",
  "cp.since_year": "In the profession since {year}",
  "cp.about": "About {name}",
  "cp.posts": "Posts",
  "cp.more_exclusive": "{n} more exclusive posts — unlock as a member.",
  "cp.no_posts": "No public posts yet.",
  "cp.focus": "Focus areas",
  "cp.topics": "Topics",
  "cp.qualifications": "Qualifications",
  "cp.visit_website": "Visit website",
  "cir.health_active": "Active",
  "cir.health_quiet": "Quiet",
  "cir.health_still": "Still",
  "cir.kind_individual": "My Circle",
  "cir.load_error": "Circles could not be loaded.",
  "cir.created": "Circle created",
  "cir.joined": "Joined circle",
  "cir.join_failed": "Could not join",
  "cir.invite_sent": "Invitation sent",
  "cir.member_removed": "Member removed",
  "cir.remove_failed": "Could not remove",
  "cir.code_copied": "Code copied",
  "cir.link_copied": "Link copied",
  "cir.pin_updated": "Pin updated",
  "cir.eyebrow": "Community",
  "cir.title": "Circles",
  "cir.subtitle": "Guide your groups and stay connected with your clients.",
  "cir.new_circle": "New circle",
  "cir.new_circle_desc": "Choose the type and give your circle a name.",
  "cir.local_circle": "Local Circle",
  "cir.local_circle_desc": "Free group for your community.",
  "cir.mein_kreis": "My Circle",
  "cir.mein_kreis_desc": "Individual, guided circle.",
  "cir.name_ph": "Circle name",
  "cir.desc_ph": "Description (optional)",
  "cir.cancel": "Cancel",
  "cir.create": "Create",
  "cir.invite_code_ph": "Invitation code",
  "cir.join": "Join",
  "cir.empty": "No circles yet. Create one or join with a code.",
  "cir.health_stat": "· {total} members · {msgs} msgs/7d · {active} active",
  "cir.copy_invite_code": "Copy invitation code",
  "cir.select_circle": "Select a circle on the left.",
  "cir.invite_code_prefix": "Invitation code:",
  "cir.copy_code": "Copy code",
  "cir.members_count": "{n} members",
  "cir.share_link": "Share invitation link",
  "cir.member_health": "Member health",
  "cir.start_convo": "Start the conversation",
  "cir.start_convo_desc": "Write the first message to your circle.",
  "cir.pin": "Pin",
  "cir.msg_ph": "Write a message …",
  "cir.invite_email_ph": "Invite by email",
  "cir.invite": "Invite",
  "cir.manage_members": "Manage members",
  "cir.manage_members_desc": "View, invite and remove members of your circle.",
  "cir.no_members": "No members yet.",
  "cir.member_fallback": "Member",
  "cir.coach": "Coach",
  "cir.remove": "Remove",
  "cir.remove_member_q": "Remove member?",
  "cir.remove_member_desc": "{who} will be removed from the circle. This cannot be undone.",
  "cir.this_member": "This member",
  "mk.seo": "Coach · My Circle",
  "mk.eyebrow": "My Circle",
  "mk.title": "My Circle",
  "mk.subtitle": "Individual, guided circles with your own price, seats and welcome message.",
  "mk.new": "New",
  "mk.empty_title": "No circle of your own yet",
  "mk.empty_desc": "Create your first individual circle with price and seats.",
  "mk.create_circle": "Create circle",
  "mk.bl_one_time": "one-time",
  "mk.bl_monthly": "/mo",
  "mk.bl_yearly": "/yr",
  "mk.free": "free",
  "mk.seats": "{n} seats",
  "mk.unlimited_seats": "Unlimited seats",
  "mk.edit": "Edit",
  "mke.seo_edit": "Coach · Edit circle",
  "mke.seo_create": "Coach · Create circle",
  "mke.title_edit": "Edit circle",
  "mke.title_create": "Create circle",
  "mke.subtitle": "Add-on subscription — just as detailed as the Inner Circle, with/without time and seat limits.",
  "mke.b_one_time": "One-time",
  "mke.b_monthly": "Monthly",
  "mke.b_yearly": "Yearly",
  "mke.period_month": "per month",
  "mke.period_week": "per week",
  "mke.period_total": "total",
  "mke.unit_days": "Days",
  "mke.unit_weeks": "Weeks",
  "mke.unit_months": "Months",
  "mke.err_name": "Please enter a name (min. 2 characters).",
  "mke.saved": "Circle saved",
  "mke.basics": "Basics",
  "mke.name": "Name",
  "mke.description": "Description",
  "mke.desc_ph": "What is this circle about?",
  "mke.cover": "Cover image",
  "mke.cover_ph": "… or paste an image URL",
  "mke.price_billing": "Price & subscription",
  "mke.price_eur": "Price (€)",
  "mke.price_credits": "Price (credits)",
  "mke.price_hint": "Leave blank (€ or credits) to let the platform derive the missing price automatically. 0 = free.",
  "mke.access_section": "Participants & time limit",
  "mke.limit_seats": "Limit number of participants",
  "mke.limit_seats_hint": "Off = unlimited members.",
  "mke.max_seats": "Maximum participants",
  "mke.seats_ph": "e.g. 12",
  "mke.limit_time": "Time-limited access",
  "mke.limit_time_hint": "Off = permanent subscription with no time limit.",
  "mke.duration": "Duration",
  "mke.duration_ph": "e.g. 3",
  "mke.perks_title": "Included perks",
  "mke.perks_hint": "Bundle offerings of all kinds — just as detailed as the Inner Circle.",
  "mke.visibility": "Visibility",
  "mke.vis_public": "Publicly visible",
  "mke.vis_public_hint": "Appears on your coach profile.",
  "mke.vis_invite": "Invite only",
  "mke.vis_invite_hint": "Join only with an invitation code/link.",
  "mke.published": "Published",
  "mke.published_hint": "Off = saved but hidden from clients.",
  "mke.welcome_links": "Welcome & links",
  "mke.welcome": "Welcome message",
  "mke.welcome_ph": "Welcome new members …",
  "mke.zoom": "Zoom link",
  "mke.onboarding_video": "Onboarding video",
  "mke.video_ph": "… or paste a video URL",
  "mke.sessions": "Included sessions",
  "mke.add": "Add",
  "mke.no_sessions": "No sessions added yet.",
  "mke.session_title_ph": "Session title",
  "mke.save": "Save",
  "mke.create": "Create",
  "ctl.deliverables": "Deliverables",
  "ctl.todos": "To-dos",
  "ctl.clients": "Clients",
  "ctl.chats": "Chats",
  "ctl.weva": "WEVA group analysis",
  "ctl.members": "Member health",
  "ctl.load_error": "Could not be loaded.",
  "ctl.deliverables_saved": "Deliverables saved",
  "ctl.weva_too_few": "Not enough data for a group analysis (min. 3 active members).",
  "ctl.analysis_created": "Analysis created",
  "ctl.analysis_pro": "Analysis not possible (Coach Pro only).",
  "ctl.seo": "Coach · {title}",
  "ctl.back": "Dashboard",
  "ctl.inner_readonly": "Inner Circle deliverables are managed in the Inner Circle plan (read-only here).",
  "ctl.no_deliverables": "No deliverables available.",
  "ctl.save": "Save",
  "ctl.todo_behind": "Behind schedule",
  "ctl.todo_behind_empty": "All on track.",
  "ctl.todo_dms": "Open DMs",
  "ctl.todo_dms_empty": "No open DMs.",
  "ctl.msg": "Message",
  "ctl.todo_snapshots": "New snapshots",
  "ctl.todo_snapshots_empty": "No new snapshots.",
  "ctl.snapshot": "Snapshot",
  "ctl.no_clients": "No clients in this area yet.",
  "ctl.client": "Client",
  "ctl.dm_limit": "DM limit active: {n}/month.",
  "ctl.no_chats": "No chats.",
  "ctl.no_members": "No members in this area yet.",
  "ctl.entries_30d": "{n} entries (30d)",
  "ctl.last_emotion": " · last: {emotion}",
  "ctl.start_analysis": "Start analysis",
  "ctl.privacy_min": "For privacy, group insights are only shown from 3 active members with data.",
  "ctl.themes": "Themes",
  "ctl.emotions": "Emotions",
  "ctl.beliefs": "Beliefs",
  "ctl.latest_analysis": "Latest analysis",
  "ctl.history": "History",
  "ctl.analysis": "Analysis",
  "ctl.privacy_note": "WEVA insights are aggregated and anonymized. Individual entries are never shared in plain text.",
  "ctl.no_data": "No data.",
  "cdb.weva": "WEVA analysis",
  "cdb.load_error": "Overview could not be loaded.",
  "cdb.seo": "Coach · {title}",
  "cdb.subtitle": "Overview of activity, earnings and deliverables.",
  "cdb.all_circles": "All circles",
  "cdb.active_members": "Active members",
  "cdb.earnings_month": "Earnings (month)",
  "cdb.snapshots_confirmed": "Confirmed snapshots",
  "cdb.entries_received": "Entries received",
  "cdb.bookings": "Bookings",
  "cdb.active_offerings": "Active offerings",
  "cdb.included_deliverables": "Included deliverables",
  "cdb.no_deliverables_defined": "No deliverables defined yet.",
  "cdb.per_month": "{n}× / month",
  "cdb.earnings_this_month": "Earnings this month",
  "cdb.bookings_received": "Bookings received",
  "cdb.areas": "Areas",
  "perk.weva_snapshot_analysis": "WEVA snapshot analyses",
  "perk.user_entries_analysis": "Entry analyses",
  "perk.weekly_plan": "Weekly plan from the coach",
  "perk.dm_monthly": "Direct messages per month",
  "perk.paid_content": "Access to all paid content",
  "perk.group_chat": "Private group chat with other members",
  "perk.video_call": "1:1 video call minutes per month",
  "perk.belief_text_beliefs": "Belief work via text · beliefs per month",
  "perk.belief_text_dms": "Belief work via text · DMs per month",
  "perk.belief_phone": "Belief work via phone · minutes per month",
  "perk.belief_video": "Belief work via video call · minutes per month",
  "perk.emergency_support": "Emotional emergency support",
  "perk.unit_month": "/month",
  "perk.unit_dms_month": "DMs/month",
  "perk.unit_min_month": "min/month",
  "perk.recommended": "· recommended",
  "perk.custom_hint": "Add your own perks / offerings (e.g. “5 voice messages / month”).",
  "perk.min_short": "min",
  "perk.offer_name_ph": "Offering name",
  "perk.count_ph": "Count",
  "perk.add": "Add",
  "cext.err_title": "Title required (min. 2 characters).",
  "cext.published": "Announcement published",
  "cext.pinned": "Pinned",
  "cext.unpin": "Unpin",
  "cext.announcements": "Announcements",
  "cext.new": "New",
  "cext.post_title": "Post announcement",
  "cext.post_desc": "Share news with your circle.",
  "cext.title": "Title",
  "cext.text": "Text",
  "cext.body_ph": "Your message …",
  "cext.require_confirm": "Require read confirmation",
  "cext.schedule": "Schedule (optional)",
  "cext.attachment": "Attachment (optional)",
  "cext.post": "Post",
  "cext.empty": "No announcements yet.",
  "cext.scheduled": "scheduled",
  "cext.confirmed": "Confirmed",
  "cext.read": "Read",
  "earn.p_month": "Month",
  "earn.p_quarter": "Quarter",
  "earn.p_year": "Year",
  "earn.p_all": "All time",
  "earn.src_inner": "Inner Circle",
  "earn.src_local": "Local Circle",
  "earn.src_sessions": "Sessions",
  "earn.src_affiliate": "Affiliate",
  "earn.src_paid": "Paid content",
  "earn.src_other": "Other",
  "earn.paid_status": "Paid out",
  "earn.pending_status": "Pending",
  "earn.failed_status": "Failed",
  "earn.seo": "Coach · Earnings",
  "earn.back": "Coach dashboard",
  "earn.eyebrow": "Earnings",
  "earn.title": "Earnings & payouts",
  "earn.subtitle": "Revenue by source, payouts and Stripe status.",
  "earn.stripe_err": "Stripe onboarding could not be started.",
  "earn.gross": "Gross revenue",
  "earn.paid_out": "Paid out",
  "earn.pending": "Pending",
  "earn.next_payout": "Next payout",
  "earn.by_source": "Revenue by source",
  "earn.no_revenue": "No revenue in this period.",
  "earn.stripe_payouts": "Stripe payouts",
  "earn.active": "Active",
  "earn.setup_needed": "Setup needed",
  "earn.opening_stripe": "Opening Stripe…",
  "earn.continue_onboarding": "Continue onboarding",
  "earn.connect_stripe": "Connect Stripe",
  "earn.payouts": "Payouts",
  "earn.no_payouts": "No payouts yet.",
  "earn.paid_on": "Paid out {date}",
  "earn.created_on": "Created {date}",
  "earn.step_connect": "Connect Stripe account",
  "earn.step_identity": "Verify identity",
  "earn.step_bank": "Add bank account for payouts",
  "earn.step_documents": "Upload requested documents (if needed)",
  "cpul.seg_all": "All",
  "cpul.seg_rising": "Rising",
  "cpul.seg_stable": "Stable",
  "cpul.seg_dropping": "At risk",
  "cpul.seg_no_data": "No data",
  "cpul.load_err": "Pulse could not be loaded.",
  "cpul.seo": "Coach · Client pulse",
  "cpul.eyebrow": "Client pulse",
  "cpul.title": "Client pulse",
  "cpul.subtitle": "Keep an eye on your clients' engagement.",
  "cpul.refresh": "Refresh",
  "cpul.alert_one": "{n} client with declining engagement.",
  "cpul.alert_other": "{n} clients with declining engagement.",
  "cpul.all_good_title": "All in the green",
  "cpul.all_good_desc": "All clients stable or rising.",
  "cpul.h7": "7d:",
  "cpul.h30": "30d:",
  "cpul.sessions": "Sessions:",
  "mh.bucket_healthy": "Active",
  "mh.bucket_silent": "Quiet",
  "mh.bucket_inactive": "Inactive",
  "mh.bucket_churned": "Churned",
  "mh.load_err": "Member health could not be loaded.",
  "mh.nudge_sent": "Nudge sent",
  "mh.bulk_nudged": "{n} members nudged",
  "mh.seo": "Coach · Member health",
  "mh.eyebrow": "Members",
  "mh.title": "Member health",
  "mh.subtitle": "Your members' activity and targeted nudges.",
  "mh.all_silent": "All quiet ones ({n})",
  "mh.empty_title": "No members yet",
  "mh.empty_desc": "As soon as members join, you'll see their activity here.",
  "mh.not_active": "Not active yet",
  "mh.last_active": "Last active {n} day(s) ago",
  "mh.expiring": " · subscription expiring soon",
  "mh.nudge": "Nudge",
  "mh.nudge_title": "Nudge {name}",
  "mh.nudge_desc": "A warm message + notification.",
  "mh.nudge_ph": "Optional message …",
  "mh.send": "Send",
  "mh.bulk_title": "Nudge all quiet members",
  "mh.bulk_desc": "Only members who were recently inactive (max. 1× per 24h).",
  "av.wd_mon": "Monday",
  "av.wd_tue": "Tuesday",
  "av.wd_wed": "Wednesday",
  "av.wd_thu": "Thursday",
  "av.wd_fri": "Friday",
  "av.wd_sat": "Saturday",
  "av.wd_sun": "Sunday",
  "av.wds_mon": "Mon",
  "av.wds_tue": "Tue",
  "av.wds_wed": "Wed",
  "av.wds_thu": "Thu",
  "av.wds_fri": "Fri",
  "av.wds_sat": "Sat",
  "av.wds_sun": "Sun",
  "av.load_err": "Availability could not be loaded.",
  "av.outlook_connected": "Outlook calendar connected.",
  "av.outlook_failed": "Outlook connection failed.",
  "av.outlook_not_setup": "Outlook is not set up yet.",
  "av.outlook_disconnected": "Outlook disconnected.",
  "av.saved": "Availability saved.",
  "av.save_failed": "Saving failed.",
  "av.day_updated": "{day} updated.",
  "av.day_reset": "{day} reset.",
  "av.day_save_failed": "Day could not be saved.",
  "av.seo": "Coach · Availability",
  "av.eyebrow": "Availability",
  "av.title": "Availability & calendar",
  "av.subtitle": "Open weekly slots or adjust individual days across the coming weeks.",
  "av.outlook_cal": "Outlook calendar",
  "av.outlook_soon": "Being set up by the team — available soon.",
  "av.connected": "Connected",
  "av.reconnect_needed": " · reconnect needed",
  "av.outlook_hint": "Connect your Outlook calendar for free/busy sync.",
  "av.disconnect": "Disconnect",
  "av.reconnect": "Reconnect",
  "av.outlook_connect": "Connect Outlook",
  "av.mode_uniform": "Uniform",
  "av.mode_individual": "Individual",
  "av.timezone": "Timezone",
  "av.uniform_hint": "The weekly template applies to all {weeks} weeks — individual days overridable below.",
  "av.individual_hint": "Each day is edited individually.",
  "av.week_template": "Weekly template",
  "av.saving": "Saving…",
  "av.save_template": "Save template",
  "av.next_weeks": "Next {weeks} weeks",
  "av.tap_hint": "· tap a day to adjust",
  "av.view": "View",
  "av.month": "Month",
  "av.weeks_short": "{w} wk",
  "av.custom": "Custom",
  "av.adjust_day": "Adjust {day}",
  "av.available": "Available",
  "av.reset": "Reset",
  "av.save": "Save",
  "av.slot": "Slot",
  "ic.seo": "Coach · Inner Circle",
  "ic.subtitle": "Your exclusive monthly subscription — bundle offerings of all kinds into a steady companionship.",
  "ic.tab_settings": "Settings",
  "ic.tab_overview": "Overview",
  "ic.tab_clients": "Clients",
  "ic.tab_weva": "WEVA",
  "ic.tab_invites": "Invitations",
  "ic.err_price": "Please set a price in € or credits.",
  "ic.err_min_eur": "Minimum price is €4.99 / month.",
  "ic.err_min_credits": "Minimum price is 50 credits / month.",
  "ic.saved_published": "Inner Circle saved & published.",
  "ic.saved_hidden": "Inner Circle saved (hidden).",
  "ic.setup_intro": "Set a monthly price and choose what your members get each month.",
  "ic.enable_card": "Enable card payments",
  "ic.enable_card_desc": "Complete both steps so clients can subscribe by card.",
  "ic.step1": "1 · Connect Stripe payouts",
  "ic.stripe_not_started": "Not started yet — Stripe verifies identity & bank details for your payouts.",
  "ic.stripe_submitted": "Submitted — Stripe is still reviewing (usually <24h).",
  "ic.stripe_connected": "Connected — you can receive payouts.",
  "ic.stripe_incomplete": "Started but incomplete — finish the KYC form.",
  "ic.stripe_start": "Start Stripe onboarding",
  "ic.step2": "2 · Set € price",
  "ic.price_set": "{price}/month set. Save to activate.",
  "ic.price_enter": "Enter a monthly price below (min. €4.99/month).",
  "ic.card_active": "Card payments active",
  "ic.card_active_desc": "Clients can subscribe by card (Stripe) or credits. {price}/month · {share}% goes to you.",
  "ic.price_eur": "Monthly price (€)",
  "ic.only_credits_hint": "Leave blank if you only want to accept credits.",
  "ic.price_credits": "Monthly price (credits)",
  "ic.price_credits_ph": "e.g. 50",
  "ic.credits_month": "credits/month",
  "ic.credits_auto_hint": "Leave blank to let the platform derive the credit price automatically.",
  "ic.revenue_split": "Platform keeps {platform}% · You get {coach}%",
  "ic.coach_pro_hint": " · upgrading to Coach Pro lowers it to 15%",
  "ic.description_label": "Description — what subscribers get",
  "ic.description_ph": "A monthly commitment to your inner work …",
  "ic.whats_included": "What's included",
  "ic.core_hint": "The first four are core perks (WEVA coaching) and are recommended.",
  "ic.visibility": "Visibility",
  "ic.visibility_hint": "Does your Inner Circle appear publicly on your profile or only by invitation?",
  "ic.vis_public": "Publicly visible",
  "ic.vis_public_hint": "Appears on your coach profile, anyone can subscribe.",
  "ic.vis_invite": "Invite only",
  "ic.vis_invite_hint": "Only invited clients can join.",
  "ic.waitlist": "{n} are waiting for your Inner Circle",
  "ic.waitlist_hint": "They'll be notified as soon as you turn on “Published”.",
  "ic.dm_limit": "Hard DM limit",
  "ic.dm_limit_hint": "On = members cannot exceed the monthly DM quota.",
  "ic.save": "Save Inner Circle",
  "ic.no_members": "No Inner Circle members yet",
  "ic.no_members_hint": "As soon as someone subscribes, they appear here.",
  "ic.planned": "{n} upcoming",
  "ic.past": "{n} past",
  "ic.weva_err": "WEVA report could not be loaded.",
  "ic.snapshot7": "Snapshot (7d)",
  "ic.days30": "30 days",
  "ic.history90": "History (90d)",
  "ic.members_one": "{n} member",
  "ic.members_other": "{n} members",
  "ic.period": "Period: last {n} days",
  "ic.top_beliefs": "Most common beliefs",
  "ic.upper_limits": "Upper-limit hotspots",
  "ic.not_enough": "Not enough activity in this period for a report.",
  "ic.min": "min",
  "ic.days": "days",
  "ic.err_email": "Please enter at least one valid email.",
  "ic.invites_created": "{n} invitation(s) created.",
  "ic.invites_err": "Invitations could not be sent.",
  "ic.invite_revoked": "Invitation revoked",
  "ic.emails_label": "Email addresses",
  "ic.emails_hint": "Separate multiple addresses with comma, semicolon or line break.",
  "ic.note_label": "Personal note (optional)",
  "ic.note_ph": "Welcome to the Inner Circle …",
  "ic.sending": "Sending…",
  "ic.kpi_sent": "Sent",
  "ic.kpi_accept_rate": "Accept rate",
  "ic.kpi_accepted": "Accepted",
  "ic.kpi_pending": "Pending",
  "ic.kpi_revoked": "Revoked",
  "ic.kpi_avg_time": "Avg join time",
  "ic.kpi_active": "Active members",
  "ic.kpi_retention": "30d retention",
  "ic.sec_pending": "Pending",
  "ic.sec_pending_empty": "No pending invitations yet.",
  "ic.sec_accepted": "Accepted",
  "ic.sec_accepted_empty": "No acceptances yet.",
  "ic.sec_revoked": "Revoked",
  "ic.back": "Circles",
  "ic.tile_deliverables": "Deliverables",
  "ic.tile_todos": "To-dos",
  "ic.tile_clients": "Clients",
  "ic.tile_chats": "Chats",
  "ic.tile_weva": "WEVA analysis",
  "ic.tile_members": "Member health",
  "ic.save_err": "Saving failed.",
  "ic.stripe_onboard_err": "Stripe onboarding could not be started.",
  "ic.opening_stripe": "Opening Stripe…",
  "ic.continue_onboarding": "Continue onboarding",
  "ic.ov_active_members": "Active members",
  "ic.ov_earnings": "Earnings (month)",
  "ic.ov_snapshots": "Confirmed snapshots",
  "ic.ov_entries": "Entries received",
  "ic.ov_bookings": "Bookings",
  "ic.ov_offerings": "Active offerings",
  "ic.deliverables_title": "Included deliverables",
  "ic.no_deliverables": "No deliverables defined yet.",
  "ic.per_month": "{n}× / month",
  "ic.areas": "Areas",
  "ic.published": "Published",
  "ic.published_hint": "Off = saved but hidden from clients.",
  "ic.saving": "Saving…",
  "ic.invite": "Invite",
  "ic.month_suffix": "/month",
  "ic.overview_err": "Overview could not be loaded.",

  // Coach · Collaboration (Collab.jsx)
  "col.seo": "Coach · Collaboration",
  "col.back": "Coach dashboard",
  "col.eyebrow": "Collaboration",
  "col.title": "Collaboration",
  "col.subtitle": "Connect with other coaches, chat together and build shared offerings.",
  "col.open_title": "Open for collaboration",
  "col.open_desc": "Other coaches can see you in the collab network and send you requests.",
  "col.stat_connected": "Connected coaches",
  "col.stat_in": "Incoming requests",
  "col.stat_out": "Outgoing requests",
  "col.stat_offerings": "Shared offerings",
  "col.tab_connected": "Connected",
  "col.tab_requests": "Requests",
  "col.tab_find": "Find",
  "col.tab_offerings": "Shared offerings",
  "col.tab_circles": "Shared circles",
  "col.tab_chats": "Chats",
  "col.st_draft": "Draft",
  "col.st_pending": "Awaiting acceptance",
  "col.st_published": "Published",
  "col.st_archived": "Archived",
  "col.kind_one_on_one": "1:1 session",
  "col.kind_training": "Training",
  "col.kind_product": "Product",
  "col.bill_one_time": "One-time",
  "col.bill_monthly": "Monthly",
  "col.bill_yearly": "Yearly",
  "col.no_shared_clients_title": "No shared clients",
  "col.no_shared_clients_desc": "Both coaches need the same client with collab consent.",
  "col.conn_empty_title": "No connections yet",
  "col.conn_empty_text": "Find coaches in the “Find” tab and send a request.",
  "col.circles_n": "{n} circles",
  "col.offers_n": "{n} offerings",
  "col.message": "Message",
  "col.shared_chat": "Shared chat",
  "col.pick_client_title": "Which client to connect?",
  "col.pick_client_desc": "Only clients who granted both coaches collab consent.",
  "col.search_client_ph": "Search client…",
  "col.req_accepted": "Request accepted.",
  "col.req_declined": "Request declined.",
  "col.req_empty_title": "No open requests",
  "col.req_empty_text": "Incoming and sent requests appear here.",
  "col.incoming_n": "Incoming ({n})",
  "col.no_incoming": "No incoming requests.",
  "col.outgoing_n": "Sent ({n})",
  "col.no_outgoing": "No sent requests.",
  "col.accept": "Accept",
  "col.decline": "Decline",
  "col.pending": "Pending",
  "col.request_sent": "Request sent to {name}.",
  "col.request_failed": "Request failed.",
  "col.search_coach_ph": "Search coach by name or expertise…",
  "col.no_coaches_title": "No coaches found",
  "col.no_coaches_text": "Try a different search term.",
  "col.request": "Request",
  "col.request_to": "Request to {name}",
  "col.topic_label": "Topic (optional)",
  "col.topic_ph": "e.g. Joint retreat",
  "col.message_label": "Message (optional)",
  "col.message_ph": "Introduce yourself briefly and describe your idea…",
  "col.sending": "Sending…",
  "col.send_request": "Send request",
  "col.off_accepted": "Offering accepted.",
  "col.off_declined": "Offering declined.",
  "col.off_published": "Offering published.",
  "col.off_archived": "Offering archived.",
  "col.new_offering": "New shared offering",
  "col.off_empty_title": "No shared offerings yet",
  "col.off_empty_text": "Create a package with connected coaches — revenue is split automatically.",
  "col.confirmed_of": "{confirmed}/{total} confirmed",
  "col.bookings_suffix": " · {n} bookings",
  "col.needs_confirm": "Your acceptance is missing",
  "col.fully_booked": "Fully booked",
  "col.publish": "Publish",
  "col.archive": "Archive",
  "col.block_title_ph": "Block title",
  "col.pick_product_ph": "Pick product/method/plan…",
  "col.duration_min": "Duration (min)",
  "col.price_eur": "Price (EUR)",
  "col.days": "Days",
  "col.day": "Day",
  "col.max_participants": "Max. participants (0 = unlimited)",
  "col.executing_coaches": "Executing coaches",
  "col.split_pct": "Split (%)",
  "col.split_executing": "Executing",
  "col.split_all": "All",
  "col.err_title_min": "Title (min. 3 characters).",
  "col.err_pick_coach": "Select at least one coach.",
  "col.err_add_block": "Add at least one block.",
  "col.err_block_title": "Block {n}: title missing.",
  "col.err_block_split": "Block {n}: split must total 100% (currently {sum}%).",
  "col.err_block_day": "Block {n}: at least one day with date/time.",
  "col.err_block_product": "Block {n}: pick a product.",
  "col.err_total_zero": "Total price must be greater than 0.",
  "col.err_override_high": "Package price cannot be higher than the sum.",
  "col.offering_created": "Shared offering created.",
  "col.create_failed": "Could not be created.",
  "col.you": "You",
  "col.coach_fallback": "Coach",
  "col.dialog_new_offering_desc": "A package of blocks (training, 1:1, product). Revenue per block is booked by your split.",
  "col.f_title": "Title",
  "col.offering_title_ph": "e.g. Breath & Body retreat package",
  "col.f_description": "Description",
  "col.coaches_connected": "Coaches (connected)",
  "col.no_connected_coaches": "No connected coaches yet. Connect first in the “Find” tab.",
  "col.blocks": "Blocks",
  "col.add_block_hint": "Add at least one block.",
  "col.sum_blocks": "Sum of blocks",
  "col.override_price": "Override package price (discount)",
  "col.package_price_ph": "Package price (EUR)",
  "col.create": "Create",
  "col.offering_fallback": "Shared offering",
  "col.coaches": "Coaches",
  "col.circ_confirmed": "Circle confirmed.",
  "col.new_circle": "New shared circle",
  "col.circ_empty_title": "No shared circles yet",
  "col.circ_empty_text": "Found a co-coaching circle with connected coaches — revenue is shared.",
  "col.circ_pending": "Awaiting acceptances",
  "col.confirm": "Confirm",
  "col.err_name_min": "Name (min. 3 characters).",
  "col.err_split_100": "Split must total 100% (currently {sum}%).",
  "col.circle_created": "Shared circle created.",
  "col.dialog_new_circle_desc": "A co-coaching circle with shared membership. All coaches must accept before it goes live.",
  "col.f_name": "Name",
  "col.circle_name_ph": "e.g. Breath & Mind Collective",
  "col.billing": "Billing",
  "col.seats": "Seats (optional)",
  "col.co_coaches_connected": "Co-coaches (connected)",
  "col.rev_split": "Revenue split (%)",
  "col.sum_100": "Sum must total 100%.",
  "col.filter_all": "All",
  "col.filter_coaches": "Coaches",
  "col.filter_with_client": "With client",
  "col.chat_offer": "Chat offer",
  "col.chats_empty_title": "No chats yet",
  "col.chats_empty_text": "Start a chat from the “Connected” tab.",
  "col.chat_fallback": "Chat",
  "col.badge_coach": "Coach",
  "col.badge_client": "Client",
  "col.chatoffer_saved": "Chat offer saved.",
  "col.chatoffer_title": "Paid chat offer",
  "col.chatoffer_desc": "Offer clients paid chat access to you.",
  "col.chatoffer_active": "Chat offer active",
  "col.unlimited_msgs": "Unlimited messages",
  "col.included_msgs": "Included messages",
  "col.phone_included": "Phone call included",
  "col.phone_minutes": "Phone minutes",
  "col.extras": "Extras (comma-separated)",
  "col.extras_ph": "e.g. Voice memos, PDF summary",
  "col.save": "Save",
  "col.no_messages": "No messages yet. Write the first one 👋",
  "col.msg_deleted": "Message deleted",
  "col.msg_input_ph": "Write a message…",

  // UX Rework 3.0
  "rw3.dw_areas": "Areas",
  "rw3.dw_quick": "Quick access",
  "rw3.mem_on_free": "You're currently on the free plan.",
  "rw3.mem_free_access": "Included: Breathe, Journal & Deep Within, plus limited WEVA reports.",
  "rw3.mem_credits_title": "Credits & billing",
  "rw3.mem_credits_note": "Individual sessions and reports are paid with credits — separate from your membership.",
  "rw3.mem_credits_cta": "Go to billing",
  "rw3.mem_lifetime": "You have lifetime access — no subscription needed.",
  "rw3.mem_coach_note": "Coach plans include all personal benefits plus practice tools.",
  "rw3.pl_confirm_multi": "Send plan “{name}” to {n} clients?",
  "rw3.pl_confirm_circle": "Send plan “{name}” to all members of this circle?",
  "rw3.off_online": "Online",
  "rw3.off_inperson": "In person",
  "rw3.ic_this_month": "This month",
  "rw3.ic_recurring_est": "est. recurring / month",
  "ch.earn_title": "Earnings (month)",
  "ch.earn_view": "Details",
  "ch.earn_gross": "Gross",
  "ch.earn_pending": "Pending",
  "ch.earn_paid": "Paid out",
  "ch.earn_next": "Next payout",
  "ch.earn_period_note": "Current month · see Earnings for periods & detail.",
  "ch.earn_vs_prev": "vs. last month",
  "dw.progress_label": "{done} of {total} transformed",
};

export default en;
